import * as stylex2 from '@stylexjs/stylex';
import './tokens.stylex.js';
import { typography, colors, metrics, motion, space, radii, shadows, sizes, tooltipMarker, contentWidths } from './tokens.stylex.js';
export { breakpoints, colors, containerBreakpoints, contentWidths, metrics, motion, radii, shadows, sizes, space, typography } from './tokens.stylex.js';
import * as Keyboard5 from '@foldworks/keyboard';
import { Button, Checkbox, Disclosure, Input, Textarea, Select, Fieldset, Switch } from '@foldkit/ui';
import { Minus, Check, ChevronDown, Plus, TriangleAlert, X, ChevronsUpDown, Copy, ChevronRight, FileText, ArrowDown, ArrowUp } from '@lucide/icons';
import { Schema, Effect, Stream, Option, Queue } from 'effect';
import { Command, Dom, Mount, Calendar as Calendar$1 } from 'foldkit';
import { defineMessageUnion } from 'foldkit/message';
import * as Anchor from '@foldkit/ui/anchor';
import * as Animation2 from '@foldkit/ui/animation';
import { init as init$1, defaultLeaveCommand, WaitForPaint, WaitForAnimationSettled, TransitionState, OutMessage as OutMessage$1, Model as Model$1, Message as Message$1 } from '@foldkit/ui/animation';
import * as Calendar2 from '@foldkit/ui/calendar';
import * as Combobox3 from '@foldkit/ui/combobox';
import * as DatePicker from '@foldkit/ui/datePicker';
import * as Dialog2 from '@foldkit/ui/dialog';
import * as Disclosure2 from '@foldkit/ui/disclosure';
import * as HoverIntent from '@foldkit/ui/hoverIntent';
import * as Menu from '@foldkit/ui/menu';
import * as Popover2 from '@foldkit/ui/popover';
import * as RadioGroup2 from '@foldkit/ui/radioGroup';
import * as Select2 from '@foldkit/ui/select';
import * as Listbox from '@foldkit/ui/listbox';
import * as Slider2 from '@foldkit/ui/slider';
import * as Tabs2 from '@foldkit/ui/tabs';
import * as Toast from '@foldkit/ui/toast';
import { WaitBeforeDismissal, Variant, Position } from '@foldkit/ui/toast';
import * as Tooltip2 from '@foldkit/ui/tooltip';
import { defineView } from 'foldkit/submodel';
import * as Dom5 from 'foldkit/dom';
import { childAttributes } from 'foldkit/html';
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key2 of __getOwnPropNames(from)) if (!__hasOwnProp.call(to, key2) && key2 !== except) __defProp(to, key2, {
      get: () => from[key2],
      enumerable: !(desc = __getOwnPropDesc(from, key2)) || desc.enumerable
    });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget);

// src/badge.ts
var badge_exports = {};
__export(badge_exports, {
  view: () => view
});
var sxAttrs = (h, ...styles9) => {
  const {
    className,
    style
  } = stylex2.props(...styles9);
  const attributes = [];
  if (className !== void 0 && className !== "") attributes.push(h.Class(className));
  if (style !== void 0 && Object.keys(style).length > 0) {
    attributes.push(h.Style(style));
  }
  return attributes;
};

// src/catalog.shared.ts
var slotAttrs = (slot, h, ...styles9) => [...(slot?.attributes ?? []), ...sxAttrs(h, ...styles9, slot?.sx)];
var styledAttrs = (config, h, ...styles9) => [...(config.attributes ?? []), ...sxAttrs(h, ...styles9, config.sx)];
var rootAttrs = (config, h, ...styles9) => {
  const root = config.slotProps?.root;
  return [...(config.attributes ?? []), ...(root?.attributes ?? []), ...sxAttrs(h, ...styles9, config.sx, root?.sx)];
};
var clamp = (value, min, max) => Math.min(max, Math.max(min, value));
var buttonStyles = {
  base: {
    kGNEyG: "x6s0dn4",
    kVAM5u: "x9r1u3d",
    kaIpWk: "x15ohvts",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kkrTdU: "x1ypdohk",
    k1xSpc: "x3nfvp2",
    kmuXW: "x2lah0s",
    kMv6JI: "xajfy2p",
    kGuDYH: "x1kio5tc",
    k63SB2: "x1b3j4lt",
    kOIVth: "x17d4w8g",
    kjj79g: "xl56j7k",
    kI3sdo: "x1a2a7pz x6454uj",
    kInvED: "x1wfwxd8",
    kIyJzY: "xfonkto",
    k1ekBW: "x98sya7",
    kAMwcw: "x1mo6wk5",
    k3aq6I: "xvvkyix xsemcyu",
    k6sLGO: "x1so62im",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  primary: {
    kWkggS: "x34jowk xzvdco6",
    kVAM5u: "x1swbpd4 x1czufhf",
    kMwMTN: "x9pa81l",
    $$css: true
  },
  secondary: {
    kWkggS: "x16z3jmj xdnxrc",
    kMwMTN: "x1hmp2g xcrbgvn",
    $$css: true
  },
  outline: {
    kGVxlE: "x8bpx8f",
    kWkggS: "x3m9280 x7pwlv5",
    kVAM5u: "x1ubh2qd",
    kMwMTN: "x1ys4cjs",
    $$css: true
  },
  ghost: {
    kWkggS: "xjbqb8w x7pwlv5",
    kVAM5u: "x9r1u3d",
    kMwMTN: "xyu5t3h",
    $$css: true
  },
  danger: {
    kWkggS: "xve6jz8 xa4ej27",
    kVAM5u: "x9r1u3d",
    kMwMTN: "x1g3r7qa",
    $$css: true
  },
  link: {
    kWkggS: "xjbqb8w",
    kVAM5u: "x9r1u3d",
    kMwMTN: "x1ysz8r6",
    kMnn75: "xkrqix3 x1sur9pj",
    kcSHmL: "xda060z",
    $$css: true
  },
  xs: {
    kaIpWk: "xt8i71g",
    kGuDYH: "xwdf1oc",
    kZKoxP: "xxk0z11",
    kE3dHu: "x163pfp",
    kpe85a: "xy13l1i",
    $$css: true
  },
  sm: {
    kGuDYH: "xwdf1oc",
    kZKoxP: "x1fgtraw",
    kE3dHu: "x1lqa7cf",
    kpe85a: "xcicffo",
    $$css: true
  },
  md: {
    kZKoxP: "x10w6t97",
    kE3dHu: "x1lqa7cf",
    kpe85a: "xcicffo",
    $$css: true
  },
  lg: {
    kGuDYH: "x16ws5mb",
    kZKoxP: "xc9qbxq",
    kE3dHu: "xf18ygs",
    kpe85a: "xnuq7ks",
    $$css: true
  },
  icon: {
    kZKoxP: "x10w6t97",
    kmVPX3: "x1717udv",
    kzqmXN: "x1td3qas",
    $$css: true
  },
  iconXs: {
    kaIpWk: "xt8i71g",
    kZKoxP: "xxk0z11",
    kE3dHu: "x1uhho1l",
    kpe85a: "x1xpa7k",
    kzqmXN: "xvy4d1p",
    $$css: true
  },
  iconSm: {
    kZKoxP: "x1fgtraw",
    kE3dHu: "x1uhho1l",
    kpe85a: "x1xpa7k",
    kzqmXN: "xgd8bvy",
    $$css: true
  },
  iconMd: {
    kZKoxP: "x10w6t97",
    kE3dHu: "x1uhho1l",
    kpe85a: "x1xpa7k",
    kzqmXN: "x1td3qas",
    $$css: true
  },
  iconLg: {
    kZKoxP: "xc9qbxq",
    kE3dHu: "x1uhho1l",
    kpe85a: "x1xpa7k",
    kzqmXN: "x14qfxbe",
    $$css: true
  },
  linkShape: {
    kZKoxP: "xt7dq6l",
    kE3dHu: "x1uhho1l",
    kpe85a: "x1xpa7k",
    k3aq6I: "x1c071of",
    $$css: true
  },
  fullWidth: {
    kzqmXN: "xh8yej3",
    $$css: true
  },
  disabled: {
    kkrTdU: "x1h6gzvc",
    kSiTet: "xbyyjgo",
    kfzvcC: "x47corl",
    k3aq6I: "x1c071of",
    $$css: true
  }
};
var badgeStyles = {
  base: {
    kGNEyG: "x6s0dn4",
    kaIpWk: "xont9ci",
    k1xSpc: "x3nfvp2",
    kGuDYH: "xfifm61",
    kVAM5u: "x1uedw2l",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    k63SB2: "x1b3j4lt",
    kOIVth: "x1jnr06f",
    kZKoxP: "x1qx5ct2",
    kLWn49: "xo5v014",
    kmVPX3: "xmfpazt",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  neutral: {
    kWkggS: "x16z3jmj",
    kMwMTN: "xyu5t3h",
    $$css: true
  },
  muted: {
    kWkggS: "xjbqb8w",
    kVAM5u: "x1ubh2qd",
    kMwMTN: "xyu5t3h",
    $$css: true
  },
  accent: {
    kWkggS: "x6x6jrj",
    kMwMTN: "x1ysz8r6",
    $$css: true
  },
  success: {
    kWkggS: "x1x4pbqu",
    kMwMTN: "x15kbz4b",
    $$css: true
  },
  warning: {
    kWkggS: "x1fyvr3y",
    kMwMTN: "xegcg24",
    $$css: true
  },
  danger: {
    kWkggS: "xve6jz8",
    kMwMTN: "x1g3r7qa",
    $$css: true
  },
  info: {
    kWkggS: "x95chvd",
    kMwMTN: "xhje13v",
    $$css: true
  },
  outline: {
    kWkggS: "xjbqb8w",
    kVAM5u: "x1e4lf4x",
    $$css: true
  },
  outlineNeutral: {
    kVAM5u: "x1hza1xs",
    kMwMTN: "x1ys4cjs",
    $$css: true
  },
  outlineMuted: {
    kVAM5u: "x1ubh2qd",
    ksu8eU: "xbsl7fq",
    $$css: true
  },
  mono: {
    kMv6JI: "xj528g9",
    kGuDYH: "x6a850q",
    kb6lSQ: "x12oo3zp",
    $$css: true
  },
  dot: {
    kWkggS: "xtwfq29",
    kaIpWk: "x1e6avla",
    kZKoxP: "xols6we",
    kzqmXN: "x1v4s8kt",
    $$css: true
  }
};
var layoutStyles = {
  stack: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    $$css: true
  }
};
var toolbarStyles = {
  root: {
    kGNEyG: "x6s0dn4",
    kWkggS: "xog5j1s",
    kL6WhQ: "xqhy64d",
    kfdmCh: "x1q0q8m5",
    kt9PQ7: "xso031l",
    k1xSpc: "x78zum5",
    kOIVth: "xou54vl",
    kjj79g: "x1qughib",
    kAzted: "xbktkl8",
    kmVPX3: "x1ff1495",
    $$css: true
  },
  copy: {
    k7Eaqz: "xeuugli",
    $$css: true
  },
  title: {
    kMwMTN: "x1ys4cjs",
    kGuDYH: "xif65rj",
    k63SB2: "x1b3j4lt",
    kb6lSQ: "x1lg07ej",
    kogj98: "x1ghz6dp",
    $$css: true
  },
  description: {
    kMwMTN: "xyu5t3h",
    kGuDYH: "xfifm61",
    k1K539: "xat24cr",
    keoZOQ: "xr9ek0c",
    $$css: true
  },
  actions: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kOIVth: "x167g77z",
    kjj79g: "x13a6bvl",
    $$css: true
  }
};
var segmentedStyles = {
  root: {
    kWkggS: "x16z3jmj",
    kaIpWk: "xxopg0z",
    k1xSpc: "x3nfvp2",
    kZKoxP: "x10w6t97",
    kmVPX3: "x9ms5i6",
    $$css: true
  },
  item: {
    kWkggS: "xjbqb8w xdnxrc",
    kVAM5u: "x9r1u3d",
    kaIpWk: "xbin24w",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kMwMTN: "xyu5t3h",
    kkrTdU: "x1ypdohk",
    kMv6JI: "xajfy2p",
    kGuDYH: "xif65rj",
    k63SB2: "x1b3j4lt",
    kZKoxP: "xd7y6wv",
    kI3sdo: "x1a2a7pz x6454uj",
    kE3dHu: "x163pfp",
    kpe85a: "xy13l1i",
    k3aq6I: "xnn1q72 xymg228",
    kIyJzY: "x1xy946n",
    k1ekBW: "xvb79w2",
    kAMwcw: "xe36upo",
    $$css: true
  },
  active: {
    kWkggS: "x13zjy52",
    kGVxlE: "x14ry9mf",
    kMwMTN: "x1ys4cjs",
    $$css: true
  },
  attention: {
    kMwMTN: "x1ys4cjs",
    $$css: true
  },
  disabled: {
    kkrTdU: "x1h6gzvc",
    kSiTet: "xbyyjgo",
    $$css: true
  }
};
var fieldStyles = {
  root: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x167g77z",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  label: {
    kMwMTN: "x1ys4cjs",
    kGuDYH: "xif65rj",
    k63SB2: "x1b3j4lt",
    kLWn49: "xo5v014",
    $$css: true
  },
  description: {
    kMwMTN: "xyu5t3h",
    kGuDYH: "xfifm61",
    kLWn49: "x37zpob",
    kogj98: "x1ghz6dp",
    $$css: true
  },
  control: {
    kWkggS: "x1f6rtwf",
    kVAM5u: "x15nqw3 x1rwf2kx",
    kaIpWk: "xbin24w",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kMwMTN: "x1heor9g",
    kMv6JI: "xajfy2p",
    kGuDYH: "xif65rj",
    kAzted: "x21xpn4",
    kI3sdo: "x1a2a7pz x6454uj",
    kInvED: "x1wfwxd8",
    kE3dHu: "x1lqa7cf",
    kpe85a: "xcicffo",
    kzqmXN: "xh8yej3",
    kGVxlE: "x1gnnqk1",
    kIyJzY: "x1xy946n",
    k1ekBW: "x12zzom9",
    kAMwcw: "xe36upo",
    $$css: true
  },
  compact: {
    kAzted: "xe0p6wg",
    $$css: true
  },
  controlWrapper: {
    kGNEyG: "x6s0dn4",
    kWkggS: "x1f6rtwf",
    kVAM5u: "x15nqw3 x1ijansz",
    kaIpWk: "xbin24w",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    k1xSpc: "x78zum5",
    k7Eaqz: "xeuugli",
    kI3sdo: "x1a2a7pz x4v947m",
    kVQacm: "xb3r6kr",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  textareaWrapper: {
    kGNEyG: "x1cy8zhl",
    $$css: true
  },
  controlInWrapper: {
    kWkggS: "xjbqb8w",
    kaIpWk: "x2u8bby",
    kGVxlE: "x1gnnqk1",
    k7Eaqz: "xeuugli",
    kI3sdo: "x1a2a7pz",
    $$css: true
  },
  adornment: {
    kGNEyG: "x6s0dn4",
    kMwMTN: "xyu5t3h",
    k1xSpc: "x3nfvp2",
    kmuXW: "x2lah0s",
    kAzted: "x21xpn4",
    kE3dHu: "x1lqa7cf",
    kpe85a: "xcicffo",
    $$css: true
  },
  selectControl: {
    kAzted: "x21xpn4",
    kpe85a: "x1sai7j1",
    kzqmXN: "x14atkfc",
    $$css: true
  },
  textarea: {
    kLWn49: "x1evy7pa",
    kAzted: "x1ujl9rh",
    kGO01o: "xdvlbce",
    kLKAdn: "x96k8nx",
    kHenm0: "x288g5",
    $$css: true
  },
  invalid: {
    kVAM5u: "xuj4g81",
    kGVxlE: "x1c8vacq",
    $$css: true
  },
  error: {
    kMwMTN: "x1g3r7qa",
    $$css: true
  }
};
var choiceStyles = {
  root: {
    kGNEyG: "x1cy8zhl",
    kMwMTN: "x1ys4cjs",
    k1xSpc: "x78zum5",
    kMv6JI: "x14t0e4u",
    kOIVth: "x7agqhd",
    $$css: true
  },
  disabled: {
    kkrTdU: "x1h6gzvc",
    kSiTet: "xbyyjgo",
    $$css: true
  },
  readOnly: {
    kkrTdU: "xt0e3qv",
    $$css: true
  },
  control: {
    kGNEyG: "x6s0dn4",
    kWkggS: "x13zjy52",
    kVAM5u: "x1hza1xs",
    kaIpWk: "x5i151u",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kMwMTN: "x9pa81l",
    kkrTdU: "x1ypdohk",
    k1xSpc: "x3nfvp2",
    kmuXW: "x2lah0s",
    kZKoxP: "xlup9mm",
    kjj79g: "xl56j7k",
    keoZOQ: "xvijh9v",
    kI3sdo: "x1a2a7pz x6454uj",
    kInvED: "x1wfwxd8",
    kmVPX3: "x1717udv",
    kIyJzY: "x1xy946n",
    k1ekBW: "x11vqxbs",
    kAMwcw: "xe36upo",
    kzqmXN: "x1kky2od",
    $$css: true
  },
  checked: {
    kWkggS: "x34jowk",
    kVAM5u: "x1swbpd4",
    $$css: true
  },
  indeterminate: {
    kWkggS: "x34jowk",
    kVAM5u: "x1swbpd4",
    $$css: true
  },
  content: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x1jnr06f",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  label: {
    kkrTdU: "x1ypdohk",
    kGuDYH: "xif65rj",
    k63SB2: "x1b3j4lt",
    kLWn49: "x1xfvgam",
    $$css: true
  },
  description: {
    kMwMTN: "xyu5t3h",
    kGuDYH: "xfifm61",
    kLWn49: "x37zpob",
    kogj98: "x1ghz6dp",
    $$css: true
  },
  hiddenInput: {
    kMcinP: "xeh89do",
    kz4h6p: "x1hyvwdk",
    kZKoxP: "xjm9jq1",
    kVQacm: "xb3r6kr",
    kVAEAm: "x10l6tqk",
    khDVqt: "xuxw1ft",
    kzqmXN: "x1i1rx1s",
    $$css: true
  }
};
var readOnlyValueStyles = {
  root: {
    kWkggS: "x16z3jmj",
    kVAM5u: "x9r1u3d",
    kaIpWk: "x3wpolg",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kMwMTN: "x1ys4cjs",
    kkrTdU: "x1ed109x",
    k1xSpc: "x1lliihq",
    kMv6JI: "x14t0e4u",
    kGuDYH: "xif65rj",
    kLWn49: "x1fc57z9",
    kAzted: "x21xpn4",
    k7Eaqz: "xeuugli",
    kI3sdo: "x1a2a7pz x6454uj",
    kInvED: "x1wfwxd8",
    kHjlTd: "xj0a0fe",
    kGO01o: "xs9asl8",
    kE3dHu: "x1lqa7cf",
    kpe85a: "xcicffo",
    kLKAdn: "x123j3cw",
    khDVqt: "x126k92a",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  compact: {
    kAzted: "xe0p6wg",
    kGO01o: "xg8j3zb",
    kLKAdn: "xyqdw3p",
    $$css: true
  },
  empty: {
    kMwMTN: "xyu5t3h",
    $$css: true
  },
  invalid: {
    kVAM5u: "xuj4g81",
    $$css: true
  }
};
var switchStyles = {
  root: {
    kGNEyG: "x1cy8zhl",
    kMwMTN: "x1ys4cjs",
    k1xSpc: "x78zum5",
    kMv6JI: "x14t0e4u",
    kOIVth: "x7agqhd",
    kjj79g: "x1qughib",
    $$css: true
  },
  disabled: {
    kkrTdU: "x1h6gzvc",
    kSiTet: "xbyyjgo",
    $$css: true
  },
  copy: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x1jnr06f",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  label: {
    kkrTdU: "x1ypdohk",
    kGuDYH: "xif65rj",
    k63SB2: "x1b3j4lt",
    kLWn49: "x1xfvgam",
    $$css: true
  },
  description: {
    kMwMTN: "xyu5t3h",
    kGuDYH: "xfifm61",
    kLWn49: "x37zpob",
    kogj98: "x1ghz6dp",
    $$css: true
  },
  control: {
    kGNEyG: "x6s0dn4",
    kWkggS: "x1g9bo7c",
    kVAM5u: "x9r1u3d",
    kaIpWk: "xv3pep",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kkrTdU: "x1ypdohk",
    k1xSpc: "x3nfvp2",
    kmuXW: "x2lah0s",
    kZKoxP: "xmix8c7",
    kI3sdo: "x1a2a7pz x6454uj",
    kInvED: "x1wfwxd8",
    kmVPX3: "xyf9f8g",
    kIyJzY: "x1xy946n",
    k1ekBW: "x106061f",
    kAMwcw: "xe36upo",
    kzqmXN: "x1td3qas",
    $$css: true
  },
  checked: {
    kWkggS: "x34jowk",
    $$css: true
  },
  thumb: {
    kWkggS: "x13zjy52",
    kaIpWk: "xv3pep",
    kGVxlE: "xeyionm",
    kZKoxP: "xlup9mm",
    k3aq6I: "xbryuvx",
    kIyJzY: "x1xy946n",
    k1ekBW: "x11xpdln",
    kAMwcw: "xe36upo",
    kzqmXN: "x1kky2od",
    $$css: true
  },
  thumbChecked: {
    k3aq6I: "xv5t66b",
    $$css: true
  },
  hiddenInput: {
    kMcinP: "xeh89do",
    kz4h6p: "x1hyvwdk",
    kZKoxP: "xjm9jq1",
    kVQacm: "xb3r6kr",
    kVAEAm: "x10l6tqk",
    khDVqt: "xuxw1ft",
    kzqmXN: "x1i1rx1s",
    $$css: true
  }
};
var fieldsetStyles = {
  root: {
    kVAM5u: "x9r1u3d",
    ksu8eU: "xng3xce",
    kMzoRj: "xc342km",
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x1v2ro7d",
    kogj98: "x1ghz6dp",
    k7Eaqz: "xeuugli",
    kmVPX3: "x1717udv",
    $$css: true
  },
  disabled: {
    kSiTet: "xwq05k6",
    $$css: true
  },
  legend: {
    kMwMTN: "x1ys4cjs",
    kMv6JI: "x14t0e4u",
    kGuDYH: "xif65rj",
    k63SB2: "x1b3j4lt",
    k1K539: "xl5rmxb",
    kmVPX3: "x1717udv",
    $$css: true
  },
  description: {
    kMwMTN: "xyu5t3h",
    kMv6JI: "x14t0e4u",
    kGuDYH: "xfifm61",
    kLWn49: "x37zpob",
    kogj98: "x1ghz6dp",
    $$css: true
  },
  content: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x7agqhd",
    $$css: true
  }
};
var disclosureStyles = {
  root: {
    kL6WhQ: "xqhy64d",
    kfdmCh: "x1q0q8m5",
    kt9PQ7: "xso031l",
    $$css: true
  },
  trigger: {
    kGNEyG: "x6s0dn4",
    kWkggS: "xjbqb8w",
    kMwMTN: "x1ys4cjs",
    kkrTdU: "x1ypdohk",
    k1xSpc: "x78zum5",
    kMv6JI: "x14t0e4u",
    kGuDYH: "xif65rj",
    k63SB2: "x1b3j4lt",
    kOIVth: "x7agqhd",
    kjj79g: "x1qughib",
    kAzted: "x2dgz13",
    kI3sdo: "x1a2a7pz x6454uj",
    kInvED: "x1wfwxd8",
    kE3dHu: "x1uhho1l",
    kpe85a: "x1xpa7k",
    kybGjl: "x1hl2dhg xt0b8zv",
    kcSHmL: "x3pynha",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  icon: {
    kMwMTN: "xyu5t3h",
    k3aq6I: "x7p49u4",
    kIyJzY: "x6xk6gu",
    k1ekBW: "x11xpdln",
    kAMwcw: "xe36upo",
    $$css: true
  },
  iconOpen: {
    k3aq6I: "x19jd1h0",
    $$css: true
  },
  panel: {
    kMwMTN: "xyu5t3h",
    kGuDYH: "xif65rj",
    kLWn49: "x1evy7pa",
    $$css: true
  },
  panelInner: {
    kmVPX3: "xe4ajzu",
    $$css: true
  }
};
var panelStyles = {
  root: {
    kWkggS: "x13zjy52",
    kMwMTN: "x2pdk8c",
    kaIpWk: "x185dj9a",
    kGVxlE: "xxmzx1m",
    kVQacm: "xb3r6kr",
    $$css: true
  },
  header: {
    kL6WhQ: "xqhy64d",
    kfdmCh: "x1q0q8m5",
    kt9PQ7: "xso031l",
    kmVPX3: "x1tamke2",
    $$css: true
  },
  title: {
    kMwMTN: "x1heor9g",
    kGuDYH: "x1j61zf2",
    k63SB2: "x1b3j4lt",
    kLWn49: "x1xfvgam",
    kogj98: "x1ghz6dp",
    $$css: true
  },
  description: {
    kMwMTN: "xyu5t3h",
    kGuDYH: "xif65rj",
    kLWn49: "xfrs9s4",
    k1K539: "xat24cr",
    keoZOQ: "x1gslohp",
    $$css: true
  },
  body: {
    kmVPX3: "x1tamke2",
    $$css: true
  }
};

// src/badge.ts
var view = (config, h) => {
  const tone = config.tone ?? "neutral";
  const isOutline = config.variant === "outline";
  return h.span(rootAttrs(config, h, badgeStyles.base, badgeStyles[tone], isOutline && badgeStyles.outline, isOutline && tone === "neutral" && badgeStyles.outlineNeutral, isOutline && tone === "muted" && badgeStyles.outlineMuted, config.mono === true && badgeStyles.mono), [...(config.dot === true ? [h.span([...slotAttrs(config.slotProps?.dot, h, badgeStyles.dot), h.AriaHidden(true)])] : []), config.label]);
};

// src/button.ts
var button_exports = {};
__export(button_exports, {
  icon: () => icon,
  view: () => view3
});

// src/icon.ts
var icon_exports = {};
__export(icon_exports, {
  view: () => view2
});
var nodeView = (iconName, node, path, absoluteStrokeWidth, h) => {
  const [tag, properties, children = []] = node;
  const key2 = properties.key ?? path;
  const attributes = Object.entries(properties).filter(([name]) => name !== "key").map(([name, value]) => h.Attribute(name, value));
  return h.keyed(tag)(`${iconName}-${key2}`, [...attributes, ...(absoluteStrokeWidth ? [h.Attribute("vector-effect", "non-scaling-stroke")] : [])], children.map((child, index) => nodeView(iconName, child, `${path}-${index}`, absoluteStrokeWidth, h)));
};
var view2 = (config, h) => {
  const sourceWidth = "size" in config.icon ? config.icon.size : config.icon.width;
  const sourceHeight = "size" in config.icon ? config.icon.size : config.icon.height;
  const size = config.size ?? 16;
  const label2 = config.label;
  return h.svg([h.Style({
    display: "block",
    "flex-shrink": "0"
  }), h.Attribute("xmlns", "http://www.w3.org/2000/svg"), h.ViewBox(`0 0 ${sourceWidth} ${sourceHeight}`), h.Width(`${size}`), h.Height(`${size}`), h.Attribute("fill", "none"), h.Attribute("stroke", "currentColor"), h.Attribute("stroke-width", `${config.strokeWidth ?? 2}`), h.Attribute("stroke-linecap", "round"), h.Attribute("stroke-linejoin", "round"), h.Attribute("focusable", "false"), h.DataAttribute("lucide-icon", config.icon.name), ...(label2 === void 0 ? [h.AriaHidden(true)] : [h.Role("img"), h.AriaLabel(label2)]), ...rootAttrs(config, h)], config.icon.node.map((node, index) => nodeView(config.icon.name, node, `${index}`, config.absoluteStrokeWidth ?? false, h)));
};

// src/button.ts
var variantStyle = variant => {
  switch (variant) {
    case "primary":
      return buttonStyles.primary;
    case "secondary":
      return buttonStyles.secondary;
    case "outline":
      return buttonStyles.outline;
    case "ghost":
      return buttonStyles.ghost;
    case "danger":
      return buttonStyles.danger;
    case "link":
      return buttonStyles.link;
  }
};
var sizeStyle = size => {
  switch (size) {
    case "xs":
      return buttonStyles.xs;
    case "sm":
      return buttonStyles.sm;
    case "md":
      return buttonStyles.md;
    case "lg":
      return buttonStyles.lg;
    case "icon":
      return buttonStyles.icon;
  }
};
var iconSize = size => size === "xs" ? 12 : size === "sm" ? 14 : 16;
var view3 = (config, h) => {
  if (config.command) {
    const {
      definition,
      platform,
      toMessage
    } = config.command;
    const {
      command: _command,
      ...rest
    } = config;
    return view3({
      ...rest,
      label: definition.label,
      isDisabled: definition.isDisabled ?? false,
      onClick: toMessage(definition.id),
      attributes: [...(config.attributes ?? []), h.AriaKeyshortcuts(Keyboard5.aria(definition.shortcut, platform)), h.Title(`${definition.label} (${Keyboard5.display(definition.shortcut, platform)})`)]
    }, h);
  }
  const variant = config.variant ?? "primary";
  const size = config.size ?? "md";
  return Button.view({
    ...(config.onClick === void 0 ? {} : {
      onClick: config.onClick
    }),
    ...(config.isDisabled === void 0 ? {} : {
      isDisabled: config.isDisabled
    }),
    toView: ({
      button
    }) => {
      const attributes = [...button, ...rootAttrs(config, h, buttonStyles.base, variantStyle(variant), sizeStyle(size), variant === "link" && buttonStyles.linkShape, config.isFullWidth === true && buttonStyles.fullWidth, config.isDisabled === true && buttonStyles.disabled), ...(config.ariaLabel === void 0 ? [] : [h.AriaLabel(config.ariaLabel)])];
      const children = [...(config.icon === void 0 ? [] : [h.span(slotAttrs(config.slotProps?.startIcon, h), [view2({
        icon: config.icon,
        size: iconSize(size)
      }, h)])]), ...(config.label === void 0 ? [] : [h.span(slotAttrs(config.slotProps?.label, h), [config.label])]), ...(config.trailingIcon === void 0 ? [] : [h.span(slotAttrs(config.slotProps?.endIcon, h), [view2({
        icon: config.trailingIcon,
        size: iconSize(size)
      }, h)])]), ...(config.children ?? [])];
      return config.as === "label" ? h.label(attributes, children) : h.button(attributes, children);
    }
  }, h);
};
var iconShape = size => {
  switch (size) {
    case "xs":
      return buttonStyles.iconXs;
    case "sm":
      return buttonStyles.iconSm;
    case "md":
      return buttonStyles.iconMd;
    case "lg":
      return buttonStyles.iconLg;
  }
};
var icon = (config, h) => {
  if (config.label.trim() === "") throw new Error("Button.icon requires a non-empty label.");
  const size = config.size ?? "md";
  return view3({
    icon: config.icon,
    ariaLabel: config.label,
    variant: config.variant ?? "ghost",
    size,
    ...(config.onClick === void 0 ? {} : {
      onClick: config.onClick
    }),
    ...(config.isDisabled === void 0 ? {} : {
      isDisabled: config.isDisabled
    }),
    ...(config.slotProps?.startIcon === void 0 ? {} : {
      slotProps: {
        startIcon: config.slotProps.startIcon
      }
    }),
    attributes: [...(config.attributes ?? []), ...(config.slotProps?.root?.attributes ?? [])],
    sx: [iconShape(size), config.sx, config.slotProps?.root?.sx]
  }, h);
};

// src/checkbox.ts
var checkbox_exports = {};
__export(checkbox_exports, {
  view: () => view5
});

// src/description.ts
var view4 = (description, attributes, visibleAttributes, h) => description === void 0 ? h.span([...attributes, h.Style({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  overflow: "hidden",
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
})], []) : h.p([...attributes, ...visibleAttributes], [description]);

// src/checkbox.ts
var view5 = (config, h) => {
  const isReadOnly = config.presentation === "value" || config.isReadOnly === true;
  return Checkbox.view({
    id: config.id,
    hasDescription: true,
    isChecked: config.isChecked,
    onToggle: config.onToggle,
    ...(config.isDisabled === void 0 ? {} : {
      isDisabled: config.isDisabled
    }),
    isReadOnly,
    ...(config.isIndeterminate === void 0 ? {} : {
      isIndeterminate: config.isIndeterminate
    }),
    ...(config.name === void 0 ? {} : {
      name: config.name
    }),
    ...(config.value === void 0 ? {} : {
      value: config.value
    }),
    toView: attributes => h.div(rootAttrs(config, h, choiceStyles.root, config.isDisabled === true && choiceStyles.disabled, isReadOnly && choiceStyles.readOnly), [h.button([...attributes.checkbox, ...slotAttrs(config.slotProps?.control, h, choiceStyles.control, isReadOnly && choiceStyles.readOnly, config.isChecked && choiceStyles.checked, config.isIndeterminate === true && choiceStyles.indeterminate)], config.isChecked || config.isIndeterminate === true ? [view2({
      icon: config.isIndeterminate === true ? Minus : Check,
      size: 13,
      strokeWidth: 2.5
    }, h)] : []), h.div(slotAttrs(config.slotProps?.content, h, choiceStyles.content), [h.span([...attributes.label, ...slotAttrs(config.slotProps?.label, h, choiceStyles.label, isReadOnly && choiceStyles.readOnly)], [config.label]), view4(config.description, attributes.description, slotAttrs(config.slotProps?.description, h, choiceStyles.description), h)]), ...(attributes.hiddenInput.length === 0 ? [] : [h.input([...attributes.hiddenInput, ...slotAttrs(config.slotProps?.hiddenInput, h, choiceStyles.hiddenInput)])])])
  }, h);
};

// src/code-block.ts
var code_block_exports = {};
__export(code_block_exports, {
  view: () => view6,
  writeClipboard: () => writeClipboard
});
var toneColorStyles = {
  neutral: {
    kMwMTN: "xyu5t3h",
    $$css: true
  },
  muted: {
    kMwMTN: "x19j9jsy",
    $$css: true
  },
  accent: {
    kMwMTN: "x1ysz8r6",
    $$css: true
  },
  success: {
    kMwMTN: "x15kbz4b",
    $$css: true
  },
  warning: {
    kMwMTN: "xegcg24",
    $$css: true
  },
  danger: {
    kMwMTN: "x1g3r7qa",
    $$css: true
  },
  info: {
    kMwMTN: "xhje13v",
    $$css: true
  }
};
var descriptionListStyles = {
  root: {
    kMv6JI: "x14t0e4u",
    kGuDYH: "x1kio5tc",
    kLWn49: "xgsdihv",
    kogj98: "x1ghz6dp",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  sm: {
    kGuDYH: "xwdf1oc",
    $$css: true
  },
  horizontal: {
    k1C7PZ: "x1h82uww",
    k1xSpc: "xrvj5dj",
    kumcoG: "x9v58at",
    khm7nJ: "xxclsjd",
    $$css: true
  },
  stacked: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x1ngs94h",
    $$css: true
  },
  divided: {
    khm7nJ: "xxs79tx",
    $$css: true
  },
  rowHorizontal: {
    kGNEyG: "x1pha0wt",
    k1xSpc: "xrvj5dj",
    kBCFzs: "x1osaytk",
    kumcoG: "x4w6khx",
    $$css: true
  },
  rowStacked: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x1xkdh0r",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  rowDivided: {
    k8WAf4: "x11vqmue",
    $$css: true
  },
  rowDivider: {
    kLZC3w: "x18lnz4u",
    kPef9Z: "x13fuv20",
    kEafiO: "x178xt8z",
    $$css: true
  },
  term: {
    kMwMTN: "xyu5t3h",
    k63SB2: "x1b3j4lt",
    k7Eaqz: "xeuugli",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  value: {
    kMwMTN: "x1ys4cjs",
    kogj98: "x1ghz6dp",
    k7Eaqz: "xeuugli",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  code: {
    kMv6JI: "xj528g9",
    kGuDYH: "x14flv6w",
    $$css: true
  },
  codeChip: {
    kWkggS: "x16z3jmj",
    kaIpWk: "x5i151u",
    kMwMTN: "x1hmp2g",
    k8WAf4: "xsplgde",
    kg3NbH: "x187qg2c",
    $$css: true
  },
  muted: {
    kMwMTN: "xyu5t3h",
    $$css: true
  },
  chips: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kOIVth: "x1kd3ua",
    $$css: true
  },
  empty: {
    kMwMTN: "xyu5t3h",
    $$css: true
  }
};
var statStyles = {
  root: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kMv6JI: "x14t0e4u",
    kOIVth: "x1kd3ua",
    kogj98: "x1ghz6dp",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  tile: {
    kWkggS: "x13zjy52",
    kVAM5u: "x1ubh2qd",
    kaIpWk: "x1c26gy3",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kMwMTN: "x2pdk8c",
    kmVPX3: "xaodzvu",
    $$css: true
  },
  tileSm: {
    kmVPX3: "x1szo1dz",
    $$css: true
  },
  tileAccent: {
    kWkggS: "x1aukw0t",
    kVAM5u: "x16gyd8g",
    $$css: true
  },
  tileSuccess: {
    kWkggS: "x1ul8v2d",
    kVAM5u: "x1rdkhij",
    $$css: true
  },
  tileWarning: {
    kWkggS: "xd5seal",
    kVAM5u: "x1w49ke4",
    $$css: true
  },
  tileDanger: {
    kWkggS: "x2pq60z",
    kVAM5u: "x1j3i1cz",
    $$css: true
  },
  tileInfo: {
    kWkggS: "xm85798",
    kVAM5u: "x126j4jg",
    $$css: true
  },
  label: {
    kGNEyG: "x6s0dn4",
    kMwMTN: "xyu5t3h",
    k1xSpc: "x78zum5",
    kGuDYH: "x1kio5tc",
    k63SB2: "x1b3j4lt",
    kOIVth: "x1kd3ua",
    kLWn49: "xxhjj0a",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  valueRow: {
    kGNEyG: "x1pha0wt",
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kOIVth: "x7agqhd",
    kogj98: "x1ghz6dp",
    $$css: true
  },
  value: {
    kMwMTN: "x1ys4cjs",
    kGuDYH: "x1pvqxga",
    kcqcaj: "xss6m8b",
    k63SB2: "x1uflamq",
    kb6lSQ: "x72az59",
    kLWn49: "xxhjj0a",
    $$css: true
  },
  valueSm: {
    kGuDYH: "xf92qd0",
    $$css: true
  },
  valueMuted: {
    kMwMTN: "xyu5t3h",
    $$css: true
  },
  delta: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x3nfvp2",
    kGuDYH: "xwdf1oc",
    kcqcaj: "xss6m8b",
    k63SB2: "x1b3j4lt",
    kOIVth: "x1xkdh0r",
    $$css: true
  },
  deltaLabel: {
    kMwMTN: "xyu5t3h",
    k63SB2: "xo1l8bm",
    $$css: true
  },
  description: {
    kMwMTN: "xyu5t3h",
    kGuDYH: "xwdf1oc",
    kLWn49: "xgsdihv",
    kogj98: "x1ghz6dp",
    $$css: true
  },
  extra: {
    kogj98: "x1ghz6dp",
    keoZOQ: "xlbxz1w",
    $$css: true
  }
};
var legendStyles = {
  root: {
    kMwMTN: "x1ys4cjs",
    k1xSpc: "x78zum5",
    kMv6JI: "x14t0e4u",
    kGuDYH: "xwdf1oc",
    kB88ic: "xe8uvvx",
    kogj98: "x1ghz6dp",
    kmVPX3: "x1717udv",
    $$css: true
  },
  horizontal: {
    kGNEyG: "x6s0dn4",
    k1C7PZ: "x1h82uww",
    kwnvtZ: "x1a02dak",
    khm7nJ: "xx3t3a7",
    $$css: true
  },
  vertical: {
    kXwgrk: "xdt5ytf",
    kOIVth: "x1kd3ua",
    $$css: true
  },
  item: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    kOIVth: "x7agqhd",
    kLWn49: "xxhjj0a",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  itemWithDescription: {
    kGNEyG: "x1cy8zhl",
    $$css: true
  },
  copy: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x1xkdh0r",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  labelRow: {
    kGNEyG: "x1pha0wt",
    k1xSpc: "x78zum5",
    kOIVth: "x1kd3ua",
    $$css: true
  },
  value: {
    kMwMTN: "xyu5t3h",
    kcqcaj: "xss6m8b",
    $$css: true
  },
  description: {
    kMwMTN: "xyu5t3h",
    kGuDYH: "x6a850q",
    $$css: true
  },
  marker: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x3nfvp2",
    kmuXW: "x2lah0s",
    kZKoxP: "x1v9usgg",
    kjj79g: "xl56j7k",
    kzqmXN: "x6jxa94",
    $$css: true
  },
  swatch: {
    kVAM5u: "x1r7ld26",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kZKoxP: "x170jfvy",
    kzqmXN: "x1fsd2vl",
    $$css: true
  },
  square: {
    kaIpWk: "x1cum3z5",
    $$css: true
  },
  circle: {
    kaIpWk: "xv3pep",
    $$css: true
  },
  line: {
    kaIpWk: "xv3pep",
    kMzoRj: "xc342km",
    kZKoxP: "xuoj239",
    kzqmXN: "x6jxa94",
    $$css: true
  },
  solid: {
    kWkggS: "xtwfq29",
    $$css: true
  },
  soft: {
    kWkggS: "x187p858",
    $$css: true
  },
  outline: {
    kWkggS: "xjbqb8w",
    kMzoRj: "xvndefy",
    $$css: true
  },
  dashed: {
    kWkggS: "xjbqb8w",
    ksu8eU: "xbsl7fq",
    kMzoRj: "xvndefy",
    $$css: true
  },
  lineDashed: {
    kWkggS: "xjbqb8w",
    ksu8eU: "xbsl7fq",
    kEafiO: "xamhcws",
    kZKoxP: "xqtp20y",
    $$css: true
  },
  symbol: {
    kGuDYH: "xwdf1oc",
    k63SB2: "x1uflamq",
    kLWn49: "xo5v014",
    $$css: true
  }
};
var codeBlockStyles = {
  root: {
    kWkggS: "x16z3jmj",
    kVAM5u: "x1ubh2qd",
    kaIpWk: "x3wpolg",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kMwMTN: "x1ys4cjs",
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    k7Eaqz: "xeuugli",
    kVQacm: "xb3r6kr",
    kVAEAm: "x1n2onr6",
    $$css: true
  },
  header: {
    kGNEyG: "x6s0dn4",
    kL6WhQ: "xqhy64d",
    kfdmCh: "x1q0q8m5",
    kt9PQ7: "xso031l",
    k1xSpc: "x78zum5",
    kOIVth: "x7agqhd",
    kjj79g: "x1qughib",
    kAzted: "x21xpn4",
    k8WAf4: "x1rz83db",
    kwRFfy: "xngqqzl",
    kZCmMZ: "x1werhyb",
    $$css: true
  },
  title: {
    kMwMTN: "xyu5t3h",
    kMv6JI: "x14t0e4u",
    kGuDYH: "xwdf1oc",
    k63SB2: "x1b3j4lt",
    k7Eaqz: "xeuugli",
    kVQacm: "xb3r6kr",
    kg5iWk: "xlyipyv",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  copy: {
    kGNEyG: "x6s0dn4",
    kWkggS: "xjbqb8w xdnxrc",
    kaIpWk: "x5i151u",
    kMwMTN: "xyu5t3h x1t0a7xc",
    kkrTdU: "x1ypdohk",
    k1xSpc: "x3nfvp2",
    kmuXW: "x2lah0s",
    kMv6JI: "x14t0e4u",
    kGuDYH: "xwdf1oc",
    k63SB2: "x1b3j4lt",
    kOIVth: "x1kd3ua",
    kZKoxP: "xxk0z11",
    kI3sdo: "x1a2a7pz x6454uj",
    kg3NbH: "x6n740t",
    $$css: true
  },
  copyFloating: {
    kWkggS: "x13zjy52 xdnxrc",
    k87sOh: "xtiyotq",
    kt4wiu: "xlyooji",
    kVAEAm: "x10l6tqk",
    kY2c9j: "x1vjfegm",
    $$css: true
  },
  viewport: {
    kAzted: "x2lwn1j",
    kVQacm: "xysyzu8",
    k6w4Gs: "xux9d8k",
    k5wCbM: "x1597r2g",
    $$css: true
  },
  viewportFocusable: {
    kI3sdo: "x1a2a7pz x6454uj",
    kInvED: "x1v57pqu",
    $$css: true
  },
  pre: {
    kMv6JI: "xj528g9",
    kGuDYH: "xwdf1oc",
    kLWn49: "x1dbl2gt",
    kogj98: "x1ghz6dp",
    kmVPX3: "x1szo1dz",
    kKi2Bq: "xeq4nuv",
    khDVqt: "x1sdyfia",
    kzqmXN: "xezivpi",
    k7Eaqz: "xgqtt45",
    $$css: true
  },
  preFloatingCopy: {
    kwRFfy: "x17kjicv",
    $$css: true
  },
  wrap: {
    kHjlTd: "xj0a0fe",
    khDVqt: "x126k92a",
    kzqmXN: "x14atkfc",
    $$css: true
  },
  code: {
    kMv6JI: "xjb2p0i",
    kGuDYH: "x1qlqyl8",
    $$css: true
  },
  line: {
    k1xSpc: "x1lliihq",
    kAzted: "x1dlxrgk",
    $$css: true
  },
  lineNumber: {
    kMwMTN: "xyu5t3h",
    k1xSpc: "x1rg5ohu",
    kcqcaj: "xss6m8b",
    k71WvV: "x1nl5tns",
    kSiTet: "x1ks1olk",
    k9WMMc: "xp4054r",
    kfSwDN: "x87ps6o",
    $$css: true
  },
  keyword: {
    kMwMTN: "x2esumo",
    $$css: true
  },
  string: {
    kMwMTN: "x1lkxaut",
    $$css: true
  },
  number: {
    kMwMTN: "xk210fg",
    $$css: true
  },
  comment: {
    kMwMTN: "x1djyuj3",
    kKX8nH: "x1k4tb9n",
    $$css: true
  },
  type: {
    kMwMTN: "x1mdygey",
    $$css: true
  },
  property: {
    kMwMTN: "x5j97w3",
    $$css: true
  },
  punctuation: {
    kMwMTN: "xyu5t3h",
    $$css: true
  }
};
var contentStyles = {
  text: {
    kMv6JI: "x14t0e4u",
    kLWn49: "xgsdihv",
    kogj98: "x1ghz6dp",
    $$css: true
  },
  textXs: {
    kGuDYH: "x6a850q",
    $$css: true
  },
  textSm: {
    kGuDYH: "xwdf1oc",
    $$css: true
  },
  textMd: {
    kGuDYH: "x1kio5tc",
    $$css: true
  },
  textLg: {
    kGuDYH: "x16ws5mb",
    $$css: true
  },
  textXl: {
    kGuDYH: "xf92qd0",
    $$css: true
  },
  toneDefault: {
    kMwMTN: "x1ys4cjs",
    $$css: true
  },
  toneMuted: {
    kMwMTN: "xyu5t3h",
    $$css: true
  },
  toneSuccess: {
    kMwMTN: "x15kbz4b",
    $$css: true
  },
  toneWarning: {
    kMwMTN: "xegcg24",
    $$css: true
  },
  toneDanger: {
    kMwMTN: "x1g3r7qa",
    $$css: true
  },
  weightRegular: {
    k63SB2: "xo1l8bm",
    $$css: true
  },
  weightMedium: {
    k63SB2: "x1b3j4lt",
    $$css: true
  },
  weightSemibold: {
    k63SB2: "x1uflamq",
    $$css: true
  },
  weightBold: {
    k63SB2: "x1gbwjcz",
    $$css: true
  },
  alignCenter: {
    k9WMMc: "x2b8uid",
    $$css: true
  },
  alignEnd: {
    k9WMMc: "xp4054r",
    $$css: true
  },
  truncate: {
    kVQacm: "xb3r6kr",
    kg5iWk: "xlyipyv",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  heading: {
    kMv6JI: "x14t0e4u",
    k63SB2: "x1uflamq",
    kb6lSQ: "x72az59",
    kLWn49: "xxhjj0a",
    kogj98: "x1ghz6dp",
    $$css: true
  },
  headingSm: {
    kGuDYH: "x1kio5tc",
    $$css: true
  },
  headingMd: {
    kGuDYH: "xf92qd0",
    $$css: true
  },
  headingLg: {
    kGuDYH: "xwsyq91",
    $$css: true
  },
  headingXl: {
    kGuDYH: "xneq65o",
    $$css: true
  },
  link: {
    kaIpWk: "x5i151u",
    kMwMTN: "x1ysz8r6",
    kMv6JI: "x14t0e4u",
    kI3sdo: "x1a2a7pz x6454uj",
    kMnn75: "xujl8zx x1ubmc1d",
    kcSHmL: "xda060z",
    $$css: true
  },
  visuallyHidden: {
    kMcinP: "xeh89do",
    kz4h6p: "x1hyvwdk",
    kZKoxP: "xjm9jq1",
    kogj98: "xkdpibf",
    kVQacm: "xb3r6kr",
    kmVPX3: "x1717udv",
    kVAEAm: "x10l6tqk",
    khDVqt: "xuxw1ft",
    kzqmXN: "x1i1rx1s",
    $$css: true
  },
  visuallyHiddenFocusable: {
    kMcinP: "xeh89do x1jxxt1b",
    kz4h6p: "x1hyvwdk x1rsz1da",
    kZKoxP: "xjm9jq1 x15cytp8",
    kogj98: "xkdpibf x1y5lnwp",
    kVQacm: "xb3r6kr xomzh7y",
    kmVPX3: "x1717udv x1t42p4o",
    kVAEAm: "x10l6tqk x1xrnuwo",
    khDVqt: "xuxw1ft",
    kzqmXN: "x1i1rx1s x1jqxupm",
    kWkggS: "x13zjy52",
    kMwMTN: "x1ys4cjs",
    k87sOh: "xfr5jun",
    kLqNvP: "xrotz4w",
    kY2c9j: "x11uqc5h",
    $$css: true
  }
};
var primitiveStyles = {
  tag: {
    kGNEyG: "x6s0dn4",
    kWkggS: "x16z3jmj",
    kVAM5u: "x1ubh2qd",
    kaIpWk: "xv3pep",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kMwMTN: "x1ys4cjs",
    k1xSpc: "x3nfvp2",
    kMv6JI: "x14t0e4u",
    kGuDYH: "xwdf1oc",
    k63SB2: "x1b3j4lt",
    kOIVth: "x1kd3ua",
    kAzted: "xjwf9q1",
    kmVPX3: "xmfpazt",
    $$css: true
  },
  tagSelected: {
    kWkggS: "x4ov27q",
    kVAM5u: "x1biuxk5",
    kMwMTN: "xc3dant",
    $$css: true
  },
  tagDanger: {
    kWkggS: "xve6jz8",
    kVAM5u: "x1j3i1cz",
    kMwMTN: "x1g3r7qa",
    $$css: true
  },
  tagSuccess: {
    kWkggS: "x1x4pbqu",
    kVAM5u: "x1qm9elf",
    kMwMTN: "x15kbz4b",
    $$css: true
  },
  tagWarning: {
    kWkggS: "x1fyvr3y",
    kVAM5u: "x1eua5u4",
    kMwMTN: "xegcg24",
    $$css: true
  },
  tagInfo: {
    kWkggS: "x95chvd",
    kVAM5u: "x6pof7l",
    kMwMTN: "xhje13v",
    $$css: true
  },
  tagAccent: {
    kWkggS: "x6x6jrj",
    kVAM5u: "x1ceqfet",
    kMwMTN: "x1ysz8r6",
    $$css: true
  },
  tagMuted: {
    kWkggS: "xjbqb8w",
    kVAM5u: "x1ubh2qd",
    kMwMTN: "xyu5t3h",
    $$css: true
  },
  tagMono: {
    kMv6JI: "xj528g9",
    kGuDYH: "x6a850q",
    $$css: true
  },
  tagButton: {
    kWkggS: "xjbqb8w",
    kMwMTN: "x1heor9g",
    kkrTdU: "x1ypdohk",
    kVVagm: "xln7xf2",
    kogj98: "x1cgib5n",
    kmVPX3: "xxzb6uj",
    $$css: true
  },
  tagRemove: {
    kGNEyG: "x6s0dn4",
    kWkggS: "xjbqb8w xlz14d4",
    kaIpWk: "xv3pep",
    kMwMTN: "x1heor9g",
    kkrTdU: "x1ypdohk",
    k1xSpc: "x3nfvp2",
    kVVagm: "xln7xf2",
    kZKoxP: "xmix8c7",
    kjj79g: "xl56j7k",
    k71WvV: "x1lxpwgx",
    kmVPX3: "x1717udv",
    kzqmXN: "x1xp8n7a",
    $$css: true
  },
  numberRoot: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x1kd3ua",
    $$css: true
  },
  numberControl: {
    kGNEyG: "x1qjc9v5",
    k1xSpc: "xrvj5dj",
    kumcoG: "x8n4wc",
    $$css: true
  },
  numberInput: {
    kysU6D: "xtilpmw",
    kaIpWk: "x2u8bby",
    k7Eaqz: "xeuugli",
    k9WMMc: "x2b8uid",
    $$css: true
  },
  numberButton: {
    kGNEyG: "x6s0dn4",
    kWkggS: "x13zjy52 xdnxrc",
    kVAM5u: "x1hza1xs",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kMwMTN: "x1ys4cjs",
    kkrTdU: "x1ypdohk",
    k1xSpc: "x3nfvp2",
    kMv6JI: "x14t0e4u",
    kGuDYH: "x16ws5mb",
    kjj79g: "xl56j7k",
    kmVPX3: "x1717udv",
    $$css: true
  },
  numberButtonStart: {
    kqGeR4: "x18yxi80",
    kWqL5O: "xgfja2r",
    kIxVMA: "x1yvtzww",
    $$css: true
  },
  numberButtonEnd: {
    kYm2EN: "xuucmwi",
    kZ1KPB: "xyj58a3",
    ksF3WI: "x1g8l7pg",
    $$css: true
  },
  stepper: {
    kB88ic: "xe8uvvx",
    kogj98: "x1ghz6dp",
    kmVPX3: "x1717udv",
    $$css: true
  },
  stepperHorizontal: {
    k1xSpc: "xrvj5dj",
    klIVar: "x1rnidkh",
    kprqdN: "x1mt1orb",
    $$css: true
  },
  stepperVertical: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x7agqhd",
    $$css: true
  },
  step: {
    kGNEyG: "x1cy8zhl",
    k1xSpc: "xrvj5dj",
    kOIVth: "x7agqhd",
    kumcoG: "x1n2e3sn",
    k7Eaqz: "xeuugli",
    kVAEAm: "x1n2onr6",
    $$css: true
  },
  stepHorizontal: {
    kumcoG: "x1y6fwsi",
    kAPf3g: "x1o2pa38",
    kg3NbH: "x187qg2c",
    k9WMMc: "x2b8uid",
    $$css: true
  },
  stepConnectorHorizontal: {
    kWkggS: "xzm8oiv",
    kZKoxP: "xjm9jq1",
    kkqhue: "x12apyxo",
    k87sOh: "xuivejd",
    kVAEAm: "x10l6tqk",
    $$css: true
  },
  stepConnectorVertical: {
    kWkggS: "xzm8oiv",
    krVfgx: "xi2lk0m",
    kLqNvP: "xk3w2oy",
    kVAEAm: "x10l6tqk",
    k87sOh: "x12eol54",
    kzqmXN: "x1i1rx1s",
    $$css: true
  },
  stepMarker: {
    kGNEyG: "x6s0dn4",
    kWkggS: "x13zjy52",
    kVAM5u: "x1hza1xs",
    kaIpWk: "xv3pep",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kMwMTN: "xyu5t3h",
    k1xSpc: "x3nfvp2",
    kMv6JI: "x14t0e4u",
    kGuDYH: "x6a850q",
    k63SB2: "x1uflamq",
    kZKoxP: "x1fgtraw",
    kjj79g: "xl56j7k",
    kVAEAm: "x1n2onr6",
    kzqmXN: "xgd8bvy",
    kY2c9j: "x1vjfegm",
    $$css: true
  },
  stepCurrent: {
    kWkggS: "x34jowk",
    kVAM5u: "x1swbpd4",
    kMwMTN: "x9pa81l",
    $$css: true
  },
  stepComplete: {
    kWkggS: "x1x4pbqu",
    kVAM5u: "x1qm9elf",
    kMwMTN: "x15kbz4b",
    $$css: true
  },
  stepError: {
    kWkggS: "xve6jz8",
    kVAM5u: "xuj4g81",
    kMwMTN: "x1g3r7qa",
    $$css: true
  },
  stepButton: {
    kWkggS: "xjbqb8w",
    kMwMTN: "x1heor9g",
    kkrTdU: "x1ypdohk",
    k1xSpc: "xrvj5dj",
    kVVagm: "xln7xf2",
    kOIVth: "x195vfkc",
    k7Eaqz: "xeuugli",
    kmVPX3: "x1717udv",
    k9WMMc: "x1yc453h",
    $$css: true
  },
  stepCopyHorizontal: {
    kAPf3g: "x1o2pa38",
    k9WMMc: "x2b8uid",
    $$css: true
  },
  stepLabel: {
    kMwMTN: "x1ys4cjs",
    kMv6JI: "x14t0e4u",
    kGuDYH: "x1kio5tc",
    k63SB2: "x1b3j4lt",
    $$css: true
  },
  stepDescription: {
    kMwMTN: "xyu5t3h",
    kMv6JI: "x14t0e4u",
    kGuDYH: "xwdf1oc",
    kLWn49: "xgsdihv",
    $$css: true
  },
  toastViewport: {
    k1xSpc: "x78zum5",
    kOIVth: "x7agqhd",
    ks0D6T: "xleip2o",
    kfzvcC: "x47corl",
    kVAEAm: "xixxii4",
    kY2c9j: "x11uqc5h",
    $$css: true
  },
  toast: {
    kWkggS: "x1rnmz67",
    kVAM5u: "x1ubh2qd",
    kaIpWk: "x1c26gy3",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kGVxlE: "x13y627i",
    kMwMTN: "xl26v19",
    k1xSpc: "xrvj5dj",
    kOIVth: "x1kd3ua",
    k7Eaqz: "x1u2d2a2",
    kmVPX3: "x1szo1dz",
    kfzvcC: "x67bb7w",
    kIyJzY: "x1xy946n x12w9bfk",
    k1ekBW: "x6o7n8i",
    $$css: true
  },
  toastClosed: {
    kSiTet: "xg01cxk",
    k3aq6I: "x1l0rlnr",
    $$css: true
  },
  toastTitle: {
    kMv6JI: "x14t0e4u",
    kGuDYH: "x1kio5tc",
    k63SB2: "x1uflamq",
    $$css: true
  },
  toastDescription: {
    kMwMTN: "xyu5t3h",
    kMv6JI: "x14t0e4u",
    kGuDYH: "xwdf1oc",
    kLWn49: "xgsdihv",
    $$css: true
  },
  toastDismiss: {
    kWkggS: "xjbqb8w",
    kaIpWk: "x5i151u",
    kMwMTN: "xyu5t3h",
    kkrTdU: "x1ypdohk",
    kMv6JI: "x14t0e4u",
    kGuDYH: "xwdf1oc",
    kFhvOy: "x1qab1bc",
    kmVPX3: "xxzb6uj",
    $$css: true
  },
  toastSuccess: {
    kGJrpR: "xxiig1l",
    k2ei4v: "xct1zlm",
    $$css: true
  },
  toastWarning: {
    kGJrpR: "xzqreo",
    k2ei4v: "xct1zlm",
    $$css: true
  },
  toastError: {
    kGJrpR: "x15swkvv",
    k2ei4v: "xct1zlm",
    $$css: true
  },
  toastInfo: {
    kGJrpR: "x1aw6kym",
    k2ei4v: "xct1zlm",
    $$css: true
  }
};

// src/code-block.ts
var kindStyles = {
  plain: void 0,
  keyword: codeBlockStyles.keyword,
  string: codeBlockStyles.string,
  number: codeBlockStyles.number,
  comment: codeBlockStyles.comment,
  type: codeBlockStyles.type,
  property: codeBlockStyles.property,
  punctuation: codeBlockStyles.punctuation
};
var plainLines = code => code.split("\n").map(text2 => [{
  text: text2
}]);
var normalize = code => code.replace(/\r\n?/g, "\n").replace(/\n$/, "");
var writeClipboard = text2 => Effect.promise(() => globalThis.navigator?.clipboard === void 0 ? Promise.resolve(false) : globalThis.navigator.clipboard.writeText(text2).then(() => true, () => false));
var tokenView = (token, h) => {
  const style = kindStyles[token.kind ?? "plain"];
  return style === void 0 ? token.text : h.span(sxAttrs(h, style), [token.text]);
};
var copyButton = (copy, config, isFloating, h) => {
  const isCopied = copy.isCopied === true;
  const label2 = isCopied ? copy.copiedLabel ?? "Copied" : copy.label ?? "Copy";
  return h.button([...slotAttrs(config.slotProps?.copy, h, codeBlockStyles.copy, isFloating && codeBlockStyles.copyFloating), h.Type("button"), h.OnClick(copy.onCopy), h.AriaLabel(isCopied ? label2 : `${label2} ${config.title ?? "code"}`)], [view2({
    icon: isCopied ? Check : Copy,
    size: 14
  }, h), label2]);
};
var view6 = (config, h) => {
  const code = normalize(config.code);
  const lines = config.highlight === void 0 ? plainLines(code) : config.highlight(code, config.language);
  const heading2 = config.title ?? (config.copy === void 0 ? void 0 : config.language);
  const hasHeader = heading2 !== void 0;
  const numberWidth = `${String(lines.length).length}ch`;
  const children = config.lineNumbers === true || config.highlight !== void 0 ? lines.map((line, index) => h.span(sxAttrs(h, codeBlockStyles.line), [...(config.lineNumbers === true ? [h.span([...sxAttrs(h, codeBlockStyles.lineNumber), h.Style({
    minWidth: numberWidth
  }), h.AriaHidden(true)], [String(index + 1)])] : []), ...line.map(token => tokenView(token, h))])) : [code];
  return h.div([...rootAttrs(config, h, codeBlockStyles.root), ...(config.language === void 0 ? [] : [h.DataAttribute("language", config.language)])], [...(hasHeader ? [h.div(slotAttrs(config.slotProps?.header, h, codeBlockStyles.header), [h.span(slotAttrs(config.slotProps?.title, h, codeBlockStyles.title), [heading2]), ...(config.copy === void 0 ? [] : [copyButton(config.copy, config, false, h)])])] : config.copy === void 0 ? [] : [copyButton(config.copy, config, true, h)]), h.div([...slotAttrs(config.slotProps?.viewport, h, codeBlockStyles.viewport, config.maxHeight !== void 0 && codeBlockStyles.viewportFocusable), ...(config.maxHeight === void 0 ? [] : [h.Style({
    maxHeight: config.maxHeight
  }), h.Role("region"), h.AriaLabel(config.ariaLabel ?? config.title ?? "Code"), h.Tabindex(0)])], [h.pre(slotAttrs(config.slotProps?.pre, h, codeBlockStyles.pre, config.wrap === true && codeBlockStyles.wrap, !hasHeader && config.copy !== void 0 && codeBlockStyles.preFloatingCopy), [h.code(slotAttrs(config.slotProps?.code, h, codeBlockStyles.code), children)])]), ...(config.copy === void 0 ? [] : [h.span([...sxAttrs(h, contentStyles.visuallyHidden), h.Role("status")], [config.copy.isCopied === true ? config.copy.copiedLabel ?? "Copied" : ""])])]);
};

// src/description-list.ts
var description_list_exports = {};
__export(description_list_exports, {
  view: () => view7
});
var toChildren = content => typeof content === "string" ? [content] : content;
var isEmpty = value => value === void 0 || (typeof value === "string" ? value.trim() === "" : value.length === 0);
var valueView = (item2, config, h) => {
  if (isEmpty(item2.value)) {
    return h.dd(slotAttrs(config.slotProps?.value, h, descriptionListStyles.value, descriptionListStyles.empty), [config.emptyValue ?? "\u2014"]);
  }
  const children = toChildren(item2.value ?? []);
  switch (item2.format ?? "text") {
    case "code":
      return h.dd(slotAttrs(config.slotProps?.value, h, descriptionListStyles.value), [h.code(sxAttrs(h, descriptionListStyles.code, descriptionListStyles.codeChip), children)]);
    case "chips":
      return h.dd(slotAttrs(config.slotProps?.value, h, descriptionListStyles.value, descriptionListStyles.chips), children);
    case "muted":
      return h.dd(slotAttrs(config.slotProps?.value, h, descriptionListStyles.value, descriptionListStyles.muted), children);
    case "text":
      return h.dd(slotAttrs(config.slotProps?.value, h, descriptionListStyles.value), children);
  }
};
var view7 = (config, h) => {
  const horizontal = (config.layout ?? "horizontal") === "horizontal";
  const dividers = config.dividers === true;
  return h.dl([...rootAttrs(config, h, descriptionListStyles.root, config.size === "sm" && descriptionListStyles.sm, horizontal ? descriptionListStyles.horizontal : descriptionListStyles.stacked, dividers && descriptionListStyles.divided), ...(horizontal && config.termWidth !== void 0 ? [h.Style({
    gridTemplateColumns: `${config.termWidth} minmax(0, 1fr)`
  })] : [])], config.items.map((item2, index) => h.div(slotAttrs(config.slotProps?.row, h, horizontal ? descriptionListStyles.rowHorizontal : descriptionListStyles.rowStacked, dividers && descriptionListStyles.rowDivided, dividers && index > 0 && descriptionListStyles.rowDivider), [h.dt(slotAttrs(config.slotProps?.term, h, descriptionListStyles.term), toChildren(item2.term)), valueView(item2, config, h)])));
};

// src/disclosure.ts
var disclosure_exports = {};
__export(disclosure_exports, {
  view: () => view8
});
var view8 = (config, h) => Disclosure.view({
  id: config.id,
  isOpen: config.isOpen,
  onToggle: config.onToggle,
  ...(config.isDisabled === void 0 ? {} : {
    isDisabled: config.isDisabled
  }),
  toView: ({
    button,
    panel,
    animatePanel
  }) => h.div(rootAttrs(config, h, disclosureStyles.root), [h.button([...button, ...slotAttrs(config.slotProps?.trigger, h, disclosureStyles.trigger)], [config.label, h.span(slotAttrs(config.slotProps?.icon, h, disclosureStyles.icon, config.isOpen && disclosureStyles.iconOpen), [view2({
    icon: ChevronDown,
    size: 16
  }, h)])]), animatePanel(h.div([...panel, ...slotAttrs(config.slotProps?.panel, h, disclosureStyles.panel)], [h.div(slotAttrs(config.slotProps?.panelInner, h, disclosureStyles.panelInner), config.children)]))])
}, h);

// src/field.ts
var field_exports = {};
__export(field_exports, {
  group: () => group,
  input: () => input,
  select: () => select,
  textarea: () => textarea,
  view: () => view10
});

// src/read-only-value.ts
var read_only_value_exports = {};
__export(read_only_value_exports, {
  optionLabel: () => optionLabel,
  view: () => view9
});
var isEmpty2 = config => config.children === void 0 ? config.value === void 0 || config.value === "" : config.children.length === 0;
var emptyContent = (config, h) => config.emptyLabel === void 0 ? [h.span([h.AriaHidden(true)], ["\u2014"]), h.span(sxAttrs(h, contentStyles.visuallyHidden), ["No value"])] : [config.emptyLabel];
var view9 = (config, h) => {
  const empty2 = isEmpty2(config);
  const submitted = config.formValue ?? config.value ?? "";
  return h.div([...rootAttrs(config, h, readOnlyValueStyles.root, config.density === "compact" && readOnlyValueStyles.compact, config.isInvalid === true && readOnlyValueStyles.invalid), h.Role("textbox"), h.AriaReadonly(true), h.Tabindex(0), h.DataAttribute("readonly", "true"), h.DataAttribute("empty", empty2 ? "true" : "false"), ...(config.id === void 0 ? [] : [h.Id(config.id)]), ...(config.ariaLabel === void 0 ? [] : [h.AriaLabel(config.ariaLabel)]), ...(config.ariaLabelledBy === void 0 ? [] : [h.AriaLabelledBy(config.ariaLabelledBy)]), ...(config.ariaDescribedBy === void 0 ? [] : [h.AriaDescribedBy(config.ariaDescribedBy)]), ...(config.isMultiline === true ? [h.Attribute("aria-multiline", "true")] : []), ...(config.isInvalid === true ? [h.AriaInvalid(true)] : [])], [...(empty2 ? [h.span(slotAttrs(config.slotProps?.empty, h, readOnlyValueStyles.empty), emptyContent(config, h))] : config.children ?? [config.value ?? ""]), ...(config.name === void 0 ? [] : [h.input([...slotAttrs(config.slotProps?.hiddenInput, h), h.Type("hidden"), h.Name(config.name), h.Value(submitted)])])]);
};
var optionLabel = (value, options) => value === void 0 || value === "" ? void 0 : options.find(option => option.value === value)?.label ?? value;

// src/field.ts
var group = (config, h) => h.div(rootAttrs(config, h, fieldStyles.root), config.children);
var view10 = (config, h) => h.div([...rootAttrs(config, h, fieldStyles.root), h.DataAttribute("invalid", config.error === void 0 ? "false" : "true"), h.DataAttribute("disabled", config.isDisabled === true ? "true" : "false")], [h.label([h.For(config.id), ...slotAttrs(config.slotProps?.label, h, fieldStyles.label)], labelContent(config)), ...config.children, view4(config.error ?? config.description, [h.Id(`${config.id}-description`)], slotAttrs(config.slotProps?.description, h, fieldStyles.description, config.error !== void 0 && fieldStyles.error), h)]);
var labelContent = config => [config.label, ...(config.isRequired === true ? [" ", "*"] : [])];
var supportingText = config => config.error ?? config.description;
var valueField = (config, answer, h) => {
  const labelId = `${config.id}-label`;
  const descriptionId = `${config.id}-description`;
  const {
    name,
    ...visibleAnswer
  } = answer;
  return h.div(rootAttrs(config, h, fieldStyles.root), [h.span([h.Id(labelId), ...slotAttrs(config.slotProps?.label, h, fieldStyles.label)], labelContent(config)), view9({
    ...visibleAnswer,
    ...(name === void 0 || config.isDisabled === true ? {} : {
      name
    }),
    ...(config.slotProps?.control === void 0 ? {} : {
      slotProps: {
        root: config.slotProps.control
      }
    }),
    ...(config.density === void 0 ? {} : {
      density: config.density
    }),
    id: config.id,
    ariaLabelledBy: labelId,
    ariaDescribedBy: descriptionId,
    isInvalid: config.error !== void 0
  }, h), view4(supportingText(config), [h.Id(descriptionId)], slotAttrs(config.slotProps?.description, h, fieldStyles.description, config.error !== void 0 && fieldStyles.error), h)]);
};
var keyboardAttributes = (config, h) => config.onKeyDown === void 0 ? [] : [h.OnKeyDown((key2, modifiers) => config.onKeyDown?.(key2, modifiers))];
var hasAdornments = config => config.startAdornment !== void 0 || config.endAdornment !== void 0;
var adornment = (side, config, h) => {
  const children = side === "start" ? config.startAdornment : config.endAdornment;
  if (children === void 0) return void 0;
  const slot = side === "start" ? config.slotProps?.startAdornment : config.slotProps?.endAdornment;
  return h.span(slotAttrs(slot, h, fieldStyles.adornment), children);
};
var adornmentChildren = (side, config, h) => {
  const child = adornment(side, config, h);
  return child === void 0 ? [] : [child];
};
var inputControl = (config, attributes, h) => {
  const control3 = h.input([...attributes, ...keyboardAttributes(config, h), ...changeAttributes(config, h), ...slotAttrs(config.slotProps?.control, h, fieldStyles.control, hasAdornments(config) && fieldStyles.controlInWrapper, config.density === "compact" && fieldStyles.compact, !hasAdornments(config) && config.error !== void 0 && fieldStyles.invalid)]);
  if (!hasAdornments(config)) return control3;
  return h.div(slotAttrs(config.slotProps?.controlWrapper, h, fieldStyles.controlWrapper, config.error !== void 0 && fieldStyles.invalid), [...adornmentChildren("start", config, h), control3, ...adornmentChildren("end", config, h)]);
};
var changeAttributes = (config, h) => config.onChange === void 0 || config.isDisabled === true || config.isReadOnly === true ? [] : [h.OnChange(config.onChange)];
var input = (config, h) => config.presentation === "value" ? valueField(config, {
  ...(config.value === void 0 ? {} : {
    value: config.type === "password" && config.value !== "" ? "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022" : config.value,
    formValue: config.value
  }),
  ...(config.name === void 0 ? {} : {
    name: config.name
  })
}, h) : Input.view({
  id: config.id,
  ...(config.value === void 0 ? {} : {
    value: config.value
  }),
  ...(config.placeholder === void 0 ? {} : {
    placeholder: config.placeholder
  }),
  ...(config.type === void 0 ? {} : {
    type: config.type
  }),
  ...(config.name === void 0 ? {} : {
    name: config.name
  }),
  ...(config.onInput === void 0 ? {} : {
    onInput: config.onInput
  }),
  ...(config.isDisabled === void 0 ? {} : {
    isDisabled: config.isDisabled
  }),
  ...(config.isReadOnly === void 0 ? {} : {
    isReadOnly: config.isReadOnly
  }),
  hasDescription: true,
  isInvalid: config.error !== void 0,
  toView: attributes => h.div(rootAttrs(config, h, fieldStyles.root), [h.label([...attributes.label, ...slotAttrs(config.slotProps?.label, h, fieldStyles.label)], labelContent(config)), inputControl(config, attributes.input, h), view4(supportingText(config), attributes.description, slotAttrs(config.slotProps?.description, h, fieldStyles.description, config.error !== void 0 && fieldStyles.error), h)])
}, h);
var textareaControl = (config, attributes, h) => {
  const control3 = h.textarea([...attributes, ...keyboardAttributes(config, h), ...changeAttributes(config, h), ...(config.name === void 0 ? [] : [h.Name(config.name)]), ...(config.minRows === void 0 ? [] : [h.Style({
    minHeight: `calc(${config.minRows} * 1.5em + 20px)`
  })]), ...slotAttrs(config.slotProps?.control, h, fieldStyles.control, fieldStyles.textarea, hasAdornments(config) && fieldStyles.controlInWrapper, !hasAdornments(config) && config.error !== void 0 && fieldStyles.invalid)]);
  if (!hasAdornments(config)) return control3;
  return h.div(slotAttrs(config.slotProps?.controlWrapper, h, fieldStyles.controlWrapper, fieldStyles.textareaWrapper, config.error !== void 0 && fieldStyles.invalid), [...adornmentChildren("start", config, h), control3, ...adornmentChildren("end", config, h)]);
};
var textarea = (config, h) => {
  if (config.minRows !== void 0 && (!Number.isInteger(config.minRows) || config.minRows < 1)) {
    throw new Error("Field textarea minRows must be a positive integer.");
  }
  if (config.presentation === "value") {
    return valueField(config, {
      ...(config.value === void 0 ? {} : {
        value: config.value
      }),
      ...(config.name === void 0 ? {} : {
        name: config.name
      }),
      isMultiline: true
    }, h);
  }
  return Textarea.view({
    id: config.id,
    ...(config.value === void 0 ? {} : {
      value: config.value
    }),
    ...(config.placeholder === void 0 ? {} : {
      placeholder: config.placeholder
    }),
    ...(config.rows === void 0 ? {} : {
      rows: config.rows
    }),
    ...(config.onInput === void 0 ? {} : {
      onInput: config.onInput
    }),
    ...(config.isDisabled === void 0 ? {} : {
      isDisabled: config.isDisabled
    }),
    ...(config.isReadOnly === void 0 ? {} : {
      isReadOnly: config.isReadOnly
    }),
    hasDescription: true,
    isInvalid: config.error !== void 0,
    toView: attributes => h.div(rootAttrs(config, h, fieldStyles.root), [h.label([...attributes.label, ...slotAttrs(config.slotProps?.label, h, fieldStyles.label)], labelContent(config)), textareaControl(config, attributes.textarea, h), view4(supportingText(config), attributes.description, slotAttrs(config.slotProps?.description, h, fieldStyles.description, config.error !== void 0 && fieldStyles.error), h)])
  }, h);
};
var select = (config, h) => {
  if (config.presentation === "value") {
    const value = optionLabel(config.value, config.options);
    return valueField(config, {
      ...(value === void 0 ? {} : {
        value
      }),
      ...(config.value === void 0 ? {} : {
        formValue: config.value
      }),
      ...(config.name === void 0 ? {} : {
        name: config.name
      })
    }, h);
  }
  return Select.view({
    id: config.id,
    ...(config.value === void 0 ? {} : {
      value: config.value
    }),
    ...(config.onChange === void 0 ? {} : {
      onChange: config.onChange
    }),
    ...(config.isDisabled === void 0 ? {} : {
      isDisabled: config.isDisabled
    }),
    ...(config.name === void 0 ? {} : {
      name: config.name
    }),
    hasDescription: true,
    isInvalid: config.error !== void 0,
    toView: attributes => h.div(rootAttrs(config, h, fieldStyles.root), [h.label([...attributes.label, ...slotAttrs(config.slotProps?.label, h, fieldStyles.label)], labelContent(config)), h.select([...attributes.select, ...slotAttrs(config.slotProps?.control, h, fieldStyles.control, config.density === "compact" && fieldStyles.compact, config.error !== void 0 && fieldStyles.invalid)], config.options.map(option => h.option([h.Value(option.value), h.Selected(option.value === config.value)], [option.label]))), view4(supportingText(config), attributes.description, slotAttrs(config.slotProps?.description, h, fieldStyles.description, config.error !== void 0 && fieldStyles.error), h)])
  }, h);
};

// src/fieldset.ts
var fieldset_exports = {};
__export(fieldset_exports, {
  view: () => view11
});
var view11 = (config, h) => Fieldset.view({
  id: config.id,
  hasDescription: true,
  ...(config.isDisabled === void 0 ? {} : {
    isDisabled: config.isDisabled
  }),
  toView: attributes => h.fieldset([...attributes.fieldset, ...rootAttrs(config, h, fieldsetStyles.root, config.isDisabled === true && fieldsetStyles.disabled)], [h.legend([...attributes.legend, ...slotAttrs(config.slotProps?.legend, h, fieldsetStyles.legend)], [config.legend]), view4(config.description, attributes.description, slotAttrs(config.slotProps?.description, h, fieldsetStyles.description), h), h.div(slotAttrs(config.slotProps?.content, h, fieldsetStyles.content), config.children)])
}, h);

// src/layout.ts
var layout_exports = {};
__export(layout_exports, {
  Container: () => Container,
  Grid: () => Grid,
  Row: () => Row,
  Stack: () => Stack,
  container: () => container,
  grid: () => grid,
  row: () => row,
  stack: () => stack
});
var gapValues = {
  none: "0px",
  xs: space.xs,
  sm: space.sm,
  md: space.md,
  lg: space.lg,
  xl: space.xl
};
var alignValues = {
  stretch: "stretch",
  start: "flex-start",
  center: "center",
  end: "flex-end",
  baseline: "baseline"
};
var justifyValues = {
  start: "flex-start",
  center: "center",
  end: "flex-end",
  between: "space-between",
  around: "space-around",
  evenly: "space-evenly"
};
var responsive = (value, fallback) => value === void 0 ? {
  base: fallback
} : typeof value === "object" ? {
  base: fallback,
  ...value
} : {
  base: value
};
var variables = (name, value, fallback, serialize) => Object.fromEntries(Object.entries(responsive(value, fallback)).map(([breakpoint, entry]) => [`--foldworks-${name}-${breakpoint}`, serialize(entry)]));
var styles = {
  responsiveFlex: {
    k1xSpc: "x78zum5",
    kXwgrk: "x6mmjt6 x1ry8420 x1h3a2kk xashu3f xz4k8z5",
    kOIVth: "x1xwecaz xhoqi85 xc6lygl x9mc02i xsliblz",
    $$css: true
  },
  responsiveFlexContainer: {
    k1xSpc: "x78zum5",
    kXwgrk: "x6mmjt6 x147j506 xt888z9 xlu8uca x15wt7j5",
    kOIVth: "x1xwecaz x1fnvc1f x1sz25tm xt9jgn2 x11msk34",
    $$css: true
  },
  wrap: {
    kwnvtZ: "x1a02dak",
    $$css: true
  },
  container: {
    kUOVxO: "xvueqy4",
    ks0D6T: "xmp2du2",
    kzqmXN: "xh8yej3",
    kg3NbH: "xludzxn x1j6i9w x1ufk9jc x1vowml5 x1w9ak7g",
    $$css: true
  },
  queryContainer: {
    k9g6sI: "x12h1iku",
    $$css: true
  },
  grid: {
    k1xSpc: "xrvj5dj",
    kumcoG: "xxs5qly x15knk05 x9j9w7d x1vjgx1 xiob2qo",
    kOIVth: "x1xwecaz xhoqi85 xc6lygl x9mc02i xsliblz",
    $$css: true
  },
  gridContainer: {
    k1xSpc: "xrvj5dj",
    kumcoG: "xxs5qly x10o0ze4 x120bbwj x16q1p86 x1ck0rwn",
    kOIVth: "x1xwecaz x1fnvc1f x1sz25tm xt9jgn2 x11msk34",
    $$css: true
  },
  autoGrid: {
    kumcoG: "xi3txqw",
    $$css: true
  }
};
var flex = (config, h) => h.div([...rootAttrs(config, h, config.responsiveTo === "container" ? styles.responsiveFlexContainer : styles.responsiveFlex, config.wrap === true && styles.wrap), h.Style({
  ...variables("direction", config.direction, "column", String),
  ...variables("gap", config.gap, "md", gap => gapValues[gap]),
  alignItems: alignValues[config.align ?? "stretch"],
  justifyContent: justifyValues[config.justify ?? "start"]
})], config.children);
var stack = (config, h) => flex({
  ...config,
  direction: config.direction ?? "column"
}, h);
var row = (config, h) => flex({
  ...config,
  direction: config.direction ?? "row",
  align: config.align ?? "center"
}, h);
var container = (config, h) => h.div([...rootAttrs(config, h, styles.container, config.query === true && styles.queryContainer), h.Style({
  "--foldworks-container-width": contentWidths[config.size ?? "xl"],
  ...variables("padding", config.padding, "lg", gap => gapValues[gap])
})], config.children);
var grid = (config, h) => {
  const columnValues = responsive(config.columns, 1);
  for (const count of Object.values(columnValues)) {
    if (!Number.isInteger(count) || count < 1 || count > 12) throw new Error("Layout.grid columns must be integers from 1 through 12.");
  }
  return h.div([...rootAttrs(config, h, config.responsiveTo === "container" ? styles.gridContainer : styles.grid, config.minColumnWidth !== void 0 && styles.autoGrid), h.Style({
    ...variables("columns", config.columns, 1, String),
    ...variables("gap", config.gap, "md", gap => gapValues[gap]),
    ...(config.minColumnWidth === void 0 ? {} : {
      "--foldworks-column-min": config.minColumnWidth
    }),
    alignItems: config.align ?? "stretch"
  })], config.children);
};
var Container = {
  view: container
};
var Grid = {
  view: grid
};
var Stack = {
  view: stack
};
var Row = {
  view: row
};

// src/legend.ts
var legend_exports = {};
__export(legend_exports, {
  view: () => view12
});
var swatchStyles = (shape, fill) => shape === "line" ? [legendStyles.swatch, legendStyles.line, fill === "dashed" || fill === "outline" ? legendStyles.lineDashed : legendStyles.solid] : [legendStyles.swatch, legendStyles[shape], legendStyles[fill]];
var markerView = (marker2, config, h) => {
  const colorAttrs = [...slotAttrs(config.slotProps?.marker, h, legendStyles.marker, toneColorStyles[marker2.tone ?? "neutral"]), ...(marker2.color === void 0 ? [] : [h.Style({
    color: marker2.color
  })]), h.AriaHidden(true)];
  switch (marker2.kind) {
    case "swatch":
      return h.span(colorAttrs, [h.span(sxAttrs(h, ...swatchStyles(marker2.shape ?? "square", marker2.fill ?? "solid")))]);
    case "symbol":
      return h.span(colorAttrs, [h.span(sxAttrs(h, legendStyles.symbol), [marker2.symbol])]);
    case "icon":
      return h.span(colorAttrs, [view2({
        icon: marker2.icon,
        size: 14
      }, h)]);
  }
};
var view12 = (config, h) => h.ul([...rootAttrs(config, h, legendStyles.root, config.orientation === "vertical" ? legendStyles.vertical : legendStyles.horizontal), h.Role("list"), h.AriaLabel(config.ariaLabel ?? "Legend")], config.items.map(item2 => h.li(slotAttrs(config.slotProps?.item, h, legendStyles.item, item2.description !== void 0 && legendStyles.itemWithDescription), [markerView(item2.marker, config, h), h.span(sxAttrs(h, legendStyles.copy), [h.span(sxAttrs(h, legendStyles.labelRow), [h.span(slotAttrs(config.slotProps?.label, h), [item2.label]), ...(item2.value === void 0 ? [] : [h.span(slotAttrs(config.slotProps?.value, h, legendStyles.value), [item2.value])])]), ...(item2.description === void 0 ? [] : [h.span(slotAttrs(config.slotProps?.description, h, legendStyles.description), [item2.description])])])])));

// src/workspace.ts
var workspace_exports = {};
__export(workspace_exports, {
  Message: () => Message,
  Model: () => Model,
  currentSize: () => currentSize,
  init: () => init,
  maximumSize: () => maximumSize,
  update: () => update,
  view: () => view13
});
var Model = Schema.Struct({
  id: Schema.String,
  orientation: Schema.Literals(["Horizontal", "Vertical"]),
  side: Schema.Literals(["Start", "End"]),
  size: Schema.Number,
  minSize: Schema.Number,
  maxSize: Schema.Number,
  secondaryMinSize: Schema.Number,
  collapsible: Schema.Boolean,
  collapsed: Schema.Boolean,
  extent: Schema.Number
});
var Message = defineMessageUnion({
  Resized: {
    size: Schema.Number
  },
  CancelledResize: {
    size: Schema.Number
  },
  Measured: {
    extent: Schema.Number
  },
  Toggled: {},
  Focused: {}
});
var handleSize = 8;
var clamp2 = (value, min, max) => Math.max(min, Math.min(max, value));
var init = config => {
  const model = {
    orientation: "Horizontal",
    side: "Start",
    size: 260,
    minSize: 160,
    maxSize: 600,
    secondaryMinSize: 240,
    collapsible: true,
    collapsed: false,
    ...config,
    extent: 0
  };
  if (!model.id || ![model.size, model.minSize, model.maxSize, model.secondaryMinSize].every(Number.isFinite) || model.minSize < 0 || model.secondaryMinSize < 0 || model.maxSize < model.minSize) {
    throw new Error("Workspace requires an ID and finite, nonnegative, ordered size limits.");
  }
  return {
    ...model,
    size: clamp2(model.size, model.minSize, model.maxSize),
    collapsed: model.collapsible && model.collapsed
  };
};
var maximumSize = model => model.extent > 0 ? Math.max(model.minSize, Math.min(model.maxSize, model.extent - model.secondaryMinSize - handleSize)) : model.maxSize;
var currentSize = model => model.collapsed ? 0 : clamp2(model.size, model.minSize, maximumSize(model));
var FocusSplitter = Command.define("FocusWorkspaceSplitter", {
  args: {
    id: Schema.String
  },
  messages: [Message.Focused],
  execute: ({
    id
  }) => Dom.focus(`#${CSS.escape(id)}-splitter`).pipe(Effect.ignore, Effect.as(Message.Focused()))
});
var update = (model, message3) => Message.match(message3, {
  Resized: ({
    size
  }) => ({
    model: Number.isFinite(size) ? {
      ...model,
      size: clamp2(size, model.minSize, maximumSize(model)),
      collapsed: false
    } : model
  }),
  CancelledResize: ({
    size
  }) => ({
    model: Number.isFinite(size) ? {
      ...model,
      size: clamp2(size, model.minSize, model.maxSize)
    } : model
  }),
  Measured: ({
    extent
  }) => ({
    model: Number.isFinite(extent) && extent > 0 && extent !== model.extent ? {
      ...model,
      extent
    } : model
  }),
  Toggled: () => model.collapsible ? {
    model: {
      ...model,
      collapsed: !model.collapsed
    },
    commands: [FocusSplitter({
      id: model.id
    })]
  } : {
    model
  },
  Focused: () => ({
    model
  })
});
var ObserveSplitter = Mount.defineStream("ObserveWorkspaceSplitter", {
  messages: [Message.Resized, Message.CancelledResize, Message.Measured, Message.Toggled],
  execute: ({
    element
  }) => Stream.callback(queue => Effect.gen(function* () {
    yield* Effect.acquireRelease(Effect.sync(() => {
      const handle = element;
      const track = handle.parentElement;
      let drag;
      const emit = message3 => Queue.offerUnsafe(queue, message3);
      const horizontal = () => handle.dataset.axis === "Horizontal";
      const sign = () => (handle.dataset.side === "End" ? -1 : 1) * (horizontal() && getComputedStyle(track).direction === "rtl" ? -1 : 1);
      const number = key3 => Number(handle.dataset[key3]);
      const measure = () => emit(Message.Measured({
        extent: horizontal() ? track.clientWidth : track.clientHeight
      }));
      const finish = cancel2 => {
        if (!drag) return;
        const previous = drag;
        drag = void 0;
        if (cancel2) emit(Message.CancelledResize({
          size: previous.preferred
        }));
        if (handle.hasPointerCapture(previous.pointer)) handle.releasePointerCapture(previous.pointer);
      };
      const down = event => {
        if (!event.isPrimary || event.button !== 0 || handle.dataset.collapsed === "true" || drag) return;
        event.preventDefault();
        handle.focus();
        drag = {
          pointer: event.pointerId,
          coordinate: horizontal() ? event.clientX : event.clientY,
          size: number("size"),
          preferred: number("preferred")
        };
        handle.setPointerCapture(event.pointerId);
      };
      const move = event => {
        if (!drag || drag.pointer !== event.pointerId) return;
        if (handle.dataset.collapsed === "true") {
          finish(false);
          return;
        }
        const coordinate = horizontal() ? event.clientX : event.clientY;
        emit(Message.Resized({
          size: drag.size + (coordinate - drag.coordinate) * sign()
        }));
      };
      const up = event => {
        if (drag?.pointer === event.pointerId) {
          move(event);
          finish(false);
        }
      };
      const cancel = event => {
        if (drag?.pointer === event.pointerId) finish(true);
      };
      const lost = () => finish(false);
      const key2 = event => {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        const previous = horizontal() ? "ArrowLeft" : "ArrowUp";
        const next = horizontal() ? "ArrowRight" : "ArrowDown";
        let message3;
        if (event.key === "Escape" && drag) {
          event.preventDefault();
          finish(true);
          return;
        }
        if (event.key === "Enter" && handle.dataset.collapsible === "true") message3 = Message.Toggled();else if (event.key === "Home") message3 = Message.Resized({
          size: number("min")
        });else if (event.key === "End") message3 = Message.Resized({
          size: number("max")
        });else if (event.key === previous || event.key === next) message3 = Message.Resized({
          size: number("size") + (event.key === next ? 1 : -1) * sign() * (event.shiftKey ? 50 : 10)
        });
        if (message3) {
          event.preventDefault();
          emit(message3);
        }
      };
      handle.addEventListener("pointerdown", down);
      handle.addEventListener("pointermove", move);
      handle.addEventListener("pointerup", up);
      handle.addEventListener("pointercancel", cancel);
      handle.addEventListener("lostpointercapture", lost);
      handle.addEventListener("keydown", key2);
      const observer = new ResizeObserver(measure);
      observer.observe(track);
      const axisObserver = new MutationObserver(measure);
      axisObserver.observe(handle, {
        attributes: true,
        attributeFilter: ["data-axis"]
      });
      measure();
      return () => {
        handle.removeEventListener("pointerdown", down);
        handle.removeEventListener("pointermove", move);
        handle.removeEventListener("pointerup", up);
        handle.removeEventListener("pointercancel", cancel);
        handle.removeEventListener("lostpointercapture", lost);
        handle.removeEventListener("keydown", key2);
        observer.disconnect();
        axisObserver.disconnect();
        if (drag && handle.hasPointerCapture(drag.pointer)) handle.releasePointerCapture(drag.pointer);
        drag = void 0;
      };
    }), dispose => Effect.sync(dispose));
    return yield* Effect.never;
  }))
});
var styles2 = {
  root: {
    k1xSpc: "xrvj5dj",
    k9llMU: "x5o4joa",
    kumcoG: "x1mkdm3x",
    kAzted: "x2lwn1j",
    k7Eaqz: "xeuugli",
    kZKoxP: "x5yr21d",
    kVQacm: "xysyzu8",
    $$css: true
  },
  track: {
    k1xSpc: "xrvj5dj",
    k7Eaqz: "xeuugli",
    kAzted: "x2lwn1j",
    $$css: true
  },
  pane: {
    k1xSpc: "xrvj5dj",
    k9llMU: "x16p6thf",
    k7Eaqz: "xeuugli",
    kAzted: "x2lwn1j",
    kVQacm: "xb3r6kr",
    kWkggS: "x187ughu",
    $$css: true
  },
  header: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kOIVth: "x167g77z",
    kjj79g: "x1qughib",
    kmVPX3: "x153ncpu",
    k7Eaqz: "xeuugli",
    kWkggS: "xuggeig",
    $$css: true
  },
  label: {
    kGuDYH: "x1j6dyjg",
    k63SB2: "x1s688f",
    kogj98: "x1ghz6dp",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  body: {
    kAzted: "x2lwn1j",
    k7Eaqz: "xeuugli",
    kVQacm: "xysyzu8",
    kZeWKH: "xish69e",
    $$css: true
  },
  contained: {
    k1xSpc: "xrvj5dj",
    kumcoG: "x1mkdm3x",
    k9llMU: "x5o4joa",
    kVQacm: "xb3r6kr",
    $$css: true
  },
  handle: {
    kWkggS: "xann9gu x1ies4cx xknkj98",
    kFalU9: "x5ve5x3",
    kfSwDN: "x87ps6o",
    kI3sdo: "x1a2a7pz x15852t7",
    kInvED: "x2ssjo2",
    kkrTdU: "xicojor",
    kY2c9j: "x1vjfegm",
    $$css: true
  },
  verticalHandle: {
    kkrTdU: "xyozgr7",
    $$css: true
  }
};
var view13 = (config, h) => {
  const {
    model,
    toParentMessage
  } = config;
  const horizontal = model.orientation === "Horizontal";
  const size = currentSize(model);
  const primaryId = `${model.id}-primary`;
  const dimensions = [`${size}px`, `${handleSize}px`, `minmax(${model.secondaryMinSize}px, 1fr)`];
  if (model.side === "End") dimensions.reverse();
  const minimum = (model.collapsed ? 0 : model.minSize) + model.secondaryMinSize + handleSize;
  const placement2 = position => horizontal ? {
    gridColumn: String(position),
    gridRow: "1"
  } : {
    gridRow: String(position),
    gridColumn: "1"
  };
  const pane = (value, primary2) => {
    const showHeader = value.showHeader !== false || !primary2 && model.collapsed && model.collapsible;
    return h.section([...sxAttrs(h, styles2.pane), h.Id(primary2 ? primaryId : `${model.id}-secondary`), h.AriaLabel(value.label),
    // Preserve mounted children and their state while removing hidden controls from focus order.
    h.Style({
      ...placement2(primary2 === (model.side === "Start") ? 1 : 3),
      gridTemplateRows: showHeader ? "auto minmax(0, 1fr)" : "minmax(0, 1fr)",
      ...(primary2 && model.collapsed ? {
        display: "none"
      } : {})
    })], [...(showHeader ? [h.div(sxAttrs(h, styles2.header), [h.h2(sxAttrs(h, styles2.label), [value.label]), ...((primary2 || model.collapsed) && model.collapsible ? [view3({
      label: `${model.collapsed ? "Show" : "Hide"} ${config.primary.label}`,
      variant: "ghost",
      size: "xs",
      onClick: toParentMessage(Message.Toggled())
    }, h)] : [])])] : []), h.div(sxAttrs(h, styles2.body, value.scroll === "Contained" && styles2.contained), value.children)]);
  };
  const primary = pane(config.primary, true);
  const secondary = pane(config.secondary, false);
  const handle = h.div([...sxAttrs(h, styles2.handle, !horizontal && styles2.verticalHandle), h.Style(placement2(2)), h.Id(`${model.id}-splitter`), h.Role("separator"), h.Tabindex(0), h.AriaLabel(config.primary.label), h.AriaControls(primaryId), h.AriaOrientation(horizontal ? "vertical" : "horizontal"), h.AriaValuemin(model.collapsible ? 0 : model.minSize), h.AriaValuemax(maximumSize(model)), h.AriaValuenow(size), h.AriaValuetext(model.collapsed ? "Collapsed" : `${Math.round(size)} pixels`), h.DataAttribute("axis", model.orientation), h.DataAttribute("side", model.side), h.DataAttribute("size", String(size)), h.DataAttribute("preferred", String(model.size)), h.DataAttribute("min", String(model.minSize)), h.DataAttribute("max", String(maximumSize(model))), h.DataAttribute("collapsed", String(model.collapsed)), h.DataAttribute("collapsible", String(model.collapsible)), h.OnMount(Mount.mapMessage(ObserveSplitter(), toParentMessage))], []);
  return h.div([...sxAttrs(h, styles2.root), h.DataAttribute("workspace", model.id)], [h.div([...sxAttrs(h, styles2.track), h.Style(horizontal ? {
    gridTemplateColumns: dimensions.join(" "),
    gridTemplateRows: "minmax(0, 1fr)",
    minWidth: `${minimum}px`
  } : {
    gridTemplateRows: dimensions.join(" "),
    gridTemplateColumns: "minmax(0, 1fr)",
    minHeight: `${minimum}px`
  })], model.side === "Start" ? [primary, handle, secondary] : [secondary, handle, primary])]);
};

// src/split-view.ts
var split_view_exports = {};
__export(split_view_exports, {
  columnTemplate: () => columnTemplate,
  view: () => view14
});
var gapValues2 = {
  none: "0px",
  xs: space.xs,
  sm: space.sm,
  md: space.md,
  lg: space.lg,
  xl: space.xl
};
var collapsed = {
  "--foldworks-split-position": "static",
  "--foldworks-split-max-height": "none",
  "--foldworks-split-overflow": "visible",
  "--foldworks-split-resize": "none",
  "--foldworks-split-fill": "100%",
  "--foldworks-split-offstage": "none"
};
var split = {
  gridTemplateColumns: "var(--foldworks-split-columns)",
  gridTemplateRows: "var(--foldworks-split-rows)",
  "--foldworks-split-position": "sticky",
  "--foldworks-split-max-height": "calc(100dvh - var(--foldworks-split-offset))",
  "--foldworks-split-overflow": "auto",
  "--foldworks-split-resize": "horizontal",
  "--foldworks-split-fill": "0px",
  "--foldworks-split-offstage": "block"
};
var styles3 = {
  root: {
    kGNEyG: "x1qjc9v5",
    k1xSpc: "xrvj5dj",
    kumcoG: "x1mkdm3x",
    kAzted: "x2lwn1j",
    k7Eaqz: "xeuugli",
    "--foldworks-split-offset": "x1lzdi6i",
    "--foldworks-split-rows": "x1wm5loc",
    "--foldworks-split-position": "x1xat3a3",
    "--foldworks-split-max-height": "xyta9j3",
    "--foldworks-split-overflow": "xoml8ba",
    "--foldworks-split-resize": "x16tzv8l",
    "--foldworks-split-fill": "x13vxqlq",
    "--foldworks-split-offstage": "xexqvwn",
    $$css: true
  },
  always: {
    kumcoG: "x14723vd",
    k9llMU: "xtw5fwa",
    "--foldworks-split-position": "xi293ah",
    "--foldworks-split-max-height": "xvcm6q",
    "--foldworks-split-overflow": "x1f3sgqr",
    "--foldworks-split-resize": "xrd7ko3",
    "--foldworks-split-fill": "xsbuym6",
    "--foldworks-split-offstage": "x1gpcf1f",
    $$css: true
  },
  viewportSm: {
    kumcoG: "x1mkdm3x x17cl2y6",
    k9llMU: "x15fl5r4 xny61i4",
    "--foldworks-split-position": "x1xat3a3 x1b3nl6e",
    "--foldworks-split-max-height": "xyta9j3 x12x6fy9",
    "--foldworks-split-overflow": "xoml8ba xz30r2x",
    "--foldworks-split-resize": "x16tzv8l xxv0vla",
    "--foldworks-split-fill": "x13vxqlq x1iy222r",
    "--foldworks-split-offstage": "xexqvwn x19a95qf",
    $$css: true
  },
  viewportMd: {
    kumcoG: "x1mkdm3x x19ge09s",
    k9llMU: "x15fl5r4 x1dekttx",
    "--foldworks-split-position": "x1xat3a3 xnwspfh",
    "--foldworks-split-max-height": "xyta9j3 x1esxjfm",
    "--foldworks-split-overflow": "xoml8ba xqygbvg",
    "--foldworks-split-resize": "x16tzv8l xqbs0f",
    "--foldworks-split-fill": "x13vxqlq x1gokeqs",
    "--foldworks-split-offstage": "xexqvwn xd4wj3n",
    $$css: true
  },
  viewportLg: {
    kumcoG: "x1mkdm3x xmq2425",
    k9llMU: "x15fl5r4 xxkbh77",
    "--foldworks-split-position": "x1xat3a3 x1jindka",
    "--foldworks-split-max-height": "xyta9j3 x1f9bmy6",
    "--foldworks-split-overflow": "xoml8ba x8038ww",
    "--foldworks-split-resize": "x16tzv8l xlcecy1",
    "--foldworks-split-fill": "x13vxqlq x149foa1",
    "--foldworks-split-offstage": "xexqvwn x1i0kr2y",
    $$css: true
  },
  viewportXl: {
    kumcoG: "x1mkdm3x x1ytgy6u",
    k9llMU: "x15fl5r4 x1ey9xog",
    "--foldworks-split-position": "x1xat3a3 x1spz40j",
    "--foldworks-split-max-height": "xyta9j3 x1brplu5",
    "--foldworks-split-overflow": "xoml8ba x1ea3jyy",
    "--foldworks-split-resize": "x16tzv8l x8vl2h3",
    "--foldworks-split-fill": "x13vxqlq xhjj2s6",
    "--foldworks-split-offstage": "xexqvwn x85rbve",
    $$css: true
  },
  containerSm: {
    kumcoG: "x1mkdm3x xm7sij8",
    k9llMU: "x15fl5r4 x19xc970",
    "--foldworks-split-position": "x1xat3a3 x1u9mmgo",
    "--foldworks-split-max-height": "xyta9j3 x1kcss28",
    "--foldworks-split-overflow": "xoml8ba x1ophyox",
    "--foldworks-split-resize": "x16tzv8l xsbow20",
    "--foldworks-split-fill": "x13vxqlq x59f923",
    "--foldworks-split-offstage": "xexqvwn xn1kf87",
    $$css: true
  },
  containerMd: {
    kumcoG: "x1mkdm3x x1pa3bpp",
    k9llMU: "x15fl5r4 xq96vbr",
    "--foldworks-split-position": "x1xat3a3 x1glmi5w",
    "--foldworks-split-max-height": "xyta9j3 x1kgmabd",
    "--foldworks-split-overflow": "xoml8ba xej8qiq",
    "--foldworks-split-resize": "x16tzv8l x4z9luz",
    "--foldworks-split-fill": "x13vxqlq xulclee",
    "--foldworks-split-offstage": "xexqvwn x1dq0dnt",
    $$css: true
  },
  containerLg: {
    kumcoG: "x1mkdm3x x1tgi6di",
    k9llMU: "x15fl5r4 x1eq2siu",
    "--foldworks-split-position": "x1xat3a3 x12s5dy6",
    "--foldworks-split-max-height": "xyta9j3 xuiqcfy",
    "--foldworks-split-overflow": "xoml8ba x1v3a5n9",
    "--foldworks-split-resize": "x16tzv8l xz8o6i",
    "--foldworks-split-fill": "x13vxqlq xb1j59w",
    "--foldworks-split-offstage": "xexqvwn xg32sjs",
    $$css: true
  },
  containerXl: {
    kumcoG: "x1mkdm3x xnnucas",
    k9llMU: "x15fl5r4 x1kufxi6",
    "--foldworks-split-position": "x1xat3a3 x7i89qe",
    "--foldworks-split-max-height": "xyta9j3 x19jq6a8",
    "--foldworks-split-overflow": "xoml8ba xuv43no",
    "--foldworks-split-resize": "x16tzv8l xzd88ar",
    "--foldworks-split-fill": "x13vxqlq xn24fcy",
    "--foldworks-split-offstage": "xexqvwn x6vofvg",
    $$css: true
  },
  fill: {
    kZKoxP: "x5yr21d",
    kVQacm: "xysyzu8",
    kZeWKH: "xish69e",
    "--foldworks-split-rows": "x1og8z0c",
    $$css: true
  },
  pane: {
    kAzted: "x2lwn1j",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  scrolls: {
    kVQacm: "x1f49v4",
    kZeWKH: "xish69e",
    k6w4Gs: "xux9d8k",
    k5wCbM: "x1597r2g",
    $$css: true
  },
  sticky: {
    kSGwAc: "x1y8v6su",
    kskxy: "xti4pnt",
    kVAEAm: "x13lito1",
    k87sOh: "x1yhduxr",
    $$css: true
  },
  resizable: {
    ks0D6T: "x1shxtee",
    k7Eaqz: "x1hq730c",
    kHenm0: "x17psln0",
    kzqmXN: "xgz2b8z",
    $$css: true
  },
  offstage: {
    k1xSpc: "x1ewk2fm",
    $$css: true
  }
};
var breakpointStyles = {
  viewport: {
    sm: styles3.viewportSm,
    md: styles3.viewportMd,
    lg: styles3.viewportLg,
    xl: styles3.viewportXl
  },
  container: {
    sm: styles3.containerSm,
    md: styles3.containerMd,
    lg: styles3.containerLg,
    xl: styles3.containerXl
  }
};
var defaultTrack = "minmax(0, 1fr)";
var defaultResizableWidth = "320px";
var columnTemplate = panes => panes.map(pane => isResizable(pane) ? "auto" : pane.width ?? defaultTrack).join(" ");
var isResizable = pane => pane.resizable !== void 0 && pane.resizable !== false;
var validate = config => {
  if (config.panes.length < 2 || config.panes.length > 3) {
    throw new Error("SplitView requires two or three panes.");
  }
  const keys = config.panes.flatMap(pane => pane.key === void 0 ? [] : [pane.key]);
  if (new Set(keys).size !== keys.length) throw new Error("SplitView pane keys must be unique.");
  if (config.collapsedPane !== void 0 && !keys.includes(config.collapsedPane)) {
    throw new Error("SplitView collapsedPane must match a pane key.");
  }
};
var view14 = (config, h) => {
  validate(config);
  const collapseBelow = config.collapseBelow ?? "md";
  const fill = config.height === "fill";
  const pane = (value, index) => {
    const resizable2 = isResizable(value);
    const scrolls = fill || value.sticky === true || resizable2;
    const limits = typeof value.resizable === "object" ? value.resizable : {};
    const tag = value.label === void 0 ? "div" : "section";
    const attributes = [...(config.slotProps?.pane?.attributes ?? []), ...(value.attributes ?? []), ...sxAttrs(h, styles3.pane, scrolls && styles3.scrolls, !fill && value.sticky === true && styles3.sticky, resizable2 && styles3.resizable, config.slotProps?.pane?.sx, value.sx, config.collapsedPane !== void 0 && value.key !== config.collapsedPane && styles3.offstage), h.DataAttribute("split-pane", value.key ?? String(index + 1)), ...(value.label === void 0 ? [] : [h.AriaLabel(value.label), ...(scrolls ? [h.Tabindex(0)] : [])]), ...(resizable2 ? [h.Style({
      "--foldworks-split-pane-width": value.width ?? defaultResizableWidth,
      "--foldworks-split-pane-min": limits.minWidth ?? "0px",
      "--foldworks-split-pane-max": limits.maxWidth ?? "100%"
    })] : [])];
    if (value.key !== void 0) return h.keyed(tag)(value.key, attributes, value.children);
    return tag === "section" ? h.section(attributes, value.children) : h.div(attributes, value.children);
  };
  return h.div([...rootAttrs(config, h, styles3.root, collapseBelow === "never" ? styles3.always : breakpointStyles[config.responsiveTo ?? "viewport"][collapseBelow], fill && styles3.fill), h.DataAttribute("split-view", String(config.panes.length)), ...(config.ariaLabel === void 0 ? [] : [h.Role("group"), h.AriaLabel(config.ariaLabel)]), h.Style({
    "--foldworks-split-columns": columnTemplate(config.panes),
    columnGap: gapValues2[config.gap ?? "lg"],
    rowGap: gapValues2[config.gap ?? "lg"],
    ...(config.stickyOffset === void 0 ? {} : {
      "--foldworks-split-offset": config.stickyOffset
    })
  })], config.panes.map(pane));
};

// src/app-header.ts
var app_header_exports = {};
__export(app_header_exports, {
  view: () => view15
});
var spin = "x1fy8ia8-B";
var pulse = "x17v254d-B";
var catalogStyles = {
  focusable: {
    kI3sdo: "x1a2a7pz x6454uj",
    kInvED: "x1wfwxd8",
    $$css: true
  },
  surface: {
    kWkggS: "x13zjy52",
    kVAM5u: "x1ubh2qd",
    kaIpWk: "x1c26gy3",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kMwMTN: "x2pdk8c",
    $$css: true
  },
  inset: {
    kWkggS: "x16z3jmj",
    kVAM5u: "x1ubh2qd",
    kaIpWk: "x3wpolg",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    $$css: true
  },
  alert: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x1kd3ua",
    kmVPX3: "x1szo1dz",
    $$css: true
  },
  alertDanger: {
    kWkggS: "xve6jz8",
    kVAM5u: "x1j3i1cz",
    kMwMTN: "x1g3r7qa",
    $$css: true
  },
  title: {
    kMwMTN: "x1heor9g",
    kMv6JI: "x14t0e4u",
    kGuDYH: "xif65rj",
    k63SB2: "x1s688f",
    kLWn49: "xwn7fz2",
    $$css: true
  },
  description: {
    kMwMTN: "xyu5t3h",
    kMv6JI: "x14t0e4u",
    kGuDYH: "x4z9k3i",
    kLWn49: "x1evy7pa",
    $$css: true
  },
  aspectRatio: {
    kVQacm: "xb3r6kr",
    kVAEAm: "x1n2onr6",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  aspectRatioContent: {
    kZKoxP: "x5yr21d",
    kpwlN0: "x10a8y8t",
    kVAEAm: "x10l6tqk",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  avatar: {
    kGNEyG: "x6s0dn4",
    kWkggS: "x16z3jmj",
    kVAM5u: "x1ubh2qd",
    kaIpWk: "xv3pep",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kMwMTN: "xyu5t3h",
    k1xSpc: "x3nfvp2",
    kmuXW: "x2lah0s",
    kMv6JI: "x14t0e4u",
    kGuDYH: "xfifm61",
    k63SB2: "x1s688f",
    kZKoxP: "x10w6t97",
    kjj79g: "xl56j7k",
    kVQacm: "xb3r6kr",
    kzqmXN: "x1td3qas",
    $$css: true
  },
  avatarSm: {
    kZKoxP: "xxk0z11",
    kzqmXN: "xvy4d1p",
    kGuDYH: "x1k6wstc",
    $$css: true
  },
  avatarLg: {
    kZKoxP: "x1vqgdyp",
    kzqmXN: "x100vrsf",
    kGuDYH: "xif65rj",
    $$css: true
  },
  avatarImage: {
    kZKoxP: "x5yr21d",
    kVIFPx: "xl1xv1r",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  breadcrumb: {
    kGNEyG: "x6s0dn4",
    kMwMTN: "xyu5t3h",
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kMv6JI: "x14t0e4u",
    kGuDYH: "x4z9k3i",
    kOIVth: "x7agqhd",
    kB88ic: "xe8uvvx",
    $$css: true
  },
  breadcrumbItem: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x3nfvp2",
    kOIVth: "x7agqhd",
    $$css: true
  },
  breadcrumbLink: {
    kMwMTN: "xyu5t3h x1t0a7xc",
    kybGjl: "x1hl2dhg",
    $$css: true
  },
  breadcrumbButton: {
    kWkggS: "xjbqb8w",
    kkrTdU: "x1ypdohk",
    kVVagm: "xln7xf2",
    kmVPX3: "x1717udv",
    $$css: true
  },
  breadcrumbOverflow: {
    k7Eaqz: "x1et6avd",
    k9WMMc: "x2b8uid",
    $$css: true
  },
  breadcrumbCurrent: {
    kMwMTN: "x1ys4cjs",
    k63SB2: "x1b3j4lt",
    $$css: true
  },
  card: {
    kGVxlE: "x1irw62u",
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kVQacm: "xb3r6kr",
    $$css: true
  },
  cardHeader: {
    kGNEyG: "x7a106z",
    k1xSpc: "xrvj5dj",
    kOIVth: "x1ngs94h",
    kumcoG: "xju1xpo",
    kmVPX3: "xnr84m0",
    $$css: true
  },
  cardHeading: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x1kd3ua",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  cardAction: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    kjj79g: "x13a6bvl",
    $$css: true
  },
  cardContent: {
    kmVPX3: "x1tamke2",
    $$css: true
  },
  cardFooter: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    kOIVth: "x7agqhd",
    kmVPX3: "xbpthk9",
    $$css: true
  },
  cardHeaderFlush: {
    kGO01o: "x1l90r2v",
    $$css: true
  },
  cardContentFlush: {
    kmVPX3: "x1717udv",
    $$css: true
  },
  cardFooterFlush: {
    kLKAdn: "xyamay9",
    $$css: true
  },
  separatorHorizontal: {
    kWkggS: "xzm8oiv",
    kZKoxP: "xjm9jq1",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  separatorVertical: {
    kSGwAc: "xkh2ocl",
    kWkggS: "xzm8oiv",
    kAzted: "x1hshjfz",
    kzqmXN: "x1i1rx1s",
    $$css: true
  },
  item: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    kOIVth: "x1ngs94h",
    kmVPX3: "x1szo1dz",
    $$css: true
  },
  itemMedia: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    kmuXW: "x2lah0s",
    kjj79g: "xl56j7k",
    $$css: true
  },
  itemContent: {
    k1xSpc: "xrvj5dj",
    kUk6DE: "x98rzlu",
    kOIVth: "x195vfkc",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  kbd: {
    kGNEyG: "x6s0dn4",
    kWkggS: "x16z3jmj",
    kVAM5u: "x1ubh2qd",
    kaIpWk: "x5i151u",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kGVxlE: "xeyionm",
    kMwMTN: "xyu5t3h",
    k1xSpc: "x3nfvp2",
    kMv6JI: "x17yh6e0",
    kGuDYH: "x1j6dyjg",
    k63SB2: "x1b3j4lt",
    kZKoxP: "x1qx5ct2",
    kjj79g: "xl56j7k",
    k7Eaqz: "xt4ypqs",
    kmVPX3: "xld7i00",
    $$css: true
  },
  empty: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x7agqhd",
    kmVPX3: "xcywksr",
    k9WMMc: "x2b8uid",
    $$css: true
  },
  emptyMedia: {
    kGNEyG: "x6s0dn4",
    kWkggS: "x16z3jmj",
    kaIpWk: "xv3pep",
    k1xSpc: "x78zum5",
    kZKoxP: "x1vqgdyp",
    kjj79g: "xl56j7k",
    kzqmXN: "x100vrsf",
    $$css: true
  },
  progress: {
    kWkggS: "x16z3jmj",
    kaIpWk: "xv3pep",
    kZKoxP: "xdk7pt",
    kVQacm: "xb3r6kr",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  progressIndicator: {
    kWkggS: "x34jowk",
    kaIpWk: "xv3pep",
    kZKoxP: "x5yr21d",
    kIyJzY: "x6xk6gu",
    k1ekBW: "xxrbq2n",
    kAMwcw: "xe36upo",
    $$css: true
  },
  progressSm: {
    kZKoxP: "xqu0tyb",
    $$css: true
  },
  progressSuccess: {
    kWkggS: "xboa406",
    $$css: true
  },
  progressWarning: {
    kWkggS: "x19pixho",
    $$css: true
  },
  progressDanger: {
    kWkggS: "xl36y09",
    $$css: true
  },
  progressInfo: {
    kWkggS: "x1txx7ec",
    $$css: true
  },
  progressMeter: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    kOIVth: "x7agqhd",
    k7Eaqz: "xeuugli",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  progressTrack: {
    kUk6DE: "x98rzlu",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  progressCaption: {
    kMwMTN: "xyu5t3h",
    kmuXW: "x2lah0s",
    kMv6JI: "x14t0e4u",
    kGuDYH: "xwdf1oc",
    kcqcaj: "xss6m8b",
    kLWn49: "xo5v014",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  skeleton: {
    k44tkh: "x18hd8ej",
    ko0y90: "xa4qsjk",
    kKVMdj: "x103vr27 x1aquc0h",
    kyAemX: "x4hg4is",
    kWkggS: "x16z3jmj",
    kaIpWk: "x3wpolg",
    kZKoxP: "xlup9mm",
    k7Eaqz: "xeuugli",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  skeletonText: {
    kaIpWk: "x5i151u",
    kZKoxP: "xlzyvqe",
    $$css: true
  },
  skeletonCircle: {
    kaIpWk: "xv3pep",
    kmuXW: "x2lah0s",
    kZKoxP: "x1vqgdyp",
    kzqmXN: "x100vrsf",
    $$css: true
  },
  loadingStatic: {
    kKVMdj: "x1a5igra",
    $$css: true
  },
  spinner: {
    k44tkh: "xof6966",
    ko0y90: "xa4qsjk",
    kKVMdj: "xpedhrg x1aquc0h",
    kyAemX: "x1esw782",
    kVAM5u: "x1ubh2qd",
    kaIpWk: "xv3pep",
    ksu8eU: "x1y0btm7",
    kLZC3w: "xwsb29g",
    kMzoRj: "xdh2fpr",
    k1xSpc: "x1rg5ohu",
    kB7OPa: "x9f619",
    kmuXW: "x2lah0s",
    kZKoxP: "xlup9mm",
    kzqmXN: "x1kky2od",
    $$css: true
  },
  spinnerXs: {
    kZKoxP: "x1kpxq89",
    kzqmXN: "xsmyaan",
    $$css: true
  },
  spinnerMd: {
    kZKoxP: "xxk0z11",
    kzqmXN: "xvy4d1p",
    $$css: true
  },
  spinnerLg: {
    kMzoRj: "x9r2w2z",
    kZKoxP: "x10w6t97",
    kzqmXN: "x1td3qas",
    $$css: true
  },
  loader: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x3nfvp2",
    kOIVth: "x7agqhd",
    kVAEAm: "x1n2onr6",
    $$css: true
  },
  loaderBlock: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kjj79g: "xl56j7k",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  loaderContent: {
    kzqmXN: "xh8yej3",
    $$css: true
  },
  loaderLabel: {
    kMwMTN: "xyu5t3h",
    kMv6JI: "x14t0e4u",
    kGuDYH: "xwdf1oc",
    kLWn49: "x1evy7pa",
    $$css: true
  },
  control: {
    kWkggS: "x1f6rtwf",
    kVAM5u: "x15nqw3 x62ilj7",
    kaIpWk: "x3wpolg",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kMwMTN: "x1heor9g",
    kMv6JI: "x14t0e4u",
    kGuDYH: "xif65rj",
    kAzted: "x21xpn4",
    kmVPX3: "xk61eof",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  textarea: {
    kLWn49: "x1evy7pa",
    kAzted: "x1ujl9rh",
    kHenm0: "x288g5",
    $$css: true
  },
  label: {
    kMwMTN: "x1ys4cjs",
    k1xSpc: "x1rg5ohu",
    kMv6JI: "x14t0e4u",
    kGuDYH: "xif65rj",
    k63SB2: "x1b3j4lt",
    $$css: true
  },
  inputGroup: {
    kGNEyG: "x1qjc9v5",
    k1xSpc: "x78zum5",
    kVQacm: "xb3r6kr",
    $$css: true
  },
  inputGroupControl: {
    kaIpWk: "x2u8bby",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  inputGroupAddon: {
    kGNEyG: "x6s0dn4",
    kMwMTN: "xyu5t3h",
    k1xSpc: "x3nfvp2",
    kmuXW: "x2lah0s",
    kMv6JI: "x14t0e4u",
    kGuDYH: "x4z9k3i",
    kmVPX3: "x1p3i4rr",
    $$css: true
  },
  otp: {
    k1xSpc: "x78zum5",
    kOIVth: "x7agqhd",
    $$css: true
  },
  radioGroup: {
    ksu8eU: "xng3xce",
    kMzoRj: "xc342km",
    k1xSpc: "xrvj5dj",
    kOIVth: "x7agqhd",
    kogj98: "x1ghz6dp",
    kmVPX3: "x1717udv",
    $$css: true
  },
  radioItem: {
    kGNEyG: "x6s0dn4",
    kMwMTN: "x1ys4cjs",
    k1xSpc: "x78zum5",
    kMv6JI: "x14t0e4u",
    kGuDYH: "xif65rj",
    kOIVth: "x7agqhd",
    $$css: true
  },
  radioControl: {
    keaTxX: "xmusadi",
    kZKoxP: "xlup9mm",
    kzqmXN: "x1kky2od",
    $$css: true
  },
  range: {
    keaTxX: "xmusadi",
    kkrTdU: "x1ypdohk",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  toggle: {
    kGNEyG: "x6s0dn4",
    kWkggS: "xjbqb8w x7pwlv5",
    kVAM5u: "x9r1u3d",
    kaIpWk: "x3wpolg",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kMwMTN: "xyu5t3h",
    kkrTdU: "x1ypdohk",
    k1xSpc: "x3nfvp2",
    kMv6JI: "x14t0e4u",
    kGuDYH: "x4z9k3i",
    k63SB2: "x1b3j4lt",
    kZKoxP: "x10w6t97",
    kjj79g: "xl56j7k",
    kmVPX3: "x1p3i4rr",
    $$css: true
  },
  togglePressed: {
    kWkggS: "x16z3jmj",
    kMwMTN: "x1ys4cjs",
    $$css: true
  },
  toggleAttention: {
    kMwMTN: "x1ys4cjs",
    $$css: true
  },
  toggleDisabled: {
    kkrTdU: "x1h6gzvc",
    kSiTet: "xbyyjgo",
    $$css: true
  },
  group: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x3nfvp2",
    $$css: true
  },
  groupConnected: {
    kaIpWk: "x2u8bby",
    koQZXg: "xh9i6ac",
    $$css: true
  },
  groupFirst: {
    kqGeR4: "x18yxi80",
    kIxVMA: "x1yvtzww",
    koQZXg: "xj3b58b",
    $$css: true
  },
  groupLast: {
    kYm2EN: "xuucmwi",
    ksF3WI: "x1g8l7pg",
    $$css: true
  },
  tabs: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x1ngs94h",
    $$css: true
  },
  tabsList: {
    kGNEyG: "x6s0dn4",
    kWkggS: "x16z3jmj",
    kaIpWk: "x1c26gy3",
    k1xSpc: "x3nfvp2",
    kOIVth: "x195vfkc",
    kmVPX3: "x9ms5i6",
    kzqmXN: "xeq5yr9",
    $$css: true
  },
  tabsTrigger: {
    kWkggS: "xjbqb8w",
    kaIpWk: "x3wpolg",
    kMwMTN: "xyu5t3h",
    kkrTdU: "x1ypdohk",
    kMv6JI: "x14t0e4u",
    kGuDYH: "x4z9k3i",
    k63SB2: "x1b3j4lt",
    kAzted: "xe0p6wg",
    kmVPX3: "x1p3i4rr",
    $$css: true
  },
  tabsTriggerActive: {
    kWkggS: "x13zjy52",
    kGVxlE: "xeyionm",
    kMwMTN: "x1ys4cjs",
    $$css: true
  },
  pagination: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    kOIVth: "x1jnr06f",
    kjj79g: "xl56j7k",
    $$css: true
  },
  pageButton: {
    kGNEyG: "x6s0dn4",
    kWkggS: "xjbqb8w x7pwlv5",
    kVAM5u: "x9r1u3d",
    kaIpWk: "x3wpolg",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kMwMTN: "x1ys4cjs",
    kkrTdU: "x1ypdohk",
    k1xSpc: "x3nfvp2",
    kMv6JI: "x14t0e4u",
    kGuDYH: "x4z9k3i",
    kZKoxP: "x10w6t97",
    kjj79g: "xl56j7k",
    k7Eaqz: "x46jg8d",
    kmVPX3: "x1xq1gxn",
    $$css: true
  },
  pageButtonCurrent: {
    kWkggS: "x13zjy52",
    kVAM5u: "x1ubh2qd",
    kGVxlE: "xeyionm",
    $$css: true
  },
  nav: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kOIVth: "x1kd3ua",
    kB88ic: "xe8uvvx",
    $$css: true
  },
  navLink: {
    kWkggS: "xjbqb8w x7pwlv5",
    kaIpWk: "x3wpolg",
    kMwMTN: "x1ys4cjs",
    k1xSpc: "x3nfvp2",
    kMv6JI: "x14t0e4u",
    kGuDYH: "x4z9k3i",
    k63SB2: "x1b3j4lt",
    kmVPX3: "x2lkgqm",
    kybGjl: "x1hl2dhg",
    $$css: true
  },
  sidebar: {
    kWkggS: "xgcb8oj",
    kVAM5u: "x146cwo5",
    kaIpWk: "x1c26gy3",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kMwMTN: "x5ophwf",
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x1ngs94h",
    k7Eaqz: "x12rczxh",
    kmVPX3: "x1szo1dz",
    $$css: true
  },
  sidebarGroup: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x1kd3ua",
    $$css: true
  },
  sidebarLabel: {
    kMwMTN: "xyu5t3h",
    kMv6JI: "x14t0e4u",
    kGuDYH: "x1j6dyjg",
    k63SB2: "x1s688f",
    kb6lSQ: "x1vyo3qp",
    kP9fke: "xtvhhri",
    $$css: true
  },
  sidebarItem: {
    kWkggS: "xjbqb8w x10fb3xt",
    kaIpWk: "x3wpolg",
    kMwMTN: "x5ophwf",
    k1xSpc: "x78zum5",
    kMv6JI: "x14t0e4u",
    kGuDYH: "x4z9k3i",
    kOIVth: "x7agqhd",
    kmVPX3: "xup17s2",
    kybGjl: "x1hl2dhg",
    $$css: true
  },
  sidebarItemCurrent: {
    kWkggS: "xcgw1mj",
    kMwMTN: "xac5jj8",
    k63SB2: "x1b3j4lt",
    $$css: true
  },
  sidebarButton: {
    kGNEyG: "x6s0dn4",
    ksu8eU: "xng3xce",
    kMzoRj: "xc342km",
    kkrTdU: "x1ypdohk",
    k9WMMc: "x1yc453h",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  sidebarCount: {
    keTefX: "xvc5jky",
    $$css: true
  },
  tabBar: {
    kGNEyG: "x6s0dn4",
    kL6WhQ: "xqhy64d",
    kfdmCh: "x1q0q8m5",
    kt9PQ7: "xso031l",
    k1xSpc: "x78zum5",
    kOIVth: "x1ngs94h",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  tabBarList: {
    kGNEyG: "x1qjc9v5",
    k1xSpc: "x78zum5",
    kUk6DE: "x98rzlu",
    kOIVth: "x1kd3ua",
    kB88ic: "xe8uvvx",
    kogj98: "x1ghz6dp",
    k7Eaqz: "xeuugli",
    kXHlph: "xw2csxc",
    kmVPX3: "x1717udv",
    $$css: true
  },
  tabBarItem: {
    k1xSpc: "x78zum5",
    $$css: true
  },
  tabBarTab: {
    kGNEyG: "x6s0dn4",
    kWkggS: "xjbqb8w",
    kaIpWk: "x2u8bby",
    ksu8eU: "xng3xce",
    kMzoRj: "xc342km",
    kGVxlE: "x1gnnqk1",
    kMwMTN: "xyu5t3h x1t0a7xc",
    kkrTdU: "x1ypdohk",
    k1xSpc: "x3nfvp2",
    kMv6JI: "x14t0e4u",
    kGuDYH: "x1kio5tc",
    k63SB2: "x1b3j4lt",
    kOIVth: "x7agqhd",
    kAzted: "x1vx9w35",
    kInvED: "x1v57pqu",
    k8WAf4: "xt970qd",
    kg3NbH: "x6n740t",
    kybGjl: "x1hl2dhg",
    kIyJzY: "x1xy946n",
    k1ekBW: "x12tmelf",
    kAMwcw: "xe36upo",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  tabBarTabCurrent: {
    kGVxlE: "xajgrh3",
    kMwMTN: "x1ys4cjs",
    $$css: true
  },
  tabBarTabDisabled: {
    kMwMTN: "xyu5t3h",
    kkrTdU: "x1h6gzvc",
    $$css: true
  },
  tabBarLabelDisabled: {
    kSiTet: "x197sbye",
    $$css: true
  },
  tabBarHint: {
    kMwMTN: "xyu5t3h",
    kGuDYH: "xwdf1oc",
    k63SB2: "xo1l8bm",
    $$css: true
  },
  tabBarBadge: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x3nfvp2",
    kOIVth: "x1kd3ua",
    $$css: true
  },
  tabBarTrailing: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    kmuXW: "x2lah0s",
    kOIVth: "x7agqhd",
    keTefX: "xvc5jky",
    k8WAf4: "x1qwmx4p",
    $$css: true
  },
  count: {
    kGNEyG: "x6s0dn4",
    kVAM5u: "x1ubh2qd",
    kaIpWk: "xv3pep",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kMwMTN: "xyu5t3h",
    k1xSpc: "x3nfvp2",
    kMv6JI: "x14t0e4u",
    kGuDYH: "x6a850q",
    kcqcaj: "xss6m8b",
    k63SB2: "x1b3j4lt",
    kZKoxP: "xlup9mm",
    kjj79g: "xl56j7k",
    kLWn49: "xo5v014",
    k7Eaqz: "x15kz4h8",
    kg3NbH: "x187qg2c",
    $$css: true
  },
  attentionDot: {
    kWkggS: "x19pixho",
    kaIpWk: "xv3pep",
    k1xSpc: "x1rg5ohu",
    kmuXW: "x2lah0s",
    kZKoxP: "xols6we",
    kzqmXN: "x1v4s8kt",
    $$css: true
  },
  withAdornments: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x3nfvp2",
    kOIVth: "x1kd3ua",
    $$css: true
  },
  overlay: {
    kGNEyG: "x6s0dn4",
    kWkggS: "x1ccwxe3",
    k1xSpc: "x78zum5",
    kpwlN0: "x10a8y8t",
    kjj79g: "xl56j7k",
    kmVPX3: "xaodzvu",
    kVAEAm: "xixxii4",
    $$css: true
  },
  dialog: {
    kWkggS: "xjbqb8w",
    kZKoxP: "x5yr21d",
    kpwlN0: "x10a8y8t",
    kogj98: "x1ghz6dp",
    kskxy: "x7ab17h",
    ks0D6T: "x1x1rfll",
    kmVPX3: "x1717udv",
    kVAEAm: "xixxii4",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  dialogBackdrop: {
    kWkggS: "xjbqb8w",
    kkrTdU: "xt0e3qv",
    kpwlN0: "x10a8y8t",
    kVAEAm: "x10l6tqk",
    $$css: true
  },
  dialogPanel: {
    kWkggS: "x13zjy52",
    kVAM5u: "x1ubh2qd",
    kaIpWk: "x1c26gy3",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kGVxlE: "x13y627i",
    kMwMTN: "x1ys4cjs",
    k1xSpc: "xrvj5dj",
    kOIVth: "x1ngs94h",
    ks0D6T: "x1pfbilc",
    kmVPX3: "xaodzvu",
    kVAEAm: "x1n2onr6",
    kzqmXN: "x1rnx0d2",
    $$css: true
  },
  dialogHeader: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x1kd3ua",
    $$css: true
  },
  dialogFooter: {
    k1xSpc: "x78zum5",
    kOIVth: "x7agqhd",
    kjj79g: "x13a6bvl",
    $$css: true
  },
  sheetPanel: {
    kaIpWk: "x2u8bby",
    kZKoxP: "x5yr21d",
    koQZXg: "x8x9d4c",
    ks0D6T: "x1lr1uin",
    $$css: true
  },
  drawerPanel: {
    kSGwAc: "xpvyfi4",
    kqGeR4: "xfrllxf",
    kYm2EN: "xjppbhk",
    ks0D6T: "x1x1rfll",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  floating: {
    kWkggS: "x13zjy52",
    kVAM5u: "x1ubh2qd",
    kaIpWk: "x3wpolg",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kGVxlE: "x13y627i",
    kMwMTN: "x1ys4cjs",
    k7Eaqz: "xfb3i0g",
    kmVPX3: "x1a2zjlo",
    kVAEAm: "x1n2onr6",
    $$css: true
  },
  menu: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x195vfkc",
    kB88ic: "xe8uvvx",
    kogj98: "x1ghz6dp",
    kmVPX3: "xfawy5m",
    $$css: true
  },
  menuItem: {
    kGNEyG: "x6s0dn4",
    kWkggS: "xjbqb8w x7pwlv5",
    kaIpWk: "x5i151u",
    kMwMTN: "x1ys4cjs",
    kkrTdU: "x1ypdohk",
    k1xSpc: "x78zum5",
    kMv6JI: "x14t0e4u",
    kGuDYH: "x4z9k3i",
    kOIVth: "x7agqhd",
    kAzted: "x1rz828m",
    kmVPX3: "x8lhhth",
    k9WMMc: "xdpxx8g",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  menuLabel: {
    kMwMTN: "xyu5t3h",
    kMv6JI: "x14t0e4u",
    kGuDYH: "x1j6dyjg",
    k63SB2: "x1s688f",
    kmVPX3: "x18tqr4w",
    $$css: true
  },
  tooltip: {
    kWkggS: "x6rnbls",
    kaIpWk: "x5i151u",
    kMwMTN: "x67xtmn",
    kMv6JI: "x14t0e4u",
    kGuDYH: "xfifm61",
    kmVPX3: "x8lhhth",
    kzqmXN: "xeq5yr9",
    $$css: true
  },
  command: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x7agqhd",
    kVQacm: "xb3r6kr",
    $$css: true
  },
  commandList: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x195vfkc",
    kskxy: "x1xiyphd",
    kORKVm: "x1odjw0f",
    $$css: true
  },
  scrollArea: {
    kVQacm: "xysyzu8",
    k6w4Gs: "xux9d8k",
    k5wCbM: "x1597r2g",
    $$css: true
  },
  resizable: {
    kAzted: "x1edz59j",
    k7Eaqz: "x5w4yej",
    kVQacm: "xysyzu8",
    kHenm0: "x8za3yd",
    $$css: true
  },
  carousel: {
    k1xSpc: "x78zum5",
    kOIVth: "x1ngs94h",
    kXHlph: "xw2csxc",
    kc424l: "xhfbhpw",
    k5wCbM: "x1597r2g",
    $$css: true
  },
  carouselItem: {
    kUk6DE: "x1g0r1qb",
    k5xd4v: "x1bhewko",
    $$css: true
  },
  calendar: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x7agqhd",
    kzqmXN: "x1dz1jew",
    $$css: true
  },
  calendarHeader: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    kjj79g: "x1qughib",
    $$css: true
  },
  calendarGrid: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x195vfkc",
    kumcoG: "x1mzazjb",
    $$css: true
  },
  calendarCell: {
    kGNEyG: "x6s0dn4",
    kWkggS: "xjbqb8w x7pwlv5",
    kaIpWk: "x5i151u",
    kMwMTN: "x1ys4cjs",
    kkrTdU: "x1ypdohk",
    k1xSpc: "x78zum5",
    kMv6JI: "x14t0e4u",
    kGuDYH: "xfifm61",
    kZKoxP: "x10w6t97",
    kjj79g: "xl56j7k",
    $$css: true
  },
  calendarCellSelected: {
    kWkggS: "x34jowk",
    kMwMTN: "x9pa81l",
    $$css: true
  },
  tableWrap: {
    kXHlph: "xw2csxc",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  table: {
    kLvRdT: "x1mwwwfo",
    kMv6JI: "x14t0e4u",
    kGuDYH: "x4z9k3i",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  tableHead: {
    kL6WhQ: "xqhy64d",
    kfdmCh: "x1q0q8m5",
    kt9PQ7: "xso031l",
    kMwMTN: "xyu5t3h",
    k63SB2: "x1b3j4lt",
    kmVPX3: "x1160tuk",
    k9WMMc: "xdpxx8g",
    $$css: true
  },
  tableCell: {
    kL6WhQ: "xqhy64d",
    kfdmCh: "x1q0q8m5",
    kt9PQ7: "xso031l",
    kMwMTN: "x1ys4cjs",
    kmVPX3: "x1uzaqoa",
    $$css: true
  },
  chart: {
    kGNEyG: "xpqajaz",
    k1xSpc: "x78zum5",
    kOIVth: "x7agqhd",
    kZKoxP: "x1wkxgih",
    kLKAdn: "x1i8l2lm",
    $$css: true
  },
  chartBar: {
    kWkggS: "x1snyutt",
    kaIpWk: "x19m2704",
    kUk6DE: "x98rzlu",
    k7Eaqz: "x15kz4h8",
    $$css: true
  },
  message: {
    kGNEyG: "x1cy8zhl",
    k1xSpc: "x78zum5",
    kOIVth: "x7agqhd",
    $$css: true
  },
  messageOwn: {
    kXwgrk: "x15zctf7",
    $$css: true
  },
  bubble: {
    kWkggS: "x16z3jmj",
    kaIpWk: "x1c26gy3",
    kMwMTN: "x1ys4cjs",
    kMv6JI: "x14t0e4u",
    kGuDYH: "x4z9k3i",
    kLWn49: "x1evy7pa",
    ks0D6T: "x14r61f",
    kmVPX3: "x1r1m0to",
    $$css: true
  },
  bubbleOwn: {
    kWkggS: "x34jowk",
    kMwMTN: "x9pa81l",
    $$css: true
  },
  marker: {
    kWkggS: "x1fyvr3y",
    kaIpWk: "x5i151u",
    kMwMTN: "xegcg24",
    kmVPX3: "x1nyoefi",
    $$css: true
  },
  attachment: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    kOIVth: "x7agqhd",
    kmVPX3: "x1160tuk",
    $$css: true
  },
  messageScroller: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x1ngs94h",
    kskxy: "x1iuus0c",
    kORKVm: "x1odjw0f",
    khEr5k: "xkcv6ua",
    $$css: true
  }
};

// src/adornments.ts
var countView = (count, label2, slot, h, ...extra) => h.span([...slotAttrs(slot, h, catalogStyles.count, ...extra), h.DataAttribute("count", String(count))], label2 === void 0 ? [String(count)] : [h.span([h.AriaHidden(true)], [String(count)]), h.span(slotAttrs(void 0, h, contentStyles.visuallyHidden), [label2])]);
var attentionView = (label2, slot, h) => [h.span([...slotAttrs(slot, h, catalogStyles.attentionDot), h.AriaHidden(true)]), h.span(slotAttrs(void 0, h, contentStyles.visuallyHidden), [label2])];
var hasAdornments2 = option => option.count !== void 0 || option.badge !== void 0 || option.needsAttention === true;
var optionAdornments = (option, slots, h) => [...(option.count === void 0 ? [] : [countView(option.count, option.countLabel, slots?.count, h)]), ...(option.badge === void 0 ? [] : [h.span(slotAttrs(slots?.badge, h, catalogStyles.withAdornments), option.badge)]), ...(option.needsAttention === true ? attentionView(option.attentionLabel ?? "Needs attention", slots?.attention, h) : [])];

// src/navigation.ts
var collapseBreadcrumbItems = (items, current, options = {}) => {
  const entries = [...items.map(item2 => ({
    kind: "item",
    item: item2
  })), {
    kind: "current",
    label: current
  }];
  if (options.maxItems === void 0) return entries;
  if (!Number.isInteger(options.maxItems) || options.maxItems < 1) {
    throw new Error("Breadcrumb maxItems must be a positive integer.");
  }
  if (entries.length <= options.maxItems) return entries;
  const before = options.itemsBeforeCollapse ?? 1;
  const after = options.itemsAfterCollapse ?? 1;
  if (!Number.isInteger(before) || !Number.isInteger(after) || before < 0 || after < 1) {
    throw new Error("Breadcrumb collapse counts must use non-negative before and positive after values.");
  }
  if (before + after + 1 > options.maxItems) {
    throw new Error("Breadcrumb maxItems must fit itemsBeforeCollapse, itemsAfterCollapse, and the overflow item.");
  }
  const hiddenCount = entries.length - before - after;
  return [...entries.slice(0, before), {
    kind: "overflow",
    hiddenCount
  }, ...entries.slice(entries.length - after)];
};
var breadcrumb = (config, h) => {
  const entries = collapseBreadcrumbItems(config.items, config.current, config);
  const separator2 = () => h.span([...slotAttrs(config.slotProps?.separator, h), h.AriaHidden(true)], [config.separator ?? "/"]);
  const actionable = item2 => {
    if (item2.href !== void 0) return h.a([...slotAttrs(config.slotProps?.link, h, catalogStyles.breadcrumbLink, catalogStyles.focusable), h.Href(item2.href), ...(item2.onClick === void 0 ? [] : [h.OnClick(item2.onClick)])], [item2.label]);
    if (item2.onClick !== void 0) return h.button([...slotAttrs(config.slotProps?.link, h, catalogStyles.breadcrumbLink, catalogStyles.focusable, catalogStyles.breadcrumbButton), h.Type("button"), h.OnClick(item2.onClick)], [item2.label]);
    return h.span(slotAttrs(config.slotProps?.link, h, catalogStyles.breadcrumbLink, catalogStyles.focusable), [item2.label]);
  };
  return h.nav([...rootAttrs(config, h), h.AriaLabel(config.ariaLabel ?? "Breadcrumb")], [h.ol(slotAttrs(config.slotProps?.list, h, catalogStyles.breadcrumb), entries.map((entry, index) => {
    if (entry.kind === "current") return h.li([...slotAttrs(config.slotProps?.current, h, catalogStyles.breadcrumbCurrent), h.AriaCurrent("page")], [entry.label]);
    const content = entry.kind === "item" ? actionable(entry.item) : config.onExpand === void 0 ? h.span([...slotAttrs(config.slotProps?.overflow, h, catalogStyles.breadcrumbOverflow), h.AriaLabel(`${entry.hiddenCount} hidden breadcrumb items`)], [config.overflowLabel ?? "\u2026"]) : h.button([...slotAttrs(config.slotProps?.overflow, h, catalogStyles.breadcrumbLink, catalogStyles.breadcrumbButton, catalogStyles.breadcrumbOverflow), h.Type("button"), h.AriaLabel(`Show ${entry.hiddenCount} hidden breadcrumb items`), h.OnClick(config.onExpand)], [config.overflowLabel ?? "\u2026"]);
    return h.li(slotAttrs(config.slotProps?.item, h, catalogStyles.breadcrumbItem), [content, ...(index === entries.length - 1 ? [] : [separator2()])]);
  }))]);
};
var pagination = (config, h) => {
  const pages = Array.from({
    length: config.pageCount
  }, (_, index) => index + 1);
  return h.nav([...styledAttrs(config, h), h.AriaLabel(config.ariaLabel ?? "Pagination")], [h.div(sxAttrs(h, catalogStyles.pagination), [h.button([...sxAttrs(h, catalogStyles.pageButton, catalogStyles.focusable), h.Type("button"), h.AriaLabel("Previous page"), h.Disabled(config.page <= 1), h.OnClick(config.onChange(Math.max(1, config.page - 1)))], ["Previous"]), ...pages.map(page => h.button([...sxAttrs(h, catalogStyles.pageButton, catalogStyles.focusable, page === config.page && catalogStyles.pageButtonCurrent), h.Type("button"), h.AriaLabel(`Page ${page}`), h.AriaCurrent(page === config.page ? "page" : "false"), h.OnClick(config.onChange(page))], [String(page)])), h.button([...sxAttrs(h, catalogStyles.pageButton, catalogStyles.focusable), h.Type("button"), h.AriaLabel("Next page"), h.Disabled(config.page >= config.pageCount), h.OnClick(config.onChange(Math.min(config.pageCount, config.page + 1)))], ["Next"])])]);
};
var tabs = (config, h) => h.div(styledAttrs(config, h, catalogStyles.tabs), [h.div([...sxAttrs(h, catalogStyles.tabsList), h.Role("tablist"), h.AriaLabel(config.ariaLabel ?? "Tabs")], config.tabs.map(tab => h.button([...sxAttrs(h, catalogStyles.tabsTrigger, catalogStyles.focusable, tab.value === config.value && catalogStyles.tabsTriggerActive), h.Type("button"), h.Role("tab"), h.Id(`${config.id}-tab-${tab.value}`), h.AriaControls(`${config.id}-panel-${tab.value}`), h.AriaSelected(tab.value === config.value), h.Tabindex(tab.value === config.value ? 0 : -1), h.Disabled(tab.isDisabled === true), h.OnClick(config.onChange(tab.value))], [tab.label]))), ...config.tabs.map(tab => h.div([h.Role("tabpanel"), h.Id(`${config.id}-panel-${tab.value}`), h.AriaLabelledBy(`${config.id}-tab-${tab.value}`), h.Hidden(tab.value !== config.value), h.Tabindex(0)], tab.content))]);
var navigationMenu = (config, h) => h.nav([...styledAttrs(config, h), h.AriaLabel(config.ariaLabel ?? "Primary navigation")], [h.ul(sxAttrs(h, catalogStyles.nav), config.items.map(item2 => h.li([], [h.a([...sxAttrs(h, catalogStyles.navLink, catalogStyles.focusable), h.Href(item2.href)], [item2.label])])))]);
var sidebarItem = (item2, h) => {
  const isCurrent = item2.isCurrent === true;
  const attributes = isButton => [...sxAttrs(h, catalogStyles.sidebarItem, catalogStyles.focusable, isButton && catalogStyles.sidebarButton, isCurrent && catalogStyles.sidebarItemCurrent), h.AriaCurrent(isCurrent ? "page" : "false")];
  const children = [...(item2.media === void 0 ? [] : [item2.media]), item2.label, ...(item2.count === void 0 ? [] : [countView(item2.count, item2.countLabel, void 0, h, catalogStyles.sidebarCount)])];
  if (item2.href !== void 0) return h.a([...attributes(false), h.Href(item2.href), ...(item2.onClick === void 0 ? [] : [h.OnClick(item2.onClick)])], children);
  if (item2.onClick !== void 0) return h.button([...attributes(true), h.Type("button"), h.OnClick(item2.onClick)], children);
  return h.span(attributes(false), children);
};
var sidebar = (config, h) => h.aside([...styledAttrs(config, h, catalogStyles.sidebar), h.AriaLabel(config.ariaLabel ?? "Sidebar")], [...(config.header ?? []), ...config.groups.map(group2 => h.div(sxAttrs(h, catalogStyles.sidebarGroup), [...(group2.label === void 0 ? [] : [h.div(sxAttrs(h, catalogStyles.sidebarLabel), [group2.label])]), ...group2.items.map(item2 => sidebarItem(item2, h))])), ...(config.footer ?? [])]);
var tabBarTabId = (id, value) => `${id}-tab-${value}`;
var nextEnabledIndex = (tabs2, index, key2) => {
  const enabled = candidate => tabs2[candidate]?.isDisabled !== true;
  const search = (start, step) => {
    for (let offset = 0; offset < tabs2.length; offset += 1) {
      const candidate = ((start + offset * step) % tabs2.length + tabs2.length) % tabs2.length;
      if (enabled(candidate)) return candidate;
    }
    return void 0;
  };
  if (key2 === "ArrowRight") return search(index + 1, 1);
  if (key2 === "ArrowLeft") return search(index - 1, -1);
  if (key2 === "Home") return search(0, 1);
  if (key2 === "End") return search(tabs2.length - 1, -1);
  return void 0;
};
var tabBar = (config, h) => {
  const slots = config.slotProps;
  const isTablist = config.semantics === "tablist";
  const selectedIndex = config.tabs.findIndex(tab => tab.value === config.value && tab.isDisabled !== true);
  const tabStop = selectedIndex >= 0 ? selectedIndex : config.tabs.findIndex(tab => tab.isDisabled !== true);
  const tabView = (tab, index) => {
    const id = tabBarTabId(config.id, tab.value);
    const isCurrent = tab.value === config.value;
    const isDisabled = tab.isDisabled === true;
    const hintId = `${id}-hint`;
    const children = [h.span(slotAttrs(slots?.label, h, isDisabled && catalogStyles.tabBarLabelDisabled), [tab.label]), ...(tab.badge === void 0 ? [] : [h.span(slotAttrs(slots?.badge, h, catalogStyles.tabBarBadge), tab.badge)]), ...(tab.hint === void 0 ? [] : [h.span([...slotAttrs(slots?.hint, h, catalogStyles.tabBarHint), h.Id(hintId)], [tab.hint])])];
    const attributes = [...slotAttrs(slots?.tab, h, catalogStyles.focusable, catalogStyles.tabBarTab, isCurrent && catalogStyles.tabBarTabCurrent, isDisabled && catalogStyles.tabBarTabDisabled), h.Id(id), ...(tab.hint === void 0 ? [] : [h.AriaDescribedBy(hintId)]), ...(isDisabled ? [h.AriaDisabled(true)] : [])];
    if (config.semantics === "tablist") {
      const onChange = config.onChange;
      return h.button([...attributes, h.Type("button"), h.Role("tab"), h.AriaSelected(isCurrent), h.Tabindex(index === tabStop ? 0 : -1), ...(config.panelId === void 0 ? [] : [h.AriaControls(config.panelId)]), ...(isDisabled ? [] : [h.OnClick(onChange(tab.value))]), h.OnKeyDownFocus(key2 => {
        const next = nextEnabledIndex(config.tabs, index, key2);
        const target = next === void 0 ? void 0 : config.tabs[next];
        return target === void 0 || next === index ? Option.none() : Option.some({
          focusSelector: `[id="${tabBarTabId(config.id, target.value)}"]`,
          message: onChange(target.value)
        });
      })], children);
    }
    const current = isCurrent ? [h.AriaCurrent("page")] : [];
    const onClick = isDisabled || config.onChange === void 0 ? [] : [h.OnClick(config.onChange(tab.value))];
    const control3 = tab.href !== void 0 && !isDisabled ? h.a([...attributes, ...current, h.Href(tab.href), ...onClick], children) : h.button([...attributes, ...current, h.Type("button"), ...onClick], children);
    return h.li(slotAttrs(slots?.item, h, catalogStyles.tabBarItem), [control3]);
  };
  const tabs2 = config.tabs.map(tabView);
  const trailing = config.trailing === void 0 ? [] : [h.div(slotAttrs(slots?.trailing, h, catalogStyles.tabBarTrailing), config.trailing)];
  return isTablist ? h.div([...rootAttrs(config, h, catalogStyles.tabBar), h.DataAttribute("tab-bar", "tablist")], [h.div([...slotAttrs(slots?.list, h, catalogStyles.tabBarList), h.Role("tablist"), h.AriaLabel(config.ariaLabel), h.AriaOrientation("horizontal")], tabs2), ...trailing]) : h.nav([...rootAttrs(config, h, catalogStyles.tabBar), h.AriaLabel(config.ariaLabel), h.DataAttribute("tab-bar", "navigation")], [h.ul(slotAttrs(slots?.list, h, catalogStyles.tabBarList), tabs2), ...trailing]);
};
var Breadcrumb = {
  view: breadcrumb,
  collapseItems: collapseBreadcrumbItems
};
var NavigationMenu = {
  view: navigationMenu
};
var Pagination = {
  view: pagination
};
var Sidebar = {
  view: sidebar
};
var TabBar = {
  view: tabBar,
  tabId: tabBarTabId
};
var Tabs = {
  view: tabs
};
var styles4 = {
  root: {
    kGNEyG: "x6s0dn4",
    kWkggS: "xog5j1s",
    kL6WhQ: "xqhy64d",
    kfdmCh: "x1q0q8m5",
    kt9PQ7: "xso031l",
    kMwMTN: "x1ys4cjs",
    k1C7PZ: "x1h82uww",
    k1xSpc: "xrvj5dj",
    kMv6JI: "x14t0e4u",
    kC13JO: "x1o5qy1w x1pnybva",
    kumcoG: "xju1xpo xcjiiad",
    kAzted: "x2dgz13",
    k8WAf4: "x11vqmue",
    kg3NbH: "xjr8qsp",
    khm7nJ: "xx3t3a7",
    $$css: true
  },
  withoutNavigation: {
    kC13JO: "x13qqev6",
    kumcoG: "xju1xpo",
    $$css: true
  },
  sticky: {
    kkqhue: "x17y0mx6",
    kVAEAm: "x7wzq59",
    k87sOh: "x13vifvy",
    kY2c9j: "x1355qak",
    $$css: true
  },
  brand: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    kOIVth: "x7agqhd",
    kJuA4N: "x1pmbb8p",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  title: {
    kMwMTN: "x1heor9g",
    kGuDYH: "x16ws5mb",
    k63SB2: "x1uflamq",
    kb6lSQ: "x1lg07ej",
    kLWn49: "xxhjj0a",
    kogj98: "x1ghz6dp",
    kVQacm: "xb3r6kr",
    kybGjl: "x1hl2dhg",
    kg5iWk: "xlyipyv",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  titleButton: {
    kWkggS: "xjbqb8w",
    kkrTdU: "x1ypdohk",
    kVVagm: "xln7xf2",
    kmVPX3: "x1717udv",
    $$css: true
  },
  navigation: {
    kGJrpR: "xv5lvn5 x1eaa1d1",
    kVhnKS: "x1t7ytsu",
    k2ei4v: "x14e42zd xtpo7py",
    kGuDYH: "x1kio5tc",
    kJuA4N: "x1nkj2r4",
    k7Eaqz: "xeuugli",
    kVQacm: "xb3r6kr",
    kZCmMZ: "x1c1uobl xikxvtj",
    $$css: true
  },
  end: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    kOIVth: "x1ngs94h",
    kJuA4N: "x16vk2yj",
    kjj79g: "x13a6bvl",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  status: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kOIVth: "x7agqhd",
    $$css: true
  },
  actions: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kOIVth: "x7agqhd",
    $$css: true
  }
};
var view15 = (config, h) => {
  const titleAttrs = slotAttrs(config.slotProps?.title, h, styles4.title, catalogStyles.focusable, config.titleHref === void 0 && config.onTitleClick !== void 0 && styles4.titleButton);
  const title = config.titleHref !== void 0 ? h.a([...titleAttrs, h.Href(config.titleHref), ...(config.onTitleClick === void 0 ? [] : [h.OnClick(config.onTitleClick)])], [config.title]) : config.onTitleClick !== void 0 ? h.button([...titleAttrs, h.Type("button"), h.OnClick(config.onTitleClick)], [config.title]) : h.span(titleAttrs, [config.title]);
  const end = [...(config.status === void 0 ? [] : [h.div(slotAttrs(config.slotProps?.status, h, styles4.status), config.status)]), ...(config.actions === void 0 ? [] : [h.div(slotAttrs(config.slotProps?.actions, h, styles4.actions), config.actions)])];
  return h.header(rootAttrs(config, h, styles4.root, config.breadcrumb === void 0 && styles4.withoutNavigation, config.sticky === true && styles4.sticky), [h.div(slotAttrs(config.slotProps?.brand, h, styles4.brand), [...(config.leading ?? []), title]), ...(config.breadcrumb === void 0 ? [] : [h.div(slotAttrs(config.slotProps?.navigation, h, styles4.navigation), [Breadcrumb.view(config.breadcrumb, h)])]), ...(end.length === 0 ? [] : [h.div(sxAttrs(h, styles4.end), end)])]);
};

// src/tree.ts
var tree_exports = {};
__export(tree_exports, {
  Message: () => Message3,
  Model: () => Model3,
  Node: () => Node,
  OutMessage: () => OutMessage2,
  init: () => init3,
  moveNodes: () => moveNodes,
  moveTarget: () => moveTarget,
  reconcile: () => reconcile,
  update: () => update3,
  view: () => view17,
  visibleNodes: () => visibleNodes
});

// src/editable-text.ts
var editable_text_exports = {};
__export(editable_text_exports, {
  Focus: () => Focus,
  Message: () => Message2,
  Model: () => Model2,
  OutMessage: () => OutMessage,
  control: () => control,
  init: () => init2,
  update: () => update2,
  view: () => view16
});
var GuardComposition = Mount.defineStream("GuardTextComposition", {
  messages: [Schema.Never],
  execute: ({
    element
  }) => Stream.callback(() => Effect.gen(function* () {
    yield* Effect.acquireRelease(Effect.sync(() => {
      let composing = false;
      const start = () => {
        composing = true;
      };
      const end = () => {
        composing = false;
      };
      const key2 = event => {
        const keyboard = event;
        if (composing || keyboard.isComposing || keyboard.keyCode === 229) keyboard.stopImmediatePropagation();
      };
      element.addEventListener("compositionstart", start);
      element.addEventListener("compositionend", end);
      element.addEventListener("keydown", key2, true);
      return () => {
        element.removeEventListener("compositionstart", start);
        element.removeEventListener("compositionend", end);
        element.removeEventListener("keydown", key2, true);
      };
    }), dispose => Effect.sync(dispose));
    return yield* Effect.never;
  }))
});
var appear = "x18re5ia-B";
var desktopStyles = {
  column: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x7agqhd",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  row: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x7agqhd",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  wrap: {
    kwnvtZ: "x1a02dak",
    $$css: true
  },
  surface: {
    kWkggS: "x13zjy52",
    kMwMTN: "x2pdk8c",
    kVAM5u: "x1ubh2qd",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kaIpWk: "x3wpolg",
    kmVPX3: "x1szo1dz",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  control: {
    kMv6JI: "x14t0e4u",
    kGuDYH: "x4z9k3i",
    k63SB2: "xo1l8bm",
    kMwMTN: "x1ys4cjs",
    kWkggS: "x13zjy52",
    kVAM5u: "x1ubh2qd",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kaIpWk: "x5i151u",
    kmVPX3: "x18tqr4w",
    k7Eaqz: "xeuugli",
    kzqmXN: "xh8yej3",
    kI3sdo: "x1a2a7pz xybh4k3",
    $$css: true
  },
  button: {
    k9WMMc: "x1yc453h",
    kMv6JI: "x14t0e4u",
    kGuDYH: "x4z9k3i",
    k63SB2: "xk50ysn",
    kaIpWk: "x5i151u",
    kmVPX3: "x18tqr4w",
    kMwMTN: "x1ys4cjs",
    kWkggS: "xjbqb8w xdnxrc",
    kkrTdU: "x1ypdohk",
    kI3sdo: "x1a2a7pz xybh4k3",
    $$css: true
  },
  muted: {
    kMwMTN: "xyu5t3h",
    kGuDYH: "xfifm61",
    $$css: true
  },
  error: {
    kMwMTN: "x1g3r7qa",
    kGuDYH: "xfifm61",
    $$css: true
  },
  overflow: {
    kVAEAm: "x1n2onr6",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  scroller: {
    kXHlph: "xw2csxc",
    k1xSpc: "x78zum5",
    kGNEyG: "x1cy8zhl",
    kOIVth: "x167g77z",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  item: {
    kmuXW: "x2lah0s",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  probes: {
    kVAEAm: "x10l6tqk",
    k33iCy: "xlshs6z",
    kfzvcC: "x47corl",
    k1xSpc: "x78zum5",
    kzqmXN: "xezivpi",
    k87sOh: "x13vifvy",
    kbCHJM: "xu96u03",
    kZKoxP: "xqtp20y",
    kVQacm: "xb3r6kr",
    $$css: true
  },
  menu: {
    kWkggS: "x1rnmz67",
    kMwMTN: "xl26v19",
    kVAM5u: "x1ubh2qd",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kaIpWk: "x3wpolg",
    kmVPX3: "x1ykk9uh",
    kGVxlE: "xq8idag",
    k7Eaqz: "xfb3i0g",
    ks0D6T: "x1usz39j",
    $$css: true
  },
  panel: {
    kKVMdj: "xqcmdr3",
    k44tkh: "x12l1aco x1u6grsq",
    $$css: true
  },
  selected: {
    kWkggS: "x4ov27q",
    kMwMTN: "xc3dant",
    $$css: true
  },
  calendar: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x1jnr06f",
    kzqmXN: "x1dz1jew",
    ks0D6T: "x193iq5w",
    $$css: true
  },
  week: {
    k1xSpc: "xrvj5dj",
    kumcoG: "x1gj6vdr",
    k9WMMc: "x2b8uid",
    $$css: true
  },
  calendarCell: {
    kzqmXN: "xh8yej3",
    k9WMMc: "x2b8uid",
    $$css: true
  },
  focused: {
    kI3sdo: "x18z643n",
    kInvED: "x2ssjo2",
    $$css: true
  },
  months: {
    k1xSpc: "xrvj5dj",
    kumcoG: "x185a7wo",
    $$css: true
  }
};

// src/editable-text.ts
var Model2 = Schema.Struct({
  id: Schema.String,
  mode: Schema.Literals(["view", "edit"]),
  draft: Schema.String,
  error: Schema.String
});
var Message2 = defineMessageUnion({
  Started: {},
  Changed: {
    value: Schema.String
  },
  Committed: {
    returnFocus: Schema.Boolean
  },
  Cancelled: {
    returnFocus: Schema.Boolean
  },
  Blurred: {},
  Focused: {}
});
var OutMessage = defineMessageUnion({
  Committed: {
    value: Schema.String
  },
  Cancelled: {}
});
var init2 = id => ({
  id,
  mode: "view",
  draft: "",
  error: ""
});
var Focus = Command.define("FocusEditableText", {
  args: {
    id: Schema.String,
    select: Schema.Boolean
  },
  messages: [Message2.Focused],
  execute: ({
    id,
    select: select2
  }) => Dom.focus(`#${CSS.escape(id)}`).pipe(Effect.andThen(Effect.sync(() => {
    if (select2) document.getElementById(id)?.select();
  })), Effect.ignore, Effect.as(Message2.Focused()))
});
var focus = (model, enabled) => enabled ? [Focus({
  id: `${model.id}-${model.mode}`,
  select: model.mode === "edit"
})] : [];
var update2 = (model, message3, policy) => {
  if (message3._tag === "Focused") return {
    model
  };
  if (policy.isDisabled || policy.isReadOnly || policy.isPending) return {
    model
  };
  switch (message3._tag) {
    case "Started":
      {
        const next = {
          ...model,
          mode: "edit",
          draft: policy.value,
          error: ""
        };
        return {
          model: next,
          commands: focus(next, true)
        };
      }
    case "Changed":
      return {
        model: model.mode === "edit" ? {
          ...model,
          draft: message3.value,
          error: ""
        } : model
      };
    case "Blurred":
      return policy.blur === "keep" ? {
        model
      } : update2(model, policy.blur === "cancel" ? Message2.Cancelled({
        returnFocus: false
      }) : Message2.Committed({
        returnFocus: false
      }), policy);
    case "Cancelled":
      {
        if (model.mode !== "edit") return {
          model
        };
        const next = {
          ...model,
          mode: "view",
          draft: policy.value,
          error: ""
        };
        return {
          model: next,
          commands: focus(next, message3.returnFocus),
          outMessage: OutMessage.Cancelled()
        };
      }
    case "Committed":
      {
        if (model.mode !== "edit") return {
          model
        };
        const error = policy.validate?.(model.draft);
        if (error) return {
          model: {
            ...model,
            error
          },
          commands: focus(model, message3.returnFocus)
        };
        const next = {
          ...model,
          mode: "view",
          error: ""
        };
        return {
          model: next,
          commands: focus(next, message3.returnFocus),
          outMessage: OutMessage.Committed({
            value: model.draft
          })
        };
      }
  }
};
var control = (config, h) => {
  const blocked = config.isDisabled || config.isReadOnly || config.isPending;
  const attrs = [h.OnMount(GuardComposition()), h.Id(config.id), h.Value(config.value), h.AriaLabel(config.label), h.Disabled(config.isDisabled === true), h.Readonly(config.isReadOnly === true || config.isPending === true), h.AriaBusy(config.isPending === true), h.AriaInvalid(Boolean(config.error)), h.AriaDescribedBy(`${config.id}-status`), ...sxAttrs(h, desktopStyles.control), h.OnInput(config.onChange), ...(config.onBlur === void 0 ? [] : [h.OnBlur(config.onBlur)]), h.OnKeyDownPreventDefault((key2, mods) => {
    if (blocked) return Option.none();
    if (key2 === "Escape" && config.escape !== "keep") return Option.some(config.onCancel);
    const policy = config.enter ?? (config.multiline ? "mod-enter" : "commit");
    return key2 === "Enter" && (policy === "commit" || policy === "mod-enter" && (mods.metaKey || mods.ctrlKey)) ? Option.some(config.onCommit) : Option.none();
  })];
  return h.div(sxAttrs(h, desktopStyles.column), [config.multiline ? h.textarea([...attrs, h.Rows(3)]) : h.input([...attrs, h.Type("text")]), h.span([h.Id(`${config.id}-status`), h.Role("status"), ...sxAttrs(h, config.error ? desktopStyles.error : desktopStyles.muted)], [config.error || (config.isPending ? "Saving\u2026" : config.status ?? (config.multiline ? "Ctrl/\u2318+Enter to save \xB7 Escape to cancel" : "Enter to save \xB7 Escape to cancel"))])]);
};
var view16 = (config, h) => {
  const send = config.toParentMessage;
  return config.model.mode === "view" ? h.div(sxAttrs(h, desktopStyles.column), [h.button([h.Id(`${config.model.id}-view`), h.Type("button"), h.AriaBusy(config.isPending === true), h.AriaLabel(`Edit ${config.label}`), h.Disabled(config.isDisabled === true || config.isReadOnly === true || config.isPending === true), h.OnClick(send(Message2.Started())), ...sxAttrs(h, desktopStyles.button)], [config.value || "Click to edit"]), ...(config.isPending ? [h.span([h.Role("status"), ...sxAttrs(h, desktopStyles.muted)], ["Saving\u2026"])] : [])]) : control({
    ...config,
    id: `${config.model.id}-edit`,
    value: config.model.draft,
    error: config.model.error,
    onChange: value => send(Message2.Changed({
      value
    })),
    onCommit: send(Message2.Committed({
      returnFocus: true
    })),
    onCancel: send(Message2.Cancelled({
      returnFocus: true
    })),
    onBlur: send(Message2.Blurred())
  }, h);
};
var Node = Schema.Struct({
  id: Schema.String,
  label: Schema.String,
  parentId: Schema.NullOr(Schema.String),
  branch: Schema.Boolean,
  renamable: Schema.Boolean,
  movable: Schema.Boolean
});
var Model3 = Schema.Struct({
  id: Schema.String,
  expandedIds: Schema.Array(Schema.String),
  activeId: Schema.NullOr(Schema.String),
  selectedId: Schema.NullOr(Schema.String),
  editingId: Schema.NullOr(Schema.String),
  draft: Schema.String,
  originalLabel: Schema.String,
  search: Schema.String,
  searchTime: Schema.Number,
  announcement: Schema.String
});
var Message3 = defineMessageUnion({
  Selected: {
    id: Schema.String
  },
  Toggled: {
    id: Schema.String
  },
  Navigated: {
    key: Schema.String,
    time: Schema.Number
  },
  StartedRename: {},
  ChangedDraft: {
    value: Schema.String
  },
  CommittedRename: {},
  CancelledRename: {},
  Moved: {
    direction: Schema.Literals(["Up", "Down", "Indent", "Outdent"])
  },
  CompletedFocus: {}
});
var OutMessage2 = defineMessageUnion({
  Selected: {
    id: Schema.String
  },
  Renamed: {
    id: Schema.String,
    label: Schema.String
  },
  Moved: {
    id: Schema.String,
    parentId: Schema.NullOr(Schema.String),
    index: Schema.Number
  }
});
var init3 = config => {
  if (!config.id) throw new Error("Tree requires a nonempty ID.");
  return {
    id: config.id,
    expandedIds: [...new Set(config.expandedIds ?? [])],
    activeId: config.selectedId ?? null,
    selectedId: config.selectedId ?? null,
    editingId: null,
    draft: "",
    originalLabel: "",
    search: "",
    searchTime: 0,
    announcement: ""
  };
};
var indexNodes = nodes => {
  const byId = /* @__PURE__ */new Map();
  const children = /* @__PURE__ */new Map();
  for (const node of nodes) {
    if (!node.id || byId.has(node.id)) throw new Error("Tree node IDs must be nonempty and unique.");
    byId.set(node.id, node);
    const siblings = children.get(node.parentId) ?? [];
    siblings.push(node);
    children.set(node.parentId, siblings);
  }
  for (const node of nodes) {
    const seen = /* @__PURE__ */new Set([node.id]);
    let parentId = node.parentId;
    while (parentId !== null) {
      if (seen.has(parentId)) throw new Error("Tree nodes cannot form a cycle.");
      seen.add(parentId);
      const parent = byId.get(parentId);
      if (!parent?.branch) throw new Error("Tree parents must be existing branch nodes.");
      parentId = parent.parentId;
    }
  }
  return {
    byId,
    children
  };
};
var visibleNodes = (model, nodes) => {
  const {
    children
  } = indexNodes(nodes);
  const expanded = new Set(model.expandedIds);
  const result = [];
  const visit = parentId => {
    for (const node of children.get(parentId) ?? []) {
      result.push(node);
      if (expanded.has(node.id)) visit(node.id);
    }
  };
  visit(null);
  return result;
};
var reconcile = (model, nodes) => {
  const {
    byId
  } = indexNodes(nodes);
  const visible = visibleNodes(model, nodes);
  const visibleIds = new Set(visible.map(node => node.id));
  let activeId = model.activeId;
  while (activeId && !visibleIds.has(activeId)) activeId = byId.get(activeId)?.parentId ?? null;
  activeId ??= visible.find(node => node.id === model.selectedId)?.id ?? visible[0]?.id ?? null;
  const editingId = model.editingId && visibleIds.has(model.editingId) ? model.editingId : null;
  return {
    ...model,
    activeId,
    editingId,
    selectedId: model.selectedId && byId.has(model.selectedId) ? model.selectedId : null,
    expandedIds: model.expandedIds.filter(id => byId.get(id)?.branch)
  };
};
var domId = (tree, node) => `${encodeURIComponent(tree)}-node-${encodeURIComponent(node)}`;
var Focus2 = Command.define("FocusTreeExplorer", {
  args: {
    id: Schema.String,
    item: Schema.NullOr(Schema.String),
    editing: Schema.Boolean
  },
  messages: [Message3.CompletedFocus],
  execute: ({
    id,
    item: item2,
    editing
  }) => Dom.focus(`#${CSS.escape(editing ? `${id}-rename` : id)}`).pipe(Effect.andThen(Effect.sync(() => {
    if (editing) document.getElementById(`${id}-rename`)?.select();
  })), Effect.andThen(item2 ? Dom.scrollIntoViewIfNotVisible(`#${CSS.escape(domId(id, item2))}`, {
    block: "nearest",
    when: "Commit"
  }) : Effect.void), Effect.ignore, Effect.as(Message3.CompletedFocus()))
});
var focus2 = model => ({
  model,
  commands: [Focus2({
    id: model.id,
    item: model.activeId,
    editing: model.editingId !== null
  })]
});
var moveTarget = (model, direction, config) => {
  const {
    byId,
    children
  } = indexNodes(config.nodes);
  const node = byId.get(model.activeId ?? "");
  if (!node?.movable) return;
  const siblings = children.get(node.parentId) ?? [];
  const index = siblings.findIndex(item2 => item2.id === node.id);
  let move;
  if (direction === "Up" && index > 0) move = {
    id: node.id,
    parentId: node.parentId,
    index: index - 1
  };
  if (direction === "Down" && index < siblings.length - 1) move = {
    id: node.id,
    parentId: node.parentId,
    index: index + 1
  };
  if (direction === "Indent") {
    const previous = siblings[index - 1];
    if (previous?.branch) move = {
      id: node.id,
      parentId: previous.id,
      index: (children.get(previous.id) ?? []).length
    };
  }
  if (direction === "Outdent" && node.parentId !== null) {
    const parent = byId.get(node.parentId);
    move = {
      id: node.id,
      parentId: parent.parentId,
      index: (children.get(parent.parentId) ?? []).findIndex(item2 => item2.id === parent.id) + 1
    };
  }
  return move && config.canMove?.(move) !== false ? move : void 0;
};
var moveNodes = (nodes, move) => {
  const {
    byId
  } = indexNodes(nodes);
  const node = byId.get(move.id);
  if (!node?.movable || !Number.isInteger(move.index) || move.index < 0) return nodes;
  let parentId = move.parentId;
  if (parentId !== null && !byId.get(parentId)?.branch) return nodes;
  while (parentId !== null) {
    if (parentId === move.id) return nodes;
    parentId = byId.get(parentId).parentId;
  }
  const remaining = nodes.filter(item2 => item2.id !== move.id);
  const siblings = remaining.filter(item2 => item2.parentId === move.parentId);
  if (move.index > siblings.length) return nodes;
  const before = siblings[move.index];
  const insertion = before ? remaining.findIndex(item2 => item2.id === before.id) : remaining.length;
  return [...remaining.slice(0, insertion), {
    ...nodes.find(item2 => item2.id === move.id),
    parentId: move.parentId
  }, ...remaining.slice(insertion)];
};
var update3 = (previous, message3, config) => {
  const model = reconcile(previous, config.nodes);
  const nodes = visibleNodes(model, config.nodes);
  const active = nodes.find(node => node.id === model.activeId);
  return Message3.match(message3, {
    CompletedFocus: () => ({
      model
    }),
    Selected: ({
      id
    }) => nodes.some(node => node.id === id) ? {
      ...focus2({
        ...model,
        activeId: id,
        selectedId: id,
        editingId: null,
        search: ""
      }),
      outMessage: OutMessage2.Selected({
        id
      })
    } : {
      model
    },
    Toggled: ({
      id
    }) => {
      if (!nodes.find(node => node.id === id)?.branch) return {
        model
      };
      const expandedIds = model.expandedIds.includes(id) ? model.expandedIds.filter(value => value !== id) : [...model.expandedIds, id];
      return focus2(reconcile({
        ...model,
        activeId: id,
        expandedIds,
        editingId: null,
        search: ""
      }, config.nodes));
    },
    StartedRename: () => active?.renamable ? focus2({
      ...model,
      editingId: active.id,
      draft: active.label,
      originalLabel: active.label
    }) : {
      model
    },
    ChangedDraft: ({
      value
    }) => ({
      model: model.editingId ? {
        ...model,
        draft: value
      } : model
    }),
    CancelledRename: () => focus2({
      ...model,
      editingId: null,
      draft: ""
    }),
    CommittedRename: () => {
      const node = config.nodes.find(node2 => node2.id === model.editingId);
      if (!node?.renamable) return focus2({
        ...model,
        editingId: null
      });
      if (node.label !== model.originalLabel) return focus2({
        ...model,
        editingId: null,
        announcement: "Name changed elsewhere. Rename cancelled."
      });
      const label2 = model.draft.trim();
      if (!label2) return focus2({
        ...model,
        announcement: "Enter a name."
      });
      const result = focus2({
        ...model,
        editingId: null,
        announcement: `Rename requested: ${label2}.`
      });
      return label2 === node.label ? result : {
        ...result,
        outMessage: OutMessage2.Renamed({
          id: node.id,
          label: label2
        })
      };
    },
    Moved: ({
      direction
    }) => {
      const target = moveTarget(model, direction, config);
      if (!target || model.editingId) return {
        model
      };
      return {
        ...focus2({
          ...model,
          expandedIds: target.parentId ? [... /* @__PURE__ */new Set([...model.expandedIds, target.parentId])] : model.expandedIds,
          announcement: `Move requested: ${active?.label ?? "item"}.`
        }),
        outMessage: OutMessage2.Moved(target)
      };
    },
    Navigated: ({
      key: key2,
      time
    }) => {
      if (!active || model.editingId) return {
        model
      };
      let id = active.id;
      const index = nodes.indexOf(active);
      if (key2 === "ArrowDown") id = nodes[Math.min(index + 1, nodes.length - 1)].id;else if (key2 === "ArrowUp") id = nodes[Math.max(0, index - 1)].id;else if (key2 === "Home") id = nodes[0].id;else if (key2 === "End") id = nodes[nodes.length - 1].id;else if (key2 === "ArrowRight") {
        if (active.branch && !model.expandedIds.includes(id)) return update3(model, Message3.Toggled({
          id
        }), config);
        id = nodes.find(node => node.parentId === active.id)?.id ?? id;
      } else if (key2 === "ArrowLeft") {
        if (active.branch && model.expandedIds.includes(id)) return update3(model, Message3.Toggled({
          id
        }), config);
        id = active.parentId ?? id;
      } else if (key2 === "Enter" || key2 === " ") return update3(model, Message3.Selected({
        id
      }), config);else if (key2 === "F2") return update3(model, Message3.StartedRename(), config);else if (key2.length === 1) {
        const character = key2.toLocaleLowerCase();
        const search = time - model.searchTime < 700 ? model.search + character : character;
        const repeated = [...search].every(value => value === character);
        const candidates = [...nodes.slice(index + (repeated ? 1 : 0)), ...nodes.slice(0, index + (repeated ? 1 : 0))];
        id = candidates.find(node => node.label.toLocaleLowerCase().startsWith(repeated ? character : search))?.id ?? id;
        return focus2({
          ...model,
          activeId: id,
          search,
          searchTime: time
        });
      }
      return focus2({
        ...model,
        activeId: id,
        search: ""
      });
    }
  });
};
var styles5 = {
  root: {
    k7Eaqz: "xeuugli",
    $$css: true
  },
  tree: {
    kI3sdo: "x1a2a7pz x15852t7",
    kInvED: "x2ssjo2",
    kmVPX3: "xfawy5m",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  row: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    kOIVth: "x1j9xkj6",
    kAzted: "xu97haq",
    kaIpWk: "x1kogg8i",
    kmVPX3: "xdqdrvq",
    kkrTdU: "x1ypdohk",
    kMwMTN: "xijt82",
    kGuDYH: "xfifm61",
    kWkggS: "xjbqb8w xjjfr13",
    $$css: true
  },
  selected: {
    kWkggS: "xqresv7",
    kMwMTN: "x1xyxl3g",
    $$css: true
  },
  active: {
    kI3sdo: "x1hn0dmv",
    kInvED: "x1g40iwv",
    $$css: true
  },
  label: {
    k7Eaqz: "xeuugli",
    kVQacm: "xb3r6kr",
    kg5iWk: "xlyipyv",
    khDVqt: "xuxw1ft",
    kUk6DE: "x98rzlu",
    $$css: true
  },
  toggle: {
    k1xSpc: "x3nfvp2",
    kzqmXN: "x1xp8n7a",
    kjj79g: "xl56j7k",
    kmuXW: "x2lah0s",
    kkrTdU: "x1ypdohk",
    $$css: true
  },
  actions: {
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kOIVth: "x1jnr06f",
    kmVPX3: "xcuk4bc",
    $$css: true
  },
  status: {
    kGuDYH: "x1j6dyjg",
    kMwMTN: "xefna1",
    kmVPX3: "xdqdrvq",
    $$css: true
  }
};
var view17 = (config, h) => {
  const {
    toParentMessage
  } = config;
  const model = reconcile(config.model, config.nodes);
  const {
    children
  } = indexNodes(config.nodes);
  const render = (parentId, level) => (children.get(parentId) ?? []).map((node, index, siblings) => {
    const editing = model.editingId === node.id;
    return h.keyed("div")(node.id, [h.Id(domId(model.id, node.id)), h.Role("treeitem"), h.AriaLabel(node.label), ...(config.checkedIds && !node.branch ? [h.AriaChecked(config.checkedIds.includes(node.id))] : []), h.AriaSelected(model.selectedId === node.id), h.AriaLevel(level), h.AriaPosinset(index + 1), h.AriaSetsize(siblings.length), ...(node.branch ? [h.AriaExpanded(model.expandedIds.includes(node.id))] : [])], [h.div([...sxAttrs(h, styles5.row, model.selectedId === node.id && styles5.selected, model.activeId === node.id && styles5.active), h.Style({
      paddingInlineStart: `${8 + (level - 1) * 16}px`
    })], [h.span([...sxAttrs(h, styles5.toggle), h.AriaHidden(true), ...(node.branch ? [h.OnClick(toParentMessage(Message3.Toggled({
      id: node.id
    })))] : [])], [view2({
      icon: node.branch ? model.expandedIds.includes(node.id) ? ChevronDown : ChevronRight : FileText,
      size: 14
    }, h)]), ...(config.checkedIds && !node.branch ? [h.input([h.Type("checkbox"), h.Tabindex(-1), h.Checked(config.checkedIds.includes(node.id)), h.AriaLabel(`Viewed ${node.label}`), ...(config.onCheckedChange ? [h.OnClick(config.onCheckedChange(node.id, !config.checkedIds.includes(node.id)))] : [h.Disabled(true)])])] : []), ...(editing ? [control({
      id: `${model.id}-rename`,
      label: `Rename ${node.label}`,
      value: model.draft,
      onChange: value => toParentMessage(Message3.ChangedDraft({
        value
      })),
      onCommit: toParentMessage(Message3.CommittedRename()),
      onCancel: toParentMessage(Message3.CancelledRename())
    }, h)] : [h.span([...sxAttrs(h, styles5.label), h.Title(node.label), h.OnClick(toParentMessage(Message3.Selected({
      id: node.id
    })))], [node.label])])]), ...(node.branch && model.expandedIds.includes(node.id) ? [h.div([h.Role("group")], render(node.id, level + 1))] : [])]);
  });
  const active = config.nodes.find(node => node.id === model.activeId);
  return h.div(sxAttrs(h, styles5.root), [h.div([...sxAttrs(h, styles5.tree), h.Id(model.id), h.Role("tree"), h.AriaLabel(config.label), h.Tabindex(0), ...(model.activeId ? [h.AriaActiveDescendant(domId(model.id, model.activeId))] : []), h.OnKeyDownPreventDefault((key2, modifiers) => {
    if (key2 === " " && active && !active.branch && config.onCheckedChange) return Option.some(config.onCheckedChange(active.id, !config.checkedIds?.includes(active.id)));
    if (model.editingId || modifiers.ctrlKey || modifiers.metaKey) return Option.none();
    if (modifiers.altKey) {
      const directions = {
        ArrowUp: "Up",
        ArrowDown: "Down",
        ArrowRight: "Indent",
        ArrowLeft: "Outdent"
      };
      const direction = directions[key2];
      return direction ? Option.some(toParentMessage(Message3.Moved({
        direction
      }))) : Option.none();
    }
    return ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Home", "End", "Enter", " ", "F2"].includes(key2) || key2.length === 1 ? Option.some(toParentMessage(Message3.Navigated({
      key: key2,
      time: Date.now()
    }))) : Option.none();
  })], config.nodes.length ? render(null, 1) : [h.p(sxAttrs(h, styles5.status), ["No items."])]), ...(config.showActions === false ? [] : [h.div([...sxAttrs(h, styles5.actions), h.Role("group"), h.AriaLabel(`${config.label} actions`)], model.editingId ? [view3({
    label: "Save name",
    size: "xs",
    onClick: toParentMessage(Message3.CommittedRename())
  }, h), view3({
    label: "Cancel rename",
    size: "xs",
    variant: "ghost",
    onClick: toParentMessage(Message3.CancelledRename())
  }, h)] : [view3({
    label: "Rename",
    size: "xs",
    variant: "ghost",
    isDisabled: !active?.renamable,
    onClick: toParentMessage(Message3.StartedRename())
  }, h), ...["Up", "Down", "Indent", "Outdent"].map(direction => view3({
    label: direction === "Up" || direction === "Down" ? `Move ${direction.toLowerCase()}` : direction,
    size: "xs",
    variant: "ghost",
    isDisabled: !moveTarget(model, direction, config),
    onClick: toParentMessage(Message3.Moved({
      direction
    }))
  }, h))])]), h.div([...sxAttrs(h, styles5.status), h.AriaLive("polite"), h.Role("status")], [model.announcement])]);
};

// src/value-tree.ts
var value_tree_exports = {};
__export(value_tree_exports, {
  Message: () => Message4,
  Model: () => Model4,
  OutMessage: () => OutMessage3,
  fromValue: () => fromValue,
  init: () => init4,
  update: () => update4,
  view: () => view18,
  visibleRows: () => visibleRows
});
var Model4 = Schema.Struct({
  id: Schema.String,
  expandedIds: Schema.Array(Schema.String),
  activeId: Schema.NullOr(Schema.String)
});
var Message4 = defineMessageUnion({
  Toggled: {
    id: Schema.String
  },
  Activated: {
    id: Schema.String
  },
  Navigated: {
    key: Schema.String
  },
  ClickedMore: {
    id: Schema.String
  },
  CompletedFocus: {}
});
var OutMessage3 = defineMessageUnion({
  /**
   * A node without loaded children was expanded. Supply its `children`. It is
   * sent again if the node is reopened before they arrive, so treat it as
   * idempotent. A node listed in `expandedIds` at `init` should come with its
   * children.
   */
  RequestedChildren: {
    id: Schema.String
  },
  /** “Show N more” was chosen. Supply more `children` and a smaller `more`. */
  RequestedMore: {
    id: Schema.String,
    loaded: Schema.Number
  }
});
var init4 = config => {
  if (!config.id) throw new Error("ValueTree requires a nonempty ID.");
  return {
    id: config.id,
    expandedIds: [...new Set(config.expandedIds ?? [])],
    activeId: null
  };
};
var opens = node => (node.children?.length ?? 0) > 0 || node.expandable === true || (node.more ?? 0) > 0;
var rowId = row2 => row2._tag === "Value" ? row2.node.id : row2.id;
var visibleRows = (model, nodes) => {
  const expanded = new Set(model.expandedIds);
  const rows = [];
  const visit = (level, depth, parentId) => level.forEach((node, position) => {
    rows.push({
      _tag: "Value",
      node,
      level: depth,
      parentId,
      position,
      size: level.length
    });
    if (!expanded.has(node.id) || !opens(node)) return;
    const children = node.children ?? [];
    if (children.length === 0 && (node.more ?? 0) === 0) {
      rows.push({
        _tag: node.expandable === true && node.children === void 0 ? "Loading" : "Empty",
        id: `${node.id}::status`,
        level: depth + 1,
        parentId: node.id
      });
    }
    visit(children, depth + 1, node.id);
    if ((node.more ?? 0) > 0) rows.push({
      _tag: "More",
      id: `${node.id}::more`,
      level: depth + 1,
      parentId: node.id,
      count: node.more,
      loaded: children.length
    });
  });
  visit(nodes, 1, null);
  return rows;
};
var domId2 = (tree, node) => `${encodeURIComponent(tree)}-value-${encodeURIComponent(node)}`;
var Focus3 = Command.define("FocusValueTree", {
  args: {
    id: Schema.String,
    item: Schema.NullOr(Schema.String)
  },
  messages: [Message4.CompletedFocus],
  execute: ({
    id,
    item: item2
  }) => Dom.focus(`#${CSS.escape(id)}`).pipe(Effect.andThen(item2 ? Dom.scrollIntoViewIfNotVisible(`#${CSS.escape(domId2(id, item2))}`, {
    block: "nearest",
    when: "Commit"
  }) : Effect.void), Effect.ignore, Effect.as(Message4.CompletedFocus()))
});
var focus3 = model => ({
  model,
  commands: [Focus3({
    id: model.id,
    item: model.activeId
  })]
});
var find = (nodes, id) => {
  for (const node of nodes) {
    if (node.id === id) return node;
    const found = find(node.children ?? [], id);
    if (found !== void 0) return found;
  }
  return void 0;
};
var toggle = (model, id, config) => {
  const node = find(config.nodes, id);
  if (node === void 0 || !opens(node)) return {
    model: {
      ...model,
      activeId: id
    }
  };
  const open = model.expandedIds.includes(id);
  const next = {
    ...model,
    activeId: id,
    expandedIds: open ? model.expandedIds.filter(value => value !== id) : [...model.expandedIds, id]
  };
  return !open && node.expandable === true && node.children === void 0 ? {
    model: next,
    outMessage: OutMessage3.RequestedChildren({
      id
    })
  } : {
    model: next
  };
};
var activeIndex = (rows, activeId) => {
  const at = rows.findIndex(row2 => rowId(row2) === activeId);
  if (at >= 0 || activeId === null) return Math.max(0, at);
  const parentId = /^(.*)::(?:more|status)$/.exec(activeId)?.[1];
  if (parentId === void 0) return 0;
  const parent = rows.findIndex(row2 => rowId(row2) === parentId);
  if (parent < 0) return 0;
  let last = parent;
  while (last + 1 < rows.length && rows[last + 1].level > rows[parent].level) last += 1;
  return last;
};
var update4 = (model, message3, config) => Message4.match(message3, {
  CompletedFocus: () => ({
    model
  }),
  Toggled: ({
    id
  }) => toggle(model, id, config),
  Activated: ({
    id
  }) => ({
    model: {
      ...model,
      activeId: id
    }
  }),
  ClickedMore: ({
    id
  }) => {
    const node = find(config.nodes, id);
    return node === void 0 ? {
      model
    } : {
      model,
      outMessage: OutMessage3.RequestedMore({
        id,
        loaded: node.children?.length ?? 0
      })
    };
  },
  Navigated: ({
    key: key2
  }) => {
    const rows = visibleRows(model, config.nodes);
    if (rows.length === 0) return {
      model
    };
    const index = activeIndex(rows, model.activeId);
    const row2 = rows[index];
    const go = target => focus3({
      ...model,
      activeId: target === void 0 ? rowId(row2) : rowId(target)
    });
    switch (key2) {
      case "ArrowDown":
        return go(rows[Math.min(index + 1, rows.length - 1)]);
      case "ArrowUp":
        return go(rows[Math.max(0, index - 1)]);
      case "Home":
        return go(rows[0]);
      case "End":
        return go(rows.at(-1));
      case "ArrowRight":
        if (row2._tag !== "Value" || !opens(row2.node)) return {
          model
        };
        return model.expandedIds.includes(row2.node.id) ? go(rows[index + 1]) : (() => {
          const opened = toggle(model, row2.node.id, config);
          return {
            ...opened,
            commands: focus3(opened.model).commands ?? []
          };
        })();
      case "ArrowLeft":
        if (row2._tag === "Value" && opens(row2.node) && model.expandedIds.includes(row2.node.id)) {
          const closed = toggle(model, row2.node.id, config);
          return {
            ...closed,
            commands: focus3(closed.model).commands ?? []
          };
        }
        return row2.parentId === null ? {
          model
        } : go(rows.find(candidate => rowId(candidate) === row2.parentId));
      case "Enter":
      case " ":
        if (row2._tag === "More") return update4(model, Message4.ClickedMore({
          id: row2.parentId
        }), config);
        return row2._tag === "Value" ? toggle(model, row2.node.id, config) : {
          model
        };
      default:
        return {
          model
        };
    }
  }
});
var styles6 = {
  tree: {
    k7Eaqz: "xeuugli",
    kmVPX3: "x1ykk9uh",
    kI3sdo: "x1a2a7pz xkrpzxx",
    kInvED: "x2ssjo2",
    kaIpWk: "x3wpolg",
    kMv6JI: "xj528g9",
    kGuDYH: "xwdf1oc",
    kLWn49: "x19v9tvf",
    $$css: true
  },
  row: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1kd3ua",
    k7Eaqz: "xeuugli",
    kAzted: "xe0957l",
    kwRFfy: "xngqqzl",
    kaIpWk: "x5i151u",
    kkrTdU: "xt0e3qv",
    kWkggS: "xjbqb8w xdnxrc",
    $$css: true
  },
  active: {
    kI3sdo: "x1w34bml",
    kInvED: "x1g40iwv",
    $$css: true
  },
  toggle: {
    k1xSpc: "x3nfvp2",
    kUk6DE: "x1okw0bk",
    kzqmXN: "x1kky2od",
    kjj79g: "xl56j7k",
    kMwMTN: "xyu5t3h",
    $$css: true
  },
  key: {
    kUk6DE: "x1okw0bk",
    kMwMTN: "xyu5t3h",
    $$css: true
  },
  preview: {
    k7Eaqz: "xeuugli",
    kVQacm: "xb3r6kr",
    kg5iWk: "xlyipyv",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  string: {
    kMwMTN: "x15kbz4b",
    $$css: true
  },
  number: {
    kMwMTN: "xegcg24",
    $$css: true
  },
  keyword: {
    kMwMTN: "xhje13v",
    $$css: true
  },
  status: {
    kMwMTN: "xyu5t3h",
    kKX8nH: "x1k4tb9n",
    $$css: true
  },
  more: {
    kMwMTN: "x1ysz8r6",
    kkrTdU: "x1ypdohk",
    kybGjl: "x1hl2dhg xt0b8zv",
    $$css: true
  },
  empty: {
    kogj98: "x1ghz6dp",
    kmVPX3: "x1a2zjlo",
    kMwMTN: "xyu5t3h",
    kMv6JI: "x14t0e4u",
    $$css: true
  }
};
var kindStyle = kind => kind === "string" ? styles6.string : kind === "number" || kind === "boolean" || kind === "nil" || kind === "null" ? styles6.number : kind === "keyword" ? styles6.keyword : null;
var view18 = (config, h) => {
  const {
    model,
    toParentMessage
  } = config;
  const rows = visibleRows(model, config.nodes);
  const activeId = rows.some(row2 => rowId(row2) === model.activeId) ? model.activeId : rows[0] === void 0 ? null : rowId(rows[0]);
  const indent = level => h.Style({
    paddingInlineStart: `${4 + (level - 1) * 16}px`
  });
  const item2 = row2 => {
    const id = rowId(row2);
    const common = [h.Id(domId2(model.id, id)), h.Role("treeitem"), h.AriaLevel(row2.level), ...sxAttrs(h, styles6.row, id === activeId && styles6.active), indent(row2.level)];
    switch (row2._tag) {
      case "Value":
        {
          const {
            node
          } = row2;
          const expandable = opens(node);
          const expanded = expandable && model.expandedIds.includes(node.id);
          const label2 = `${node.key === void 0 ? "" : `${node.key}: `}${node.preview}`;
          return h.div([...common, h.AriaLabel(label2), h.AriaPosinset(row2.position + 1), h.AriaSetsize(row2.size), ...(expandable ? [h.AriaExpanded(expanded)] : []), h.DataAttribute("value-node", node.id), ...(node.kind === void 0 ? [] : [h.DataAttribute("kind", node.kind)]), h.OnClick(toParentMessage(expandable ? Message4.Toggled({
            id: node.id
          }) : Message4.Activated({
            id: node.id
          })))], [h.span([...sxAttrs(h, styles6.toggle), h.AriaHidden(true)], expandable ? [view2({
            icon: expanded ? ChevronDown : ChevronRight,
            size: 12
          }, h)] : []), ...(node.key === void 0 ? [] : [h.span(sxAttrs(h, styles6.key), [`${node.key}:`])]), h.span([...sxAttrs(h, styles6.preview, kindStyle(node.kind)), h.Title(node.preview)], [node.preview])]);
        }
      case "More":
        return h.div([...common, h.AriaLabel(`Show ${row2.count} more`), h.DataAttribute("value-more", row2.parentId),
        // The row is the control, so the tree's items hold nothing interactive.
        h.OnClick(toParentMessage(Message4.ClickedMore({
          id: row2.parentId
        })))], [h.span([...sxAttrs(h, styles6.toggle), h.AriaHidden(true)], []), h.span(sxAttrs(h, styles6.more), [`Show ${row2.count} more`])]);
      case "Loading":
      case "Empty":
        return h.div([...common, h.AriaLabel(row2._tag === "Loading" ? "Loading" : "Empty"), ...(row2._tag === "Loading" ? [h.AriaBusy(true)] : []), h.OnClick(toParentMessage(Message4.Activated({
          id
        })))], [h.span([...sxAttrs(h, styles6.toggle), h.AriaHidden(true)], []), h.span(sxAttrs(h, styles6.status), [row2._tag === "Loading" ? "Loading\u2026" : "empty"])]);
    }
  };
  return rows.length === 0 ? h.p(sxAttrs(h, styles6.empty), [config.emptyText ?? "No value."]) : h.div([...sxAttrs(h, styles6.tree), h.Id(model.id), h.Role("tree"), h.AriaLabel(config.label), h.Tabindex(0), ...(activeId === null ? [] : [h.AriaActiveDescendant(domId2(model.id, activeId))]), h.OnKeyDownPreventDefault((key2, modifiers) => modifiers.ctrlKey || modifiers.metaKey || modifiers.altKey || !["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Home", "End", "Enter", " "].includes(key2) ? Option.none() : Option.some(toParentMessage(Message4.Navigated({
    key: key2
  }))))], rows.map(item2));
};
var fromValue = (value, rootId = "$", options = {}) => {
  const limit = options.limit ?? 100;
  const maxDepth = options.depth ?? 8;
  const seen = /* @__PURE__ */new Set();
  const build = (current, id, key2, depth) => {
    const keyed = key2 === void 0 ? {} : {
      key: key2
    };
    if (current === null || current === void 0) return {
      id,
      ...keyed,
      preview: String(current),
      kind: "null"
    };
    if (typeof current === "string") return {
      id,
      ...keyed,
      preview: JSON.stringify(current),
      kind: "string"
    };
    if (typeof current === "number" || typeof current === "bigint") return {
      id,
      ...keyed,
      preview: String(current),
      kind: "number"
    };
    if (typeof current === "boolean") return {
      id,
      ...keyed,
      preview: String(current),
      kind: "boolean"
    };
    if (typeof current === "function") return {
      id,
      ...keyed,
      preview: `\u0192 ${current.name || "anonymous"}`,
      kind: "function"
    };
    if (typeof current !== "object") return {
      id,
      ...keyed,
      preview: String(current)
    };
    if (seen.has(current)) return {
      id,
      ...keyed,
      preview: "(circular)",
      kind: "circular"
    };
    const positional = current instanceof Map || current instanceof Set;
    const entries = Array.isArray(current) ? current.map((entry, index) => [String(index), entry]) : current instanceof Map ? [...current].map(([entryKey, entry]) => [String(entryKey), entry]) : current instanceof Set ? [...current].map((entry, index) => [String(index), entry]) : Object.entries(current);
    const kind = Array.isArray(current) ? "list" : current instanceof Map ? "map" : current instanceof Set ? "set" : "record";
    const preview = `${kind === "record" ? "{\u2026}" : kind} \xB7 ${entries.length} ${entries.length === 1 ? "entry" : "entries"}`;
    if (depth >= maxDepth) return {
      id,
      ...keyed,
      preview,
      kind
    };
    seen.add(current);
    const children = entries.slice(0, limit).map(([entryKey, entry], index) => build(entry, `${id}/${positional ? `#${index}` : encodeURIComponent(entryKey)}`, entryKey, depth + 1));
    seen.delete(current);
    return {
      id,
      ...keyed,
      preview,
      kind,
      children,
      ...(entries.length > limit ? {
        more: entries.length - limit
      } : {})
    };
  };
  return build(value, rootId, void 0, 0);
};

// src/panel.ts
var panel_exports = {};
__export(panel_exports, {
  view: () => view19
});
var view19 = (config, h) => h.section(rootAttrs(config, h, panelStyles.root), [...(config.title === void 0 && config.description === void 0 ? [] : [h.header(slotAttrs(config.slotProps?.header, h, panelStyles.header), [...(config.title === void 0 ? [] : [h.h2(slotAttrs(config.slotProps?.title, h, panelStyles.title), [config.title])]), ...(config.description === void 0 ? [] : [h.p(slotAttrs(config.slotProps?.description, h, panelStyles.description), [config.description])])])]), h.div(slotAttrs(config.slotProps?.body, h, panelStyles.body), config.children)]);

// src/segmented-control.ts
var segmented_control_exports = {};
__export(segmented_control_exports, {
  view: () => view20
});
var view20 = (config, h) => h.div([...rootAttrs(config, h, segmentedStyles.root), h.Role("group"), h.AriaLabel(config.ariaLabel)], config.options.map(option => h.button([h.Type("button"), ...slotAttrs(config.slotProps?.item, h, segmentedStyles.item, hasAdornments2(option) && catalogStyles.withAdornments, option.value === config.value && segmentedStyles.active, option.needsAttention === true && segmentedStyles.attention, option.isDisabled === true && segmentedStyles.disabled), h.AriaPressed(option.value === config.value ? "true" : "false"), ...(option.needsAttention === true ? [h.DataAttribute("attention", "true")] : []), ...(option.isDisabled === true ? [h.Disabled(true)] : [h.OnClick(config.onChange(option.value))])], [option.label, ...optionAdornments(option, config.slotProps, h)])));

// src/select.ts
var select_exports = {};
__export(select_exports, {
  control: () => control2,
  view: () => view21
});
var control2 = (config, h) => {
  if (config.presentation === "value") {
    const value = optionLabel(config.value, config.options);
    return view9({
      ...(config.attributes === void 0 ? {} : {
        attributes: config.attributes
      }),
      ...(config.sx === void 0 ? {} : {
        sx: config.sx
      }),
      ...(config.slotProps?.root === void 0 ? {} : {
        slotProps: {
          root: config.slotProps.root
        }
      }),
      ...(value === void 0 ? {} : {
        value
      }),
      ariaLabel: config.ariaLabel
    }, h);
  }
  return h.select([...rootAttrs(config, h, fieldStyles.control, fieldStyles.selectControl), h.Value(config.value), h.AriaLabel(config.ariaLabel), h.OnChange(config.onChange), ...(config.isDisabled === true ? [h.Disabled(true)] : [])], config.options.map(option => h.option([h.Value(option.value), h.Selected(option.value === config.value)], [option.label])));
};
var view21 = (config, h) => {
  const selected = config.options.find(option => option.value === config.value);
  return h.div(rootAttrs(config, h), [h.button([...slotAttrs(config.slotProps?.trigger, h, fieldStyles.control, catalogStyles.focusable), h.Type("button"), h.AriaLabel(config.ariaLabel), h.AriaHasPopup("listbox"), h.AriaExpanded(config.isOpen), h.AriaControls(`${config.id}-listbox`), h.Disabled(config.isDisabled === true), h.OnClick(config.onOpenChange(!config.isOpen))], [selected?.label ?? "Select an option"]), ...(config.isOpen ? [h.div([...slotAttrs(config.slotProps?.list, h, catalogStyles.floating, catalogStyles.menu), h.Id(`${config.id}-listbox`), h.Role("listbox"), h.AriaLabel(config.ariaLabel)], config.options.map(option => h.button([...slotAttrs(config.slotProps?.option, h, catalogStyles.menuItem, catalogStyles.focusable), h.Type("button"), h.Role("option"), h.AriaSelected(option.value === config.value), h.Disabled(option.isDisabled === true), h.OnClick(config.onChange(option.value))], [option.label])))] : [])]);
};

// src/stat.ts
var stat_exports = {};
__export(stat_exports, {
  view: () => view22
});
var tileTones = {
  neutral: void 0,
  muted: void 0,
  accent: statStyles.tileAccent,
  success: statStyles.tileSuccess,
  warning: statStyles.tileWarning,
  danger: statStyles.tileDanger,
  info: statStyles.tileInfo
};
var valueTones = {
  neutral: void 0,
  muted: statStyles.valueMuted,
  accent: toneColorStyles.accent,
  success: toneColorStyles.success,
  warning: toneColorStyles.warning,
  danger: toneColorStyles.danger,
  info: toneColorStyles.info
};
var trendIcons = {
  up: ArrowUp,
  down: ArrowDown,
  flat: Minus
};
var trendLabels = {
  up: "Up",
  down: "Down",
  flat: "No change"
};
var trendTones = {
  up: "success",
  down: "danger",
  flat: "neutral"
};
var deltaView = (delta, config, h) => {
  const tone = delta.tone ?? trendTones[delta.trend];
  return h.span(slotAttrs(config.slotProps?.delta, h, statStyles.delta, tone === "neutral" ? statStyles.valueMuted : valueTones[tone]), [view2({
    icon: trendIcons[delta.trend],
    size: 12,
    strokeWidth: 2.25
  }, h), h.span(sxAttrs(h, contentStyles.visuallyHidden), [`${delta.trendLabel ?? trendLabels[delta.trend]} `]), delta.value, ...(delta.label === void 0 ? [] : [h.span(sxAttrs(h, statStyles.deltaLabel), [` ${delta.label}`])])]);
};
var view22 = (config, h) => {
  const tone = config.tone ?? "neutral";
  const isTile = (config.variant ?? "tile") === "tile";
  const isSmall = config.size === "sm";
  return h.dl(rootAttrs(config, h, statStyles.root, isTile && statStyles.tile, isTile && isSmall && statStyles.tileSm, isTile && tileTones[tone]), [h.dt(slotAttrs(config.slotProps?.label, h, statStyles.label), [...(config.media === void 0 ? [] : [config.media]), config.label]), h.dd(sxAttrs(h, statStyles.valueRow), [h.span(slotAttrs(config.slotProps?.value, h, statStyles.value, isSmall && statStyles.valueSm, valueTones[tone]), [config.value]), ...(config.delta === void 0 ? [] : [deltaView(config.delta, config, h)])]), ...(config.description === void 0 ? [] : [h.dd(slotAttrs(config.slotProps?.description, h, statStyles.description), [config.description])]), ...(config.children === void 0 ? [] : [h.dd(sxAttrs(h, statStyles.extra), config.children)])]);
};

// src/switch.ts
var switch_exports = {};
__export(switch_exports, {
  view: () => view23
});
var view23 = (config, h) => Switch.view({
  id: config.id,
  hasDescription: true,
  isChecked: config.isChecked,
  onToggle: config.onToggle,
  ...(config.isDisabled === void 0 ? {} : {
    isDisabled: config.isDisabled
  }),
  ...(config.isReadOnly === void 0 ? {} : {
    isReadOnly: config.isReadOnly
  }),
  ...(config.name === void 0 ? {} : {
    name: config.name
  }),
  ...(config.value === void 0 ? {} : {
    value: config.value
  }),
  toView: attributes => h.div(rootAttrs(config, h, switchStyles.root, config.isDisabled === true && switchStyles.disabled), [h.div(slotAttrs(config.slotProps?.copy, h, switchStyles.copy), [h.span([...attributes.label, ...slotAttrs(config.slotProps?.label, h, switchStyles.label)], [config.label]), view4(config.description, attributes.description, slotAttrs(config.slotProps?.description, h, switchStyles.description), h)]), h.button([...attributes.button, ...slotAttrs(config.slotProps?.control, h, switchStyles.control, config.isChecked && switchStyles.checked)], [h.span(slotAttrs(config.slotProps?.thumb, h, switchStyles.thumb, config.isChecked && switchStyles.thumbChecked))]), ...(attributes.hiddenInput.length === 0 ? [] : [h.input([...attributes.hiddenInput, ...slotAttrs(config.slotProps?.hiddenInput, h, switchStyles.hiddenInput)])])])
}, h);

// src/toolbar.ts
var toolbar_exports = {};
__export(toolbar_exports, {
  view: () => view24
});
var view24 = (config, h) => h.header(rootAttrs(config, h, toolbarStyles.root), [h.div(slotAttrs(config.slotProps?.copy, h, toolbarStyles.copy), [...(config.leading ?? []), h.h1(slotAttrs(config.slotProps?.title, h, toolbarStyles.title), [config.title]), ...(config.description === void 0 ? [] : [h.p(slotAttrs(config.slotProps?.description, h, toolbarStyles.description), [config.description])])]), h.div(slotAttrs(config.slotProps?.actions, h, toolbarStyles.actions), config.actions ?? [])]);
var styles7 = {
  stack: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x1ngs94h",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  row: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kwnvtZ: "x1a02dak",
    kOIVth: "x7agqhd",
    $$css: true
  },
  muted: {
    kMwMTN: "xyu5t3h",
    kGuDYH: "xwdf1oc",
    kLWn49: "x1evy7pa",
    $$css: true
  },
  label: {
    kGuDYH: "xwdf1oc",
    k63SB2: "x1uflamq",
    $$css: true
  },
  value: {
    kGuDYH: "xf92qd0",
    k63SB2: "x1uflamq",
    kcqcaj: "xss6m8b",
    $$css: true
  },
  list: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x1ngs94h",
    kB88ic: "xe8uvvx",
    kmVPX3: "x1717udv",
    kogj98: "x1ghz6dp",
    $$css: true
  },
  branch: {
    kZ1KPB: "xe0pwq",
    k4WBpm: "x19ypqd9",
    kaZRDh: "x1gku5c5",
    kE3dHu: "xdkax1o",
    keoZOQ: "xy4oe9p",
    $$css: true
  },
  box: {
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1ubh2qd",
    kaIpWk: "x3wpolg",
    kmVPX3: "x1szo1dz",
    $$css: true
  },
  title: {
    kGuDYH: "x1kio5tc",
    k63SB2: "x1uflamq",
    kogj98: "x1ghz6dp",
    $$css: true
  },
  before: {
    kMwMTN: "xyu5t3h",
    kybGjl: "xmqliwb",
    $$css: true
  },
  after: {
    k63SB2: "x1uflamq",
    $$css: true
  }
};
var explanation = (nodes, h) => h.ul(sxAttrs(h, styles7.list), nodes.map(node => h.li([], [h.div(sxAttrs(h, styles7.row), [view({
  label: node.outcome === "passed" ? "\u2713 Passed" : node.outcome === "failed" ? "\xD7 Failed" : "? Unknown",
  tone: node.outcome === "passed" ? "success" : node.outcome === "failed" ? "danger" : "neutral"
}, h), h.span(sxAttrs(h, styles7.label), [node.label])]), ...(node.detail === void 0 ? [] : [h.p(sxAttrs(h, styles7.muted), [node.detail])]), ...(node.children?.length ? [h.div(sxAttrs(h, styles7.branch), [explanation(node.children, h)])] : [])])));
var ExplanationTree = {
  view: (config, h) => h.section([h.AriaLabel(config.label)], [explanation(config.nodes, h)])
};
var ValueInspector = {
  view: (config, h) => h.section([...sxAttrs(h, styles7.stack), h.AriaLabel(`${config.label} details`)], [h.div(sxAttrs(h, styles7.row), [h.h3(sxAttrs(h, styles7.title), [config.label]), view({
    label: config.origin
  }, h), view({
    label: config.freshness,
    tone: config.freshness === "Current" ? "success" : "warning"
  }, h)]), h.p(sxAttrs(h, styles7.value), [config.value]), ...(config.context === void 0 ? [] : [h.p(sxAttrs(h, styles7.muted), [config.context])]), ...(config.children ?? [])])
};
var ChangeSetPreview = {
  view: (config, h) => h.section([...sxAttrs(h, styles7.stack), h.AriaLabel(config.label)], [h.h3(sxAttrs(h, styles7.title), [config.label]), h.p(sxAttrs(h, styles7.muted), [config.basis]), ...(config.content ?? []), ...(config.changes === void 0 ? [] : [h.ul(sxAttrs(h, styles7.list), config.changes.map(change => h.li(sxAttrs(h, styles7.box), [h.div(sxAttrs(h, styles7.label), [change.label]), h.div(sxAttrs(h, styles7.row), [h.span(sxAttrs(h, styles7.before), [change.before]), h.span([h.AriaLabel("changes to")], ["\u2192"]), h.span(sxAttrs(h, styles7.after), [change.after])])])))]), ...(config.consequences === void 0 ? [] : [h.h4(sxAttrs(h, styles7.title), ["Consequences"]), h.ul(sxAttrs(h, styles7.list), config.consequences.map(item2 => h.li([], [h.div(sxAttrs(h, styles7.row), [view({
    label: item2.kind === "added" ? "+ Added" : item2.kind === "removed" ? "\u2212 Removed" : "~ Changed",
    tone: item2.kind === "added" ? "info" : "neutral"
  }, h), h.span(sxAttrs(h, styles7.label), [item2.label])]), ...(item2.detail === void 0 ? [] : [h.p(sxAttrs(h, styles7.muted), [item2.detail])])])))]), ...(config.notices ?? []).map(notice => h.p(sxAttrs(h, styles7.muted), [notice])), h.div(sxAttrs(h, styles7.row), config.actions ?? [])])
};
var TransactionTimeline = {
  view: (config, h) => h.section([...sxAttrs(h, styles7.stack), h.AriaLabel(config.label)], [h.h3(sxAttrs(h, styles7.title), [config.label]), ...(config.entries.length === 0 ? [h.p(sxAttrs(h, styles7.muted), [config.emptyText ?? "No changes recorded."])] : []), h.ol(sxAttrs(h, styles7.list), config.entries.map(entry => {
    const body = config.renderBody?.(entry);
    return h.li([...sxAttrs(h, styles7.box), h.DataAttribute("entry-kind", entry.kind ?? "transaction")], [h.h4(sxAttrs(h, styles7.title), [entry.title]), h.p(sxAttrs(h, styles7.muted), [`${entry.actor} \xB7 ${entry.timestamp}`]), ...(body ? [body] : []), ...entry.changes.map(change => h.p(sxAttrs(h, styles7.label), [`${change.label}: ${change.before} \u2192 ${change.after}`])), h.p(sxAttrs(h, styles7.muted), [entry.context]), h.p(sxAttrs(h, styles7.muted), [entry.id])]);
  }))])
};
var placesOf = nodes => {
  const places = /* @__PURE__ */new Map();
  const visit = (level, parentId) => level.forEach((node, index) => {
    places.set(node.id, {
      parentId,
      index,
      node
    });
    visit(node.children ?? [], node.id);
  });
  visit(nodes, null);
  return places;
};
var longestIncreasing = values => {
  const tails = [];
  const previous = [];
  values.forEach((value, at) => {
    let low = 0,
      high = tails.length;
    while (low < high) {
      const middle = low + high >> 1;
      if (values[tails[middle]] < value) low = middle + 1;else high = middle;
    }
    previous[at] = low > 0 ? tails[low - 1] : -1;
    tails[low] = at;
  });
  const kept = /* @__PURE__ */new Set();
  for (let at = tails.at(-1) ?? -1; at >= 0; at = previous[at]) kept.add(at);
  return kept;
};
var diffTrees = (before, after) => {
  const old = placesOf(before);
  const now = placesOf(after);
  const reordered = /* @__PURE__ */new Set();
  const findReordered = (nodes, parentId) => {
    const stayed = nodes.filter(node => old.get(node.id)?.parentId === parentId);
    const kept = longestIncreasing(stayed.map(node => old.get(node.id).index));
    stayed.forEach((node, at) => {
      if (!kept.has(at)) reordered.add(node.id);
    });
    for (const node of nodes) findReordered(node.children ?? [], node.id);
  };
  findReordered(after, null);
  const removedUnder = parentId => {
    const groups = /* @__PURE__ */new Map();
    const children = parentId === null ? before : old.get(parentId)?.node.children ?? [];
    let anchor2 = null;
    for (const child of children) {
      const place = now.get(child.id);
      if (place === void 0) groups.set(anchor2, [...(groups.get(anchor2) ?? []), child]);else if (place.parentId === parentId) anchor2 = child.id;
    }
    return groups;
  };
  const rows = [];
  const emitRemoved = (node, depth) => {
    rows.push({
      _tag: "Node",
      id: node.id,
      label: node.label,
      depth,
      status: "Removed"
    });
    for (const child of node.children ?? []) if (!now.has(child.id)) emitRemoved(child, depth + 1);
  };
  const emit = (nodes, parentId, depth) => {
    const removed = parentId === null || old.has(parentId) ? removedUnder(parentId) : /* @__PURE__ */new Map();
    for (const gone of removed.get(null) ?? []) emitRemoved(gone, depth);
    for (const node of nodes) {
      const previous = old.get(node.id);
      const status = previous === void 0 ? "Added" : previous.parentId !== parentId || reordered.has(node.id) ? "Moved" : previous.node.label !== node.label ? "Edited" : "Unchanged";
      rows.push({
        _tag: "Node",
        id: node.id,
        label: node.label,
        depth,
        status,
        ...(previous !== void 0 && previous.node.label !== node.label ? {
          was: previous.node.label
        } : {})
      });
      emit(node.children ?? [], node.id, depth + 1);
      for (const gone of removed.get(node.id) ?? []) emitRemoved(gone, depth);
    }
  };
  emit(after, null, 0);
  return rows;
};
var changedRegion = (rows, context = 1) => {
  const changed = rows.flatMap((row2, at) => row2.status === "Unchanged" ? [] : [at]);
  if (changed.length === 0) return [];
  const parentOf = [];
  const stack2 = [];
  rows.forEach((row2, at) => {
    while (stack2.length > 0 && rows[stack2.at(-1)].depth >= row2.depth) stack2.pop();
    parentOf[at] = stack2.at(-1) ?? -1;
    stack2.push(at);
  });
  const chain = at => {
    const path = [];
    for (let node = at; node >= 0; node = parentOf[node]) path.unshift(node);
    return path;
  };
  const chains = changed.map(at => chain(parentOf[at]));
  let root = -1;
  for (let level = 0; chains.every(path => path[level] !== void 0 && path[level] === chains[0][level]); level += 1) {
    root = chains[0][level];
  }
  const kept = /* @__PURE__ */new Set([root]);
  const counted = /* @__PURE__ */new Set([root, ...changed]);
  const siblings = /* @__PURE__ */new Map();
  rows.forEach((_, at) => siblings.set(parentOf[at], [...(siblings.get(parentOf[at]) ?? []), at]));
  for (const at of changed) {
    for (const node of chain(at)) {
      kept.add(node);
      counted.add(node);
    }
    const around = siblings.get(parentOf[at]) ?? [];
    const position = around.indexOf(at);
    for (const sibling of around.slice(Math.max(0, position - context), position + context + 1)) kept.add(sibling);
  }
  const base = root < 0 ? 0 : rows[root].depth;
  const start = root < 0 ? 0 : root;
  const result = [];
  let hidden = [];
  const flush = () => {
    if (hidden.length === 1) result.push({
      ...rows[hidden[0]],
      depth: rows[hidden[0]].depth - base
    });else if (hidden.length > 1) result.push({
      _tag: "Elided",
      depth: rows[hidden[0]].depth - base,
      count: hidden.length
    });
    hidden = [];
  };
  for (let at = start; at < rows.length; at += 1) {
    const row2 = rows[at];
    if (root >= 0 && at > root && row2.depth <= rows[root].depth) break;
    if (kept.has(at)) {
      flush();
      result.push({
        ...row2,
        depth: row2.depth - base
      });
    } else if (counted.has(parentOf[at])) {
      if (hidden.length > 0 && parentOf[hidden[0]] !== parentOf[at]) flush();
      hidden.push(at);
    }
  }
  flush();
  return result;
};
var summarizeDiff = rows => {
  const counts = {
    Added: 0,
    Removed: 0,
    Moved: 0,
    Edited: 0
  };
  for (const row2 of rows) {
    if (row2._tag !== "Node" || row2.status === "Unchanged") continue;
    counts[row2.status] += 1;
    if (row2.status === "Moved" && row2.was !== void 0) counts.Edited += 1;
  }
  return counts;
};
var styles8 = {
  root: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x7agqhd",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  summary: {
    kogj98: "x1ghz6dp",
    kMwMTN: "xyu5t3h",
    kGuDYH: "xwdf1oc",
    $$css: true
  },
  list: {
    kB88ic: "xe8uvvx",
    kogj98: "x1ghz6dp",
    kmVPX3: "x1ykk9uh",
    k7Eaqz: "xeuugli",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1ubh2qd",
    kaIpWk: "x3wpolg",
    kWkggS: "x13zjy52",
    kMwMTN: "x2pdk8c",
    kGuDYH: "xwdf1oc",
    kLWn49: "x1fc57z9",
    $$css: true
  },
  row: {
    k1xSpc: "x78zum5",
    kGNEyG: "x1pha0wt",
    kOIVth: "x1kd3ua",
    k7Eaqz: "xeuugli",
    kwRFfy: "xngqqzl",
    kaIpWk: "x5i151u",
    $$css: true
  },
  added: {
    kWkggS: "x1x4pbqu",
    $$css: true
  },
  removed: {
    kWkggS: "xve6jz8",
    kMwMTN: "xyu5t3h",
    kybGjl: "xmqliwb",
    $$css: true
  },
  moved: {
    kWkggS: "x95chvd",
    $$css: true
  },
  edited: {
    kWkggS: "x1fyvr3y",
    $$css: true
  },
  marker: {
    kUk6DE: "x1okw0bk",
    kzqmXN: "x93kpjw",
    k9WMMc: "x2b8uid",
    k63SB2: "x1uflamq",
    kMwMTN: "xyu5t3h",
    $$css: true
  },
  addedMarker: {
    kMwMTN: "x15kbz4b",
    $$css: true
  },
  removedMarker: {
    kMwMTN: "x1g3r7qa",
    $$css: true
  },
  movedMarker: {
    kMwMTN: "xhje13v",
    $$css: true
  },
  editedMarker: {
    kMwMTN: "xegcg24",
    $$css: true
  },
  label: {
    k7Eaqz: "xeuugli",
    kVQacm: "xb3r6kr",
    kg5iWk: "xlyipyv",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  was: {
    kUk6DE: "x1okw0bk",
    ks0D6T: "x1y8h3ww",
    kVQacm: "xb3r6kr",
    kg5iWk: "xlyipyv",
    khDVqt: "xuxw1ft",
    kMwMTN: "xyu5t3h",
    $$css: true
  },
  elided: {
    kMwMTN: "xyu5t3h",
    kKX8nH: "x1k4tb9n",
    $$css: true
  },
  hidden: {
    kVAEAm: "x10l6tqk",
    kzqmXN: "x1i1rx1s",
    kZKoxP: "xjm9jq1",
    kVQacm: "xb3r6kr",
    kz4h6p: "x1hyvwdk",
    khDVqt: "xuxw1ft",
    $$css: true
  }
};
var MARKERS = {
  Unchanged: "",
  Added: "+",
  Removed: "\u2212",
  Moved: "\u2192",
  Edited: "~"
};
var plural = (count, noun) => `${count} ${noun}`;
var TreeDiff = {
  view: (config, h) => {
    const rows = changedRegion(diffTrees(config.before, config.after), config.context ?? 1);
    const counts = summarizeDiff(rows);
    const summary = [counts.Added > 0 ? plural(counts.Added, "added") : "", counts.Removed > 0 ? plural(counts.Removed, "removed") : "", counts.Moved > 0 ? plural(counts.Moved, "moved") : "", counts.Edited > 0 ? plural(counts.Edited, "edited") : ""].filter(part => part !== "").join(" \xB7 ");
    return h.section([...sxAttrs(h, styles8.root), h.AriaLabel(config.label), h.DataAttribute("tree-diff", "true")], [h.p(sxAttrs(h, styles8.summary), [rows.length === 0 ? config.emptyText ?? "No changes." : summary]), ...(rows.length === 0 ? [] : [h.ul([...sxAttrs(h, styles8.list), h.Role("list")], rows.map(row2 => row2._tag === "Elided" ? h.li([...sxAttrs(h, styles8.row, styles8.elided), h.DataAttribute("tree-diff-elided", String(row2.count)), h.Style({
      paddingInlineStart: `calc(${row2.depth} * 16px + 1.25em + 4px)`
    })], [`\u22EF ${row2.count} unchanged`]) : h.li([...sxAttrs(h, styles8.row, row2.status === "Added" && styles8.added, row2.status === "Removed" && styles8.removed, row2.status === "Moved" && styles8.moved, row2.status === "Edited" && styles8.edited), h.DataAttribute("tree-diff-row", row2.id), h.DataAttribute("status", row2.status), h.Style({
      paddingInlineStart: `calc(${row2.depth} * 16px + 4px)`
    })], [h.span([...sxAttrs(h, styles8.marker, row2.status === "Added" && styles8.addedMarker, row2.status === "Removed" && styles8.removedMarker, row2.status === "Moved" && styles8.movedMarker, row2.status === "Edited" && styles8.editedMarker), h.AriaHidden(true)], [MARKERS[row2.status]]), h.span([...sxAttrs(h, styles8.label), h.Title(row2.label)], [row2.label.split("\n")[0] || "Untitled"]), ...(row2.was === void 0 ? [] : [h.span([...sxAttrs(h, styles8.was), h.Title(row2.was)], [`was ${row2.was.split("\n")[0]}`])]), ...(row2.status === "Unchanged" ? [] : [h.span(sxAttrs(h, styles8.hidden), [` (${row2.status === "Moved" && row2.was !== void 0 ? "moved and edited" : row2.status.toLowerCase()})`])])])))])]);
  }
};

// src/collections.ts
var accordion = (config, h) => h.div(sxAttrs(h, layoutStyles.stack), config.items.map(item2 => view8(item2, h)));
var Accordion = {
  view: accordion
};
var Collapsible = {
  view: view8
};

// src/content.ts
var textSize = size => ({
  xs: contentStyles.textXs,
  sm: contentStyles.textSm,
  md: contentStyles.textMd,
  lg: contentStyles.textLg,
  xl: contentStyles.textXl
})[size];
var textTone = tone => ({
  default: contentStyles.toneDefault,
  muted: contentStyles.toneMuted,
  success: contentStyles.toneSuccess,
  warning: contentStyles.toneWarning,
  danger: contentStyles.toneDanger
})[tone];
var textWeight = weight => ({
  regular: contentStyles.weightRegular,
  medium: contentStyles.weightMedium,
  semibold: contentStyles.weightSemibold,
  bold: contentStyles.weightBold
})[weight];
var text = (config, h) => {
  const attributes = styledAttrs(config, h, contentStyles.text, textSize(config.size ?? "md"), textTone(config.tone ?? "default"), textWeight(config.weight ?? "regular"), config.align === "center" && contentStyles.alignCenter, config.align === "end" && contentStyles.alignEnd, config.truncate === true && contentStyles.truncate);
  switch (config.as ?? "p") {
    case "span":
      return h.span(attributes, config.children);
    case "div":
      return h.div(attributes, config.children);
    case "p":
      return h.p(attributes, config.children);
  }
};
var heading = (config, h) => {
  const size = config.size ?? {
    1: "xl",
    2: "lg",
    3: "md",
    4: "sm",
    5: "sm",
    6: "sm"
  }[config.level ?? 2];
  const attributes = styledAttrs(config, h, contentStyles.heading, textTone(config.tone ?? "default"), {
    sm: contentStyles.headingSm,
    md: contentStyles.headingMd,
    lg: contentStyles.headingLg,
    xl: contentStyles.headingXl
  }[size]);
  switch (config.level ?? 2) {
    case 1:
      return h.h1(attributes, config.children);
    case 2:
      return h.h2(attributes, config.children);
    case 3:
      return h.h3(attributes, config.children);
    case 4:
      return h.h4(attributes, config.children);
    case 5:
      return h.h5(attributes, config.children);
    case 6:
      return h.h6(attributes, config.children);
  }
};
var link = (config, h) => {
  const target = config.target ?? (config.external === true ? "_blank" : void 0);
  const rel = config.rel ?? (target === "_blank" ? "noreferrer noopener" : void 0);
  return h.a([...styledAttrs(config, h, contentStyles.link), h.Href(config.href), ...(target === void 0 ? [] : [h.Target(target)]), ...(rel === void 0 ? [] : [h.Rel(rel)]), ...(config.current === void 0 ? [] : [h.AriaCurrent(config.current)])], config.children);
};
var visuallyHidden = (config, h) => h.span([...styledAttrs(config, h, config.focusable === true ? contentStyles.visuallyHiddenFocusable : contentStyles.visuallyHidden), ...(config.focusable === true ? [h.Tabindex(0)] : [])], config.children);
var Text = {
  view: text
};
var Heading = {
  view: heading
};
var Link = {
  view: link
};
var VisuallyHidden = {
  view: visuallyHidden
};
var rowHover = `linear-gradient(color-mix(in oklch, ${colors.foreground} 5%, transparent), color-mix(in oklch, ${colors.foreground} 5%, transparent))`;
var denseStyles = {
  alignStart: {
    k9WMMc: "x1yc453h",
    $$css: true
  },
  alignCenter: {
    k9WMMc: "x2b8uid",
    $$css: true
  },
  alignEnd: {
    k9WMMc: "xp4054r",
    $$css: true
  },
  rowHeader: {
    k63SB2: "x1b3j4lt",
    k9WMMc: "x1yc453h",
    $$css: true
  },
  rowInteractive: {
    kKwaWg: "x18o3ruo xgqjf2s x1goc9sq",
    kkrTdU: "x1ypdohk",
    $$css: true
  },
  rowInfo: {
    kWkggS: "x95chvd",
    $$css: true
  },
  rowSuccess: {
    kWkggS: "x1x4pbqu",
    $$css: true
  },
  rowWarning: {
    kWkggS: "x1fyvr3y",
    $$css: true
  },
  rowDanger: {
    kWkggS: "xve6jz8",
    $$css: true
  },
  rowSelected: {
    kWkggS: "x4ov27q",
    $$css: true
  },
  rowAction: {
    kWkggS: "xjbqb8w",
    kaIpWk: "x5i151u",
    kMwMTN: "x1heor9g",
    kkrTdU: "x1ypdohk",
    kVVagm: "xln7xf2",
    kmVPX3: "x1717udv",
    k9WMMc: "x16tdsg8",
    $$css: true
  },
  itemInteractive: {
    kWkggS: "x16z3jmj xdnxrc x5kilcl",
    kMwMTN: "x1ys4cjs",
    kkrTdU: "x1ypdohk",
    kVVagm: "xln7xf2",
    k9WMMc: "x1yc453h",
    kybGjl: "x1hl2dhg",
    kIyJzY: "x1xy946n x12w9bfk",
    k1ekBW: "xts7igz",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  itemPressed: {
    kWkggS: "xtvgv0j",
    kVAM5u: "x1hza1xs",
    $$css: true
  },
  itemSelected: {
    kWkggS: "x4ov27q",
    kVAM5u: "x1biuxk5",
    $$css: true
  },
  itemDisabled: {
    kkrTdU: "x1h6gzvc",
    kSiTet: "xwq05k6",
    $$css: true
  },
  itemBlock: {
    k1xSpc: "x1lliihq",
    $$css: true
  },
  itemTrailing: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x3nfvp2",
    kmuXW: "x2lah0s",
    kOIVth: "x7agqhd",
    $$css: true
  },
  tooltipRoot: {
    k1xSpc: "x3nfvp2",
    ks0D6T: "x193iq5w",
    kVAEAm: "x1n2onr6",
    $$css: true
  },
  tooltipTrigger: {
    kGNEyG: "x6s0dn4",
    kaIpWk: "x5i151u",
    k1xSpc: "x3nfvp2",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  tooltipPanel: {
    k63SB2: "x1fcty0u",
    kLWn49: "xgsdihv",
    ks0D6T: "x16em4ew",
    kSiTet: "xg01cxk x6bswoq x1welr6k",
    kVAEAm: "x10l6tqk",
    k9WMMc: "x1yc453h",
    kIr0Dl: "x1ahifba x1meb5dc",
    kIyJzY: "x1xy946n x12w9bfk",
    k1ekBW: "x1jl3cmp",
    k33iCy: "xlshs6z x17t498l x1bsyqup",
    khDVqt: "x1fj9vlw",
    kzqmXN: "xezivpi",
    kY2c9j: "xa9119d",
    kgeoSG: "x1cpjm7i",
    kFcpXp: "xrpxzf2",
    kEoFBp: "x1hmns74",
    $$css: true
  },
  tooltipTop: {
    krVfgx: "x10w3d4m",
    kbCHJM: "x1nrll8i",
    k1K539: "x1x4ksus",
    k3aq6I: "xuuh30",
    $$css: true
  },
  tooltipBottom: {
    kbCHJM: "x1nrll8i",
    keoZOQ: "xy4oe9p",
    k87sOh: "xdsb8wn",
    k3aq6I: "xuuh30",
    $$css: true
  },
  tooltipStart: {
    kt4wiu: "x1eu7cjg",
    k71WvV: "x1y957ti",
    k87sOh: "xwa60dl",
    k3aq6I: "x1cb1t30",
    $$css: true
  },
  tooltipEnd: {
    kLqNvP: "x2hswfz",
    keTefX: "xkvhg5v",
    k87sOh: "xwa60dl",
    k3aq6I: "x1cb1t30",
    $$css: true
  }
};

// src/display.ts
var alert = (config, h) => h.div([...styledAttrs(config, h, catalogStyles.surface, catalogStyles.alert, config.tone === "danger" && catalogStyles.alertDanger), h.Role(config.tone === "danger" ? "alert" : "status"), ...(config.live === void 0 ? [] : [h.AriaLive(config.live)])], [h.div(sxAttrs(h, catalogStyles.title), [config.title]), ...(config.description === void 0 ? [] : [h.p(sxAttrs(h, catalogStyles.description), [config.description])]), ...(config.children ?? [])]);
var aspectRatio = (config, h) => {
  const ratio = config.ratio ?? 16 / 9;
  return h.div([...styledAttrs(config, h, catalogStyles.aspectRatio), h.Style({
    paddingBottom: `${100 / ratio}%`
  })], [h.div(sxAttrs(h, catalogStyles.aspectRatioContent), config.children)]);
};
var avatar = (config, h) => h.span(styledAttrs(config, h, catalogStyles.avatar, config.size === "sm" && catalogStyles.avatarSm, config.size === "lg" && catalogStyles.avatarLg), config.src === void 0 ? [h.span([h.AriaHidden(true)], [config.fallback])] : [h.img([...sxAttrs(h, catalogStyles.avatarImage), h.Src(config.src), h.Alt(config.alt)])]);
var card = (config, h) => h.section(rootAttrs(config, h, catalogStyles.surface, catalogStyles.card), [...(config.title === void 0 && config.description === void 0 && config.action === void 0 ? [] : [h.header(slotAttrs(config.slotProps?.header, h, catalogStyles.cardHeader, config.flush === true && catalogStyles.cardHeaderFlush), [h.div(slotAttrs(config.slotProps?.heading, h, catalogStyles.cardHeading), [...(config.title === void 0 ? [] : [h.h3(slotAttrs(config.slotProps?.title, h, catalogStyles.title), [config.title])]), ...(config.description === void 0 ? [] : [h.p(slotAttrs(config.slotProps?.description, h, catalogStyles.description), [config.description])])]), ...(config.action === void 0 ? [] : [h.div(slotAttrs(config.slotProps?.action, h, catalogStyles.cardAction), config.action)])])]), h.div(slotAttrs(config.slotProps?.content, h, catalogStyles.cardContent, config.flush === true && catalogStyles.cardContentFlush), config.children), ...(config.footer === void 0 ? [] : [h.footer(slotAttrs(config.slotProps?.footer, h, catalogStyles.cardFooter, config.flush === true && catalogStyles.cardFooterFlush), config.footer)])]);
var empty = (config, h) => h.div(styledAttrs(config, h, catalogStyles.inset, catalogStyles.empty), [...(config.media === void 0 ? [] : [h.div(sxAttrs(h, catalogStyles.emptyMedia), [config.media])]), h.h3(sxAttrs(h, catalogStyles.title), [config.title]), ...(config.description === void 0 ? [] : [h.p(sxAttrs(h, catalogStyles.description), [config.description])]), ...(config.actions ?? [])]);
var isInteractiveItem = config => config.onClick !== void 0 || config.href !== void 0;
var item = (config, h) => isInteractiveItem(config) ? interactiveItem(config, h) : h.div(styledAttrs(config, h, catalogStyles.inset, catalogStyles.item), [...(config.media === void 0 ? [] : [h.div(sxAttrs(h, catalogStyles.itemMedia), [config.media])]), h.div(sxAttrs(h, catalogStyles.itemContent), [h.div(sxAttrs(h, catalogStyles.title), [config.title]), ...(config.description === void 0 ? [] : [h.p(sxAttrs(h, catalogStyles.description), [config.description])])]), ...(config.actions ?? [])]);
var interactiveItem = (config, h) => {
  const isDisabled = config.isDisabled === true;
  const isPressed = config.href === void 0 && config.isPressed === true;
  const attributes = [...styledAttrs(config, h, catalogStyles.inset, catalogStyles.item, denseStyles.itemInteractive, catalogStyles.focusable, isPressed && denseStyles.itemPressed, config.isSelected === true && denseStyles.itemSelected, isDisabled && denseStyles.itemDisabled), ...(config.ariaLabel === void 0 ? [] : [h.AriaLabel(config.ariaLabel)]), ...(config.isSelected === true ? [h.AriaCurrent("true")] : [])];
  const children = [...(config.media === void 0 ? [] : [h.span(sxAttrs(h, catalogStyles.itemMedia), [config.media])]), h.span(sxAttrs(h, catalogStyles.itemContent), [h.span(sxAttrs(h, catalogStyles.title), [config.title]), ...(config.description === void 0 ? [] : [h.span(sxAttrs(h, catalogStyles.description, denseStyles.itemBlock), [config.description])])]), ...(config.trailing === void 0 ? [] : [h.span(sxAttrs(h, denseStyles.itemTrailing), config.trailing)])];
  if (config.href !== void 0) {
    return h.a([...attributes, ...(isDisabled ? [h.AriaDisabled(true)] : [h.Href(config.href), ...(config.onClick === void 0 ? [] : [h.OnClick(config.onClick)])])], children);
  }
  return h.button([...attributes, h.Type("button"), h.Disabled(isDisabled), ...(config.isPressed === void 0 ? [] : [h.AriaPressed(String(config.isPressed))]), ...(isDisabled ? [] : [h.OnClick(config.onClick)])], children);
};
var kbd = (config, h) => h.span(styledAttrs(config, h, catalogStyles.group), config.keys.flatMap((key2, index) => [...(index === 0 ? [] : ["+"]), h.kbd(sxAttrs(h, catalogStyles.kbd), [key2])]));
var separator = (config, h) => h.div([...styledAttrs(config, h, config.orientation === "vertical" ? catalogStyles.separatorVertical : catalogStyles.separatorHorizontal), ...(config.decorative === false ? [h.Role("separator"), h.AriaOrientation(config.orientation ?? "horizontal")] : [h.AriaHidden(true)])]);
var alignStyles = {
  start: denseStyles.alignStart,
  center: denseStyles.alignCenter,
  end: denseStyles.alignEnd
};
var toneStyles = {
  default: void 0,
  info: denseStyles.rowInfo,
  success: denseStyles.rowSuccess,
  warning: denseStyles.rowWarning,
  danger: denseStyles.rowDanger
};
var isCellConfig = cell => typeof cell === "object" && cell !== null && "content" in cell;
var isRowConfig = row2 => !Array.isArray(row2);
var cellContent = content => Array.isArray(content) ? content : [content];
var layeredAttrs = (layers, h, ...recipe) => [...layers.flatMap(layer => layer?.attributes ?? []), ...sxAttrs(h, ...recipe, ...layers.map(layer => layer?.sx))];
var table = (config, h) => {
  const slots = config.slotProps;
  const columns = config.columns.map(column => typeof column === "string" ? {
    label: column
  } : column);
  const columnAlign = index => columns[index]?.align;
  const row2 = entry => {
    const rowConfig = isRowConfig(entry) ? entry : void 0;
    const isInteractive = rowConfig?.onClick !== void 0;
    const isSelected = rowConfig?.isSelected === true;
    let column = 0;
    const cells = (rowConfig?.cells ?? entry).map((cell, index) => {
      const cellConfig = isCellConfig(cell) ? cell : void 0;
      const align = cellConfig?.align ?? columnAlign(column);
      column += cellConfig?.colSpan ?? 1;
      const isHeader = cellConfig?.isHeader ?? (config.rowHeaders === true && index === 0);
      const content = cellConfig === void 0 ? [cell] : cellContent(cellConfig.content);
      const attributes = [...layeredAttrs([slots?.cell, cellConfig], h, catalogStyles.tableCell, isHeader && denseStyles.rowHeader, align !== void 0 && alignStyles[align]), ...(isHeader ? [h.Scope("row")] : []), ...(cellConfig?.colSpan === void 0 ? [] : [h.Colspan(cellConfig.colSpan)]), ...(cellConfig?.rowSpan === void 0 ? [] : [h.Rowspan(cellConfig.rowSpan)]), ...(cellConfig?.width === void 0 ? [] : [h.Style({
        width: cellConfig.width
      })])];
      const children = isInteractive && index === 0 ? [h.button([...sxAttrs(h, denseStyles.rowAction, catalogStyles.focusable), h.Type("button"), ...(rowConfig?.ariaLabel === void 0 ? [] : [h.AriaLabel(rowConfig.ariaLabel)]), ...(isSelected ? [h.AriaCurrent("true")] : [])], content)] : content;
      return isHeader ? h.th(attributes, children) : h.td(attributes, children);
    });
    if (rowConfig === void 0) return h.tr(slotAttrs(slots?.row, h), cells);
    const tone = rowConfig.tone ?? "default";
    return h.keyed("tr")(rowConfig.key, [...layeredAttrs([slots?.row, rowConfig], h, toneStyles[tone], isSelected && denseStyles.rowSelected, isInteractive && denseStyles.rowInteractive), ...(tone === "default" ? [] : [h.DataAttribute("tone", tone)]), ...(isSelected ? [h.DataAttribute("selected", "true")] : []), ...(rowConfig.onClick === void 0 ? [] : [h.OnClick(rowConfig.onClick)]), ...(!isInteractive && isSelected ? [h.AriaCurrent("true")] : []), ...(!isInteractive && rowConfig.ariaLabel !== void 0 ? [h.AriaLabel(rowConfig.ariaLabel)] : [])], cells);
  };
  return h.div(rootAttrs(config, h, catalogStyles.tableWrap), [h.table(slotAttrs(slots?.table, h, catalogStyles.table), [...(config.caption === void 0 ? [] : [h.caption(slotAttrs(slots?.caption, h), [config.caption])]), ...(columns.some(column => column.width !== void 0) ? [h.colgroup([], columns.map(column => h.col(column.width === void 0 ? [] : [h.Style({
    width: column.width
  })])))] : []), h.thead(slotAttrs(slots?.head, h), [h.tr([], columns.map(column => {
    const align = column.headerAlign ?? column.align;
    return h.th([...layeredAttrs([slots?.headerCell, column], h, catalogStyles.tableHead, align !== void 0 && alignStyles[align]), h.Scope("col")], [column.label]);
  }))]), h.tbody(slotAttrs(slots?.body, h), config.rows.map(row2))])]);
};
var chart = (config, h) => {
  const max = config.max ?? Math.max(...config.values, 1);
  return h.div([...styledAttrs(config, h, catalogStyles.chart), h.Role("img"), h.AriaLabel(config.ariaLabel)], config.values.map((value, index) => h.div([...sxAttrs(h, catalogStyles.chartBar), h.Style({
    height: `${clamp(value / max, 0, 1) * 100}%`,
    backgroundColor: `var(--chart-${index % 5 + 1})`
  }), h.Title(String(value))])));
};
var Alert = {
  view: alert
};
var AspectRatio = {
  view: aspectRatio
};
var Avatar = {
  view: avatar
};
var Card = {
  view: card
};
var Chart = {
  view: chart
};
var Empty = {
  view: empty
};
var Item = {
  view: item
};
var Kbd = {
  view: kbd
};
var Separator = {
  view: separator
};
var Table = {
  view: table
};

// src/direction.ts
var view25 = (config, h) => h.div([...styledAttrs(config, h), h.Dir(config.direction)], config.children);
var Direction = {
  view: view25
};

// src/forms.ts
var controlAttributes = (config, h) => [...styledAttrs(config, h, catalogStyles.control, catalogStyles.focusable), ...(config.id === void 0 ? [] : [h.Id(config.id)]), ...(config.name === void 0 ? [] : [h.Name(config.name)]), ...(config.value === void 0 ? [] : [h.Value(config.value)]), ...(config.placeholder === void 0 ? [] : [h.Placeholder(config.placeholder)]), ...(config.ariaLabel === void 0 ? [] : [h.AriaLabel(config.ariaLabel)]), ...(config.ariaLabelledBy === void 0 ? [] : [h.AriaLabelledBy(config.ariaLabelledBy)]), ...(config.isDisabled === void 0 ? [] : [h.Disabled(config.isDisabled)]), ...(config.isReadOnly === void 0 ? [] : [h.Readonly(config.isReadOnly)]), ...(config.isRequired === void 0 ? [] : [h.Required(config.isRequired)]), ...(config.isInvalid === void 0 ? [] : [h.AriaInvalid(config.isInvalid)]), ...(config.onInput === void 0 ? [] : [h.OnInput(config.onInput)]), ...(config.onChange === void 0 ? [] : [h.OnChange(config.onChange)])];
var maskedValue = (value, type) => type === "password" && value !== void 0 && value !== "" ? "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022" : value;
var controlValue = (config, h, isMultiline) => {
  const value = maskedValue(config.value, config.type);
  return view9({
    ...(config.attributes === void 0 ? {} : {
      attributes: config.attributes
    }),
    ...(config.sx === void 0 ? {} : {
      sx: config.sx
    }),
    ...(config.id === void 0 ? {} : {
      id: config.id
    }),
    ...(value === void 0 ? {} : {
      value
    }),
    ...(config.ariaLabel === void 0 ? {} : {
      ariaLabel: config.ariaLabel
    }),
    ...(config.ariaLabelledBy === void 0 ? {} : {
      ariaLabelledBy: config.ariaLabelledBy
    }),
    ...(config.name === void 0 || config.isDisabled === true ? {} : {
      name: config.name
    }),
    ...(config.value === void 0 ? {} : {
      formValue: config.value
    }),
    ...(config.isInvalid === void 0 ? {} : {
      isInvalid: config.isInvalid
    }),
    isMultiline
  }, h);
};
var input2 = (config, h) => config.presentation === "value" ? controlValue(config, h, false) : h.input([...controlAttributes(config, h), h.Type(config.type ?? "text")]);
var textarea2 = (config, h) => config.presentation === "value" ? controlValue(config, h, true) : h.textarea([...controlAttributes(config, h), ...sxAttrs(h, catalogStyles.textarea), ...(config.rows === void 0 ? [] : [h.Rows(config.rows)])]);
var label = (config, h) => h.label([...styledAttrs(config, h, catalogStyles.label), h.For(config.for), ...(config.id === void 0 ? [] : [h.Id(config.id)]), ...(config.isDisabled === true ? [h.AriaDisabled(true)] : [])], config.children);
var nativeSelect = (config, h) => {
  if (config.presentation === "value") {
    const value = optionLabel(config.value, config.options);
    return view9({
      ...(config.attributes === void 0 ? {} : {
        attributes: config.attributes
      }),
      ...(config.sx === void 0 ? {} : {
        sx: config.sx
      }),
      ...(config.id === void 0 ? {} : {
        id: config.id
      }),
      ...(value === void 0 ? {} : {
        value
      }),
      ...(config.name === void 0 || config.isDisabled === true ? {} : {
        name: config.name
      }),
      ...(config.isInvalid === void 0 ? {} : {
        isInvalid: config.isInvalid
      }),
      ariaLabel: config.ariaLabel,
      formValue: config.value
    }, h);
  }
  return h.select([...styledAttrs(config, h, catalogStyles.control, catalogStyles.focusable), h.Value(config.value), h.AriaLabel(config.ariaLabel), ...(config.id === void 0 ? [] : [h.Id(config.id)]), ...(config.name === void 0 ? [] : [h.Name(config.name)]), ...(config.isDisabled === void 0 ? [] : [h.Disabled(config.isDisabled)]), ...(config.isInvalid === void 0 ? [] : [h.AriaInvalid(config.isInvalid)]), ...(config.onChange === void 0 ? [] : [h.OnChange(config.onChange)])], config.options.map(option => h.option([h.Value(option.value), h.Selected(option.value === config.value), ...(option.isDisabled === void 0 ? [] : [h.Disabled(option.isDisabled)])], [option.label])));
};
var inputGroup = (config, h) => h.div(styledAttrs(config, h, catalogStyles.inset, catalogStyles.inputGroup), [...(config.prefix === void 0 ? [] : [h.div(sxAttrs(h, catalogStyles.inputGroupAddon), config.prefix)]), h.div(sxAttrs(h, catalogStyles.inputGroupControl), [config.control]), ...(config.suffix === void 0 ? [] : [h.div(sxAttrs(h, catalogStyles.inputGroupAddon), config.suffix)])]);
var inputGroupInput = (config, h) => h.input([...styledAttrs(config, h, catalogStyles.control, catalogStyles.focusable, catalogStyles.inputGroupControl), ...(config.id === void 0 ? [] : [h.Id(config.id)]), ...(config.name === void 0 ? [] : [h.Name(config.name)]), ...(config.value === void 0 ? [] : [h.Value(config.value)]), ...(config.placeholder === void 0 ? [] : [h.Placeholder(config.placeholder)]), ...(config.ariaLabel === void 0 ? [] : [h.AriaLabel(config.ariaLabel)]), ...(config.isDisabled === void 0 ? [] : [h.Disabled(config.isDisabled)]), ...(config.isReadOnly === void 0 ? [] : [h.Readonly(config.isReadOnly)]), ...(config.onInput === void 0 ? [] : [h.OnInput(config.onInput)]), ...(config.onChange === void 0 ? [] : [h.OnChange(config.onChange)]), h.Type(config.type ?? "text")]);
var inputOtp = (config, h) => {
  const length = config.length ?? 6;
  return h.div(styledAttrs(config, h, catalogStyles.otp), [h.input([...sxAttrs(h, catalogStyles.control, catalogStyles.focusable), h.Value(config.value), h.AriaLabel(config.ariaLabel ?? "One-time password"), h.Attribute("inputmode", "numeric"), h.Attribute("autocomplete", "one-time-code"), h.Attribute("maxlength", String(length)), h.Style({
    fontFamily: "ui-monospace, monospace",
    letterSpacing: "0.65em",
    width: `${length * 2.25}rem`
  }), ...(config.isDisabled === void 0 ? [] : [h.Disabled(config.isDisabled)]), ...(config.onInput === void 0 ? [] : [h.OnInput(value => config.onInput?.(value.replace(/\D/g, "").slice(0, length)))])])]);
};
var radioGroup = (config, h) => {
  if (config.presentation === "value") {
    const value = optionLabel(config.value, config.options);
    return view9({
      ...(config.attributes === void 0 ? {} : {
        attributes: config.attributes
      }),
      ...(config.sx === void 0 ? {} : {
        sx: config.sx
      }),
      ...(value === void 0 ? {} : {
        value
      }),
      ...(config.value === void 0 ? {} : {
        formValue: config.value
      }),
      ariaLabel: config.ariaLabel,
      // Native radios only submit a checked value.
      ...(config.value === void 0 || config.isDisabled === true ? {} : {
        name: config.name
      })
    }, h);
  }
  return h.fieldset([...styledAttrs(config, h, catalogStyles.radioGroup), h.AriaLabel(config.ariaLabel), ...(config.isDisabled === true ? [h.Disabled(true)] : [])], config.options.map(option => h.label(sxAttrs(h, catalogStyles.radioItem), [h.input([...sxAttrs(h, catalogStyles.radioControl, catalogStyles.focusable), h.Type("radio"), h.Name(config.name), h.Value(option.value), h.Checked(option.value === config.value), h.OnChange(() => config.onChange(option.value)), ...(option.isDisabled === true ? [h.Disabled(true)] : [])]), h.span([], [option.label, ...(option.description === void 0 ? [] : [h.span(sxAttrs(h, catalogStyles.description), [option.description])])])])));
};
var slider = (config, h) => h.input([...styledAttrs(config, h, catalogStyles.range, catalogStyles.focusable), h.Type("range"), h.Value(String(config.value)), h.AriaLabel(config.ariaLabel), h.Attribute("min", String(config.min ?? 0)), h.Attribute("max", String(config.max ?? 100)), h.Attribute("step", String(config.step ?? 1)), ...(config.isDisabled === true ? [h.Disabled(true)] : []), h.OnInput(value => config.onChange(Number(value)))]);
var toggle2 = (config, h) => h.button([...rootAttrs(config, h, catalogStyles.toggle, catalogStyles.focusable, config.count !== void 0 && catalogStyles.withAdornments, config.isPressed && catalogStyles.togglePressed, config.isDisabled === true && catalogStyles.toggleDisabled), h.Type("button"), h.AriaPressed(String(config.isPressed)), h.OnClick(config.onToggle(!config.isPressed)), ...(config.isDisabled === true ? [h.Disabled(true)] : [])], [config.label, ...(config.count === void 0 ? [] : [countView(config.count, config.countLabel, config.slotProps?.count, h)])]);
var toggleGroup = (config, h) => h.div([...rootAttrs(config, h, catalogStyles.inset, catalogStyles.group), h.Role("group"), h.AriaLabel(config.ariaLabel)], config.options.map((option, index) => {
  const isPressed = config.values.includes(option.value);
  const nextValues = config.multiple === true ? isPressed ? config.values.filter(value => value !== option.value) : [...config.values, option.value] : [option.value];
  return h.button([...slotAttrs(config.slotProps?.item, h, catalogStyles.toggle, catalogStyles.groupConnected, index === 0 && catalogStyles.groupFirst, index === config.options.length - 1 && catalogStyles.groupLast, hasAdornments2(option) && catalogStyles.withAdornments, isPressed && catalogStyles.togglePressed, option.needsAttention === true && catalogStyles.toggleAttention, option.isDisabled === true && catalogStyles.toggleDisabled), h.Type("button"), h.AriaPressed(String(isPressed)), ...(option.needsAttention === true ? [h.DataAttribute("attention", "true")] : []), ...(option.isDisabled === true ? [h.Disabled(true)] : [h.OnClick(config.onChange(nextValues))])], [option.label, ...optionAdornments(option, config.slotProps, h)]);
}));
var buttonGroup = (config, h) => h.div([...styledAttrs(config, h, catalogStyles.group), h.Role("group"), ...(config.ariaLabel === void 0 ? [] : [h.AriaLabel(config.ariaLabel)])], config.children);
var form = (config, h) => h.form([...styledAttrs(config, h), h.OnSubmit(config.onSubmit), ...(config.ariaLabel === void 0 ? [] : [h.AriaLabel(config.ariaLabel)])], config.children);
var ButtonGroup = {
  view: buttonGroup
};
var Form = {
  view: form
};
var Input2 = {
  view: input2
};
var InputGroup = {
  view: inputGroup,
  input: inputGroupInput
};
var InputOtp = {
  view: inputOtp
};
var Label = {
  view: label
};
var NativeSelect = {
  view: nativeSelect
};
var RadioGroup = {
  view: radioGroup
};
var Slider = {
  view: slider
};
var Textarea2 = {
  view: textarea2
};
var Toggle = {
  view: toggle2
};
var ToggleGroup = {
  view: toggleGroup
};

// src/feedback.ts
var progressTones = {
  default: void 0,
  success: catalogStyles.progressSuccess,
  warning: catalogStyles.progressWarning,
  danger: catalogStyles.progressDanger,
  info: catalogStyles.progressInfo
};
var progress = (config, h) => {
  const max = config.max ?? 100;
  const value = config.value === void 0 ? void 0 : clamp(config.value, 0, max);
  const slots = config.slotProps;
  const trackStyles = [catalogStyles.progress, config.size === "sm" && catalogStyles.progressSm];
  const indicator = value === void 0 ? [] : [h.div([...slotAttrs(slots?.indicator, h, catalogStyles.progressIndicator, progressTones[config.tone ?? "default"]), h.Style({
    width: `${value / max * 100}%`
  })])];
  const semantics = [h.Role("progressbar"), h.AriaLabel(config.ariaLabel), h.AriaValuemin(0), h.AriaValuemax(max), ...(value === void 0 ? [] : [h.AriaValuenow(value)]), ...(config.caption === void 0 ? [] : [h.AriaValuetext(config.caption)])];
  if (config.caption === void 0) {
    return h.div([...rootAttrs(config, h, ...trackStyles, slots?.track?.sx), ...(slots?.track?.attributes ?? []), ...semantics], indicator);
  }
  return h.div([...rootAttrs(config, h, catalogStyles.progressMeter), ...semantics], [h.div(slotAttrs(slots?.track, h, ...trackStyles, catalogStyles.progressTrack), indicator), h.span([...slotAttrs(slots?.caption, h, catalogStyles.progressCaption), h.AriaHidden(true)], [config.caption])]);
};
var skeleton = (config, h) => h.div([...rootAttrs(config, h, catalogStyles.skeleton, config.shape === "text" && catalogStyles.skeletonText, config.shape === "circle" && catalogStyles.skeletonCircle, config.isAnimated === false && catalogStyles.loadingStatic), h.AriaHidden(config.label === void 0), ...(config.label === void 0 ? [] : [h.Role("status"), h.AriaLabel(config.label)]), ...(config.width === void 0 && config.height === void 0 ? [] : [h.Style({
  ...(config.width === void 0 ? {} : {
    width: config.width
  }),
  ...(config.height === void 0 ? {} : {
    height: config.height
  })
})])], config.label === void 0 ? [] : [h.span(sxAttrs(h, contentStyles.visuallyHidden), [config.label])]);
var spinnerSizes = {
  xs: catalogStyles.spinnerXs,
  sm: void 0,
  md: catalogStyles.spinnerMd,
  lg: catalogStyles.spinnerLg
};
var spinner = (config, h) => h.span([...rootAttrs(config, h, catalogStyles.spinner, spinnerSizes[config.size ?? "sm"], config.isAnimated === false && catalogStyles.loadingStatic), ...(config.decorative === true ? [h.AriaHidden(true)] : [h.Role("status"), h.AriaLabel(config.label ?? "Loading")])], config.decorative === true ? [] : [h.span(sxAttrs(h, contentStyles.visuallyHidden), [config.label ?? "Loading"])]);
var loader = (config, h) => {
  const label2 = config.label ?? "Loading";
  const layout = config.layout ?? (config.children === void 0 ? "inline" : "block");
  const slots = config.slotProps;
  const attributes = [...rootAttrs(config, h, catalogStyles.loader, layout === "block" && catalogStyles.loaderBlock), h.Role("status"), h.AriaLabel(label2), h.AriaLive("polite"), h.AriaAtomic(true)];
  const children = [config.children === void 0 ? spinner({
    decorative: true,
    size: config.size ?? "sm",
    slotProps: {
      root: slots?.indicator ?? {}
    }
  }, h) : h.div([...slotAttrs(slots?.content, h, catalogStyles.loaderContent), h.AriaHidden(true)], config.children), h.span(slotAttrs(slots?.label, h, catalogStyles.loaderLabel, config.hideLabel === true && contentStyles.visuallyHidden), [label2])];
  return layout === "inline" && config.children === void 0 ? h.span(attributes, children) : h.div(attributes, children);
};
var sonner = (config, h) => h.div([...styledAttrs(config, h), h.AriaLive("polite"), h.AriaRelevant("additions removals")], config.toasts.map(toast => h.div([...sxAttrs(h, catalogStyles.surface, catalogStyles.alert, toast.tone === "danger" && catalogStyles.alertDanger), h.DataAttribute("toast-id", toast.id)], [h.div(sxAttrs(h, catalogStyles.title), [toast.title]), ...(toast.description === void 0 ? [] : [h.p(sxAttrs(h, catalogStyles.description), [toast.description])]), ...(toast.action === void 0 ? [] : [h.button([...sxAttrs(h, catalogStyles.menuItem), h.OnClick(toast.action.onClick)], [toast.action.label])]), ...(config.onDismiss === void 0 ? [] : [h.button([...sxAttrs(h, catalogStyles.menuItem), h.OnClick(config.onDismiss(toast.id)), h.AriaLabel(`Dismiss ${toast.title}`)], ["Dismiss"])])])));
var message = (config, h) => h.div([...styledAttrs(config, h, catalogStyles.inset, catalogStyles.alert), h.Role("status"), h.AriaBusy(config.isBusy === true)], [...(config.title === void 0 ? [] : [h.div(sxAttrs(h, catalogStyles.title), [config.title])]), ...config.children]);
var Progress = {
  view: progress
};
var Skeleton = {
  view: skeleton
};
var Spinner = {
  view: spinner
};
var Loader = {
  view: loader
};
var Sonner = {
  view: sonner
};
var StatusMessage = {
  view: message
};
var decimalPlaces = value => {
  const text2 = String(value).toLocaleLowerCase();
  if (text2.includes("e-")) return Number(text2.split("e-")[1] ?? 0);
  return text2.includes(".") ? text2.split(".")[1]?.length ?? 0 : 0;
};
var normalize2 = (value, config = {}) => {
  const bounded = Math.min(config.max ?? Infinity, Math.max(config.min ?? -Infinity, value));
  const precision = Math.max(decimalPlaces(config.step ?? 1), decimalPlaces(config.min ?? 0));
  return Number(bounded.toFixed(Math.min(12, precision)));
};
var stepValue = (value, direction, config = {}) => {
  const step = Number.isFinite(config.step) && (config.step ?? 0) > 0 ? config.step ?? 1 : 1;
  const origin = value ?? (direction > 0 ? config.min ?? 0 : config.max ?? 0);
  return normalize2(origin + direction * step, config);
};
var valueView2 = (config, h) => {
  const labelId = `${config.id}-label`;
  const descriptionId = `${config.id}-description`;
  return h.div(rootAttrs(config, h, primitiveStyles.numberRoot), [...(config.label === void 0 ? [] : [h.span([h.Id(labelId), ...slotAttrs(config.slotProps?.label, h, catalogStyles.label)], [config.label, ...(config.isRequired === true ? [" *"] : [])])]), view9({
    ...(config.value === void 0 ? {} : {
      value: (config.formatValue ?? String)(config.value),
      formValue: String(config.value)
    }),
    ...(config.label !== void 0 || config.ariaLabel === void 0 ? {} : {
      ariaLabel: config.ariaLabel
    }),
    ...(config.label === void 0 ? {} : {
      ariaLabelledBy: labelId
    }),
    ...(config.description === void 0 ? {} : {
      ariaDescribedBy: descriptionId
    }),
    ...(config.name === void 0 || config.isDisabled === true ? {} : {
      name: config.name
    }),
    ...(config.isInvalid === void 0 ? {} : {
      isInvalid: config.isInvalid
    }),
    ...(config.slotProps?.input === void 0 ? {} : {
      slotProps: {
        root: config.slotProps.input
      }
    }),
    id: config.id
  }, h), ...(config.description === void 0 ? [] : [h.p([h.Id(descriptionId), ...slotAttrs(config.slotProps?.description, h, catalogStyles.description)], [config.description])])]);
};
var view26 = (config, h) => {
  if (config.label === void 0 && config.ariaLabel === void 0) {
    throw new Error("NumberField requires label or ariaLabel.");
  }
  if (config.presentation === "value") return valueView2(config, h);
  const descriptionId = `${config.id}-description`;
  const canDecrease = config.value === void 0 || config.min === void 0 || config.value > config.min;
  const canIncrease = config.value === void 0 || config.max === void 0 || config.value < config.max;
  return h.div(rootAttrs(config, h, primitiveStyles.numberRoot), [...(config.label === void 0 ? [] : [h.label([h.For(config.id), ...slotAttrs(config.slotProps?.label, h, catalogStyles.label)], [config.label, ...(config.isRequired === true ? [" *"] : [])])]), h.div(slotAttrs(config.slotProps?.control, h, primitiveStyles.numberControl), [h.button([...slotAttrs(config.slotProps?.decrement, h, primitiveStyles.numberButton, primitiveStyles.numberButtonStart, catalogStyles.focusable), h.Type("button"), h.AriaLabel(`Decrease ${config.label ?? config.ariaLabel}`), h.Disabled(config.isDisabled === true || config.isReadOnly === true || !canDecrease), h.OnClick(config.onChange(stepValue(config.value, -1, config)))], [view2({
    icon: Minus,
    size: 14
  }, h)]), h.input([...slotAttrs(config.slotProps?.input, h, catalogStyles.control, catalogStyles.focusable, primitiveStyles.numberInput), h.Id(config.id), h.Type("number"), h.InputMode("decimal"), ...(config.value === void 0 ? [] : [h.Value(String(config.value))]), ...(config.label === void 0 ? [h.AriaLabel(config.ariaLabel ?? "Number")] : []), ...(config.description === void 0 ? [] : [h.AriaDescribedBy(descriptionId)]), ...(config.name === void 0 ? [] : [h.Name(config.name)]), ...(config.placeholder === void 0 ? [] : [h.Placeholder(config.placeholder)]), ...(config.min === void 0 ? [] : [h.Min(String(config.min))]), ...(config.max === void 0 ? [] : [h.Max(String(config.max))]), h.Step(String(config.step ?? 1)), h.Disabled(config.isDisabled === true), h.Readonly(config.isReadOnly === true), h.Required(config.isRequired === true), h.AriaInvalid(config.isInvalid === true), h.OnInput(raw => {
    const parsed = raw.trim() === "" ? void 0 : Number(raw);
    return config.onChange(parsed === void 0 || !Number.isFinite(parsed) ? void 0 : normalize2(parsed, config));
  })]), h.button([...slotAttrs(config.slotProps?.increment, h, primitiveStyles.numberButton, primitiveStyles.numberButtonEnd, catalogStyles.focusable), h.Type("button"), h.AriaLabel(`Increase ${config.label ?? config.ariaLabel}`), h.Disabled(config.isDisabled === true || config.isReadOnly === true || !canIncrease), h.OnClick(config.onChange(stepValue(config.value, 1, config)))], [view2({
    icon: Plus,
    size: 14
  }, h)])]), ...(config.description === void 0 ? [] : [h.p([h.Id(descriptionId), ...slotAttrs(config.slotProps?.description, h, catalogStyles.description)], [config.description])])]);
};
var NumberField = {
  view: view26,
  normalize: normalize2,
  stepValue
};
var view27 = (config, h) => {
  const currentIndex = config.steps.findIndex(step => step.id === config.currentStepId);
  if (currentIndex < 0 && config.steps.length > 0) throw new Error("Stepper currentStepId must identify a step.");
  const orientation = config.orientation ?? "horizontal";
  return h.nav([h.AriaLabel(config.ariaLabel ?? "Progress"), ...styledAttrs(config, h)], [h.ol(sxAttrs(h, primitiveStyles.stepper, orientation === "horizontal" ? primitiveStyles.stepperHorizontal : primitiveStyles.stepperVertical), config.steps.map((step, index) => {
    const status = step.status ?? (index < currentIndex ? "complete" : index === currentIndex ? "current" : "upcoming");
    const marker2 = status === "complete" ? view2({
      icon: Check,
      size: 14
    }, h) : status === "error" ? view2({
      icon: TriangleAlert,
      size: 14
    }, h) : String(index + 1);
    const copy = [h.span(sxAttrs(h, primitiveStyles.stepLabel), [step.label]), ...(step.description === void 0 ? [] : [h.span(sxAttrs(h, primitiveStyles.stepDescription), [step.description])])];
    return h.li([...sxAttrs(h, primitiveStyles.step, orientation === "horizontal" && primitiveStyles.stepHorizontal), h.DataAttribute("status", status), ...(status === "current" ? [h.AriaCurrent("step")] : [])], [...(index === config.steps.length - 1 ? [] : [h.span([...sxAttrs(h, orientation === "horizontal" ? primitiveStyles.stepConnectorHorizontal : primitiveStyles.stepConnectorVertical), h.AriaHidden(true)])]), h.span([...sxAttrs(h, primitiveStyles.stepMarker, status === "current" && primitiveStyles.stepCurrent, status === "complete" && primitiveStyles.stepComplete, status === "error" && primitiveStyles.stepError), h.AriaHidden(true)], [marker2]), config.onSelect === void 0 ? h.span(sxAttrs(h, orientation === "horizontal" && primitiveStyles.stepCopyHorizontal), copy) : h.button([...sxAttrs(h, primitiveStyles.stepButton, orientation === "horizontal" && primitiveStyles.stepCopyHorizontal), h.Type("button"), h.Disabled(step.isDisabled === true), h.OnClick(config.onSelect(step.id))], copy)]);
  }))]);
};
var Stepper = {
  view: view27
};
var toneStyles2 = {
  muted: primitiveStyles.tagMuted,
  accent: primitiveStyles.tagAccent,
  success: primitiveStyles.tagSuccess,
  warning: primitiveStyles.tagWarning,
  danger: primitiveStyles.tagDanger,
  info: primitiveStyles.tagInfo
};
var view28 = (config, h) => {
  const label2 = config.onSelect === void 0 ? h.span(slotAttrs(config.slotProps?.label, h), [config.label]) : h.button([...slotAttrs(config.slotProps?.label, h, primitiveStyles.tagButton), h.Type("button"), h.AriaPressed(String(config.isSelected === true)), h.Disabled(config.isDisabled === true), h.OnClick(config.onSelect)], [config.label]);
  return h.span(rootAttrs(config, h, primitiveStyles.tag, config.isSelected === true && primitiveStyles.tagSelected, config.tone === void 0 || config.tone === "neutral" ? null : toneStyles2[config.tone], config.mono === true && primitiveStyles.tagMono), [...(config.media ?? []), label2, ...(config.onRemove === void 0 ? [] : [h.button([...slotAttrs(config.slotProps?.remove, h, primitiveStyles.tagRemove), h.Type("button"), h.Disabled(config.isDisabled === true), h.AriaLabel(config.removeLabel ?? `Remove ${config.label}`), h.OnClick(config.onRemove)], [view2({
    icon: X,
    size: 12
  }, h)])])]);
};
var Tag = {
  view: view28
};
var dialogView = (config, h, kind = "dialog", placement2 = "center") => h.dialog([...styledAttrs(config, h, catalogStyles.dialog), h.Id(config.id), h.Open(config.isOpen), h.Role(kind), h.AriaModal(true), h.AriaLabelledBy(`${config.id}-title`), ...(config.description === void 0 ? [] : [h.AriaDescribedBy(`${config.id}-description`)]), h.OnCancel(config.onOpenChange(false))], [h.div([...sxAttrs(h, catalogStyles.overlay), ...(placement2 === "sheet" ? [h.Style({
  justifyContent: "flex-end",
  padding: "0"
})] : []), ...(placement2 === "drawer" ? [h.Style({
  alignItems: "flex-end",
  padding: "0"
})] : [])], [h.button([...sxAttrs(h, catalogStyles.dialogBackdrop), h.Type("button"), h.AriaLabel(`Close ${config.title}`), h.OnClick(config.onOpenChange(false))]), h.section([...sxAttrs(h, catalogStyles.dialogPanel, placement2 === "sheet" && catalogStyles.sheetPanel, placement2 === "drawer" && catalogStyles.drawerPanel)], [h.header(sxAttrs(h, catalogStyles.dialogHeader), [h.h2([h.Id(`${config.id}-title`), ...sxAttrs(h, catalogStyles.title)], [config.title]), ...(config.description === void 0 ? [] : [h.p([h.Id(`${config.id}-description`), ...sxAttrs(h, catalogStyles.description)], [config.description])])]), ...config.children, ...(config.footer === void 0 ? [] : [h.footer(sxAttrs(h, catalogStyles.dialogFooter), config.footer)])])])]);
var dialog = (config, h) => dialogView(config, h);
var alertDialog = (config, h) => dialogView(config, h, "alertdialog");
var sheet = (config, h) => dialogView(config, h, "dialog", "sheet");
var drawer = (config, h) => dialogView(config, h, "dialog", "drawer");
var popover = (config, h) => h.div(styledAttrs(config, h), [h.button([...sxAttrs(h, catalogStyles.toggle, catalogStyles.focusable), h.Type("button"), h.AriaExpanded(config.isOpen), h.AriaControls(`${config.id}-content`), h.AriaHasPopup("dialog"), h.OnClick(config.onOpenChange(!config.isOpen))], config.trigger), ...(config.isOpen ? [h.div([...sxAttrs(h, catalogStyles.floating), h.Id(`${config.id}-content`), h.Role("dialog"), ...(config.ariaLabel === void 0 ? [] : [h.AriaLabel(config.ariaLabel)])], config.content)] : [])]);
var hoverCard = (config, h) => h.div([...styledAttrs(config, h), h.OnMouseEnter(config.onOpenChange(true)), h.OnMouseLeave(config.onOpenChange(false))], [h.span([h.Tabindex(0), h.AriaDescribedBy(`${config.id}-content`)], config.trigger), ...(config.isOpen ? [h.div([...sxAttrs(h, catalogStyles.floating), h.Id(`${config.id}-content`), h.Role("tooltip")], config.content)] : [])]);
var placementStyles = {
  top: denseStyles.tooltipTop,
  bottom: denseStyles.tooltipBottom,
  start: denseStyles.tooltipStart,
  end: denseStyles.tooltipEnd
};
var statelessTooltip = (config, h) => {
  const description = config.id === void 0 ? [h.AriaDescription(config.label)] : [h.AriaDescribedBy(config.id)];
  return h.span(rootAttrs(config, h, denseStyles.tooltipRoot, tooltipMarker), [config.renderTrigger === void 0 ? h.span([...slotAttrs(config.slotProps?.trigger, h, denseStyles.tooltipTrigger, catalogStyles.focusable), ...(config.isFocusable === false ? [] : [h.Tabindex(0)]), ...description], config.trigger) : config.renderTrigger([...slotAttrs(config.slotProps?.trigger, h, denseStyles.tooltipTrigger, catalogStyles.focusable), ...description], config.trigger, h), h.span([...slotAttrs(config.slotProps?.panel, h, catalogStyles.tooltip, denseStyles.tooltipPanel, placementStyles[config.placement ?? "top"]), ...(config.id === void 0 ? [h.AriaHidden(true)] : [h.Id(config.id), h.Role("tooltip")])], [config.label])]);
};
var tooltip = (config, h) => {
  if (config.mode === "stateless") return statelessTooltip(config, h);
  return h.span([...styledAttrs(config, h), ...(config.onOpenChange === void 0 ? [] : [h.OnMouseEnter(config.onOpenChange(true)), h.OnMouseLeave(config.onOpenChange(false))])], [h.span([h.Tabindex(0), h.AriaDescribedBy(config.id)], config.trigger), ...(config.isOpen === true ? [h.span([...sxAttrs(h, catalogStyles.tooltip), h.Id(config.id), h.Role("tooltip")], [config.label])] : [])]);
};
var AlertDialog = {
  view: alertDialog
};
var Dialog = {
  view: dialog
};
var Drawer = {
  view: drawer
};
var HoverCard = {
  view: hoverCard
};
var Popover = {
  view: popover
};
var Sheet = {
  view: sheet
};
var Tooltip = {
  view: tooltip
};

// src/menus.ts
var menuContent = (groups, h) => h.div([...sxAttrs(h, catalogStyles.floating), h.Role("menu")], groups.flatMap(group2 => [...(group2.label === void 0 ? [] : [h.div([...sxAttrs(h, catalogStyles.menuLabel), h.Role("presentation")], [group2.label])]), h.div([h.Role("group")], group2.items.map(item2 => h.button([...sxAttrs(h, catalogStyles.menuItem, catalogStyles.focusable), h.Type("button"), h.Role("menuitem"), h.Disabled(item2.isDisabled === true), h.OnClick(item2.onSelect), h.DataAttribute("menu-item-id", item2.id), ...(item2.isDestructive === true ? [h.Style({
  color: "var(--destructive)"
})] : [])], [...(item2.media === void 0 ? [] : [item2.media]), item2.label, ...(item2.shortcut === void 0 ? [] : [h.span([h.Style({
  marginLeft: "auto",
  opacity: "0.65"
})], [item2.shortcut])])])))]));
var dropdownMenu = (config, h) => h.div(styledAttrs(config, h), [h.button([...sxAttrs(h, catalogStyles.toggle, catalogStyles.focusable), h.Type("button"), h.AriaHasPopup("menu"), h.AriaExpanded(config.isOpen), h.AriaControls(`${config.id}-menu`), h.OnClick(config.onOpenChange(!config.isOpen))], config.trigger), ...(config.isOpen ? [h.div([h.Id(`${config.id}-menu`), ...(config.ariaLabel === void 0 ? [] : [h.AriaLabel(config.ariaLabel)])], [menuContent(config.groups, h)])] : [])]);
var contextMenu = (config, h) => h.div([...styledAttrs(config, h), h.OnContextMenu(config.onOpen), h.AriaHasPopup("menu")], [...config.children, ...(config.isOpen ? [menuContent(config.groups, h)] : [])]);
var menubar = (config, h) => h.div([...styledAttrs(config, h, catalogStyles.inset, catalogStyles.group), h.Role("menubar"), h.AriaLabel(config.ariaLabel ?? "Application menu")], config.menus.map(menu => h.div([], [h.button([...sxAttrs(h, catalogStyles.menuItem, catalogStyles.focusable), h.Type("button"), h.Role("menuitem"), h.AriaHasPopup("menu"), h.AriaExpanded(menu.isOpen), h.OnClick(menu.onToggle)], [menu.label]), ...(menu.isOpen ? [menuContent(menu.groups, h)] : [])])));
var command = (config, h) => {
  const normalizedQuery = config.query.trim().toLocaleLowerCase();
  const visibleItems = config.items.filter(item2 => normalizedQuery === "" || [item2.label, ...(item2.keywords ?? [])].some(value => value.toLocaleLowerCase().includes(normalizedQuery)));
  const groups = visibleItems.reduce((accumulator, item2) => {
    const group2 = item2.group ?? "Commands";
    const entries = accumulator.get(group2) ?? [];
    accumulator.set(group2, [...entries, item2]);
    return accumulator;
  }, /* @__PURE__ */new Map());
  return h.div([...styledAttrs(config, h, catalogStyles.surface, catalogStyles.command), h.Role("combobox"), h.AriaLabel(config.ariaLabel ?? "Command menu")], [h.input([...sxAttrs(h, catalogStyles.control, catalogStyles.focusable), h.Value(config.query), h.Placeholder(config.placeholder ?? "Type a command or search\u2026"), h.AriaAutocomplete("list"), h.OnInput(config.onQueryChange)]), h.div([...sxAttrs(h, catalogStyles.commandList), h.Role("listbox")], visibleItems.length === 0 ? [h.div(sxAttrs(h, catalogStyles.description), [config.emptyLabel ?? "No results found."])] : [...groups.entries()].flatMap(([group2, items]) => [h.div(sxAttrs(h, catalogStyles.menuLabel), [group2]), h.div([h.Role("group"), h.AriaLabel(group2)], items.map(item2 => h.button([...sxAttrs(h, catalogStyles.menuItem, catalogStyles.focusable), h.Type("button"), h.Role("option"), h.Disabled(item2.isDisabled === true), h.OnClick(item2.onSelect), h.DataAttribute("command-item-id", item2.id)], [...(item2.media === void 0 ? [] : [item2.media]), item2.label])))]))]);
};
var combobox = (config, h) => h.div(styledAttrs(config, h), [h.input([...sxAttrs(h, catalogStyles.control, catalogStyles.focusable), h.Id(config.id), h.Value(config.value), h.Placeholder(config.placeholder ?? "Search\u2026"), h.AriaLabel(config.ariaLabel), h.Attribute("list", `${config.id}-options`), h.Attribute("autocomplete", "off"), h.Disabled(config.isDisabled === true), h.OnInput(config.onChange)]), h.datalist([h.Id(`${config.id}-options`)], config.options.map(option => h.option([h.Value(option.value), h.Attribute("label", option.label)])))]);
var Combobox = {
  view: combobox
};
var Command5 = {
  view: command
};
var ContextMenu = {
  view: contextMenu
};
var DropdownMenu = {
  view: dropdownMenu
};
var Menubar = {
  view: menubar
};

// src/calendar.ts
var key = date => `${date.year}-${String(date.month).padStart(2, "0")}-${String(date.day).padStart(2, "0")}`;
var calendar = (config, h) => {
  const locale = config.locale ?? "en-US";
  const date = new Date(Date.UTC(config.year, config.month - 1, 1));
  const label2 = new Intl.DateTimeFormat(locale, {
    month: "long",
    year: "numeric",
    timeZone: "UTC"
  }).format(date);
  const dayCount = new Date(Date.UTC(config.year, config.month, 0)).getUTCDate();
  const offset = date.getUTCDay();
  const cells = [...Array.from({
    length: offset
  }, () => void 0), ...Array.from({
    length: dayCount
  }, (_, index) => index + 1)];
  return h.div(styledAttrs(config, h, catalogStyles.surface, catalogStyles.calendar), [h.header(sxAttrs(h, catalogStyles.calendarHeader), [h.button([...sxAttrs(h, catalogStyles.pageButton, catalogStyles.focusable), h.Type("button"), h.AriaLabel("Previous month"), ...(config.onPreviousMonth === void 0 ? [h.Disabled(true)] : [h.OnClick(config.onPreviousMonth)])], ["\u2039"]), h.div([...sxAttrs(h, catalogStyles.title), h.AriaLive("polite")], [label2]), h.button([...sxAttrs(h, catalogStyles.pageButton, catalogStyles.focusable), h.Type("button"), h.AriaLabel("Next month"), ...(config.onNextMonth === void 0 ? [h.Disabled(true)] : [h.OnClick(config.onNextMonth)])], ["\u203A"])]), h.div([...sxAttrs(h, catalogStyles.calendarGrid), h.Role("grid"), h.AriaLabel(label2)], [...["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map(day => h.div([...sxAttrs(h, catalogStyles.description), h.Role("columnheader"), h.AriaLabel(day)], [day])), ...cells.map((day, index) => {
    if (day === void 0) return h.div([h.Key(`empty-${index}`), h.Role("gridcell")]);
    const value = {
      year: config.year,
      month: config.month,
      day
    };
    const isSelected = config.selected !== void 0 && key(config.selected) === key(value);
    const isDisabled = config.isDateDisabled?.(value) === true;
    return h.button([...sxAttrs(h, catalogStyles.calendarCell, catalogStyles.focusable, isSelected && catalogStyles.calendarCellSelected), h.Key(key(value)), h.Type("button"), h.Role("gridcell"), h.AriaSelected(isSelected), h.Disabled(isDisabled), h.OnClick(config.onSelect(value))], [String(day)]);
  })])]);
};
var Calendar = {
  view: calendar,
  key
};

// src/containers.ts
var scrollArea = (config, h) => h.div([...styledAttrs(config, h, catalogStyles.scrollArea), ...(config.maxHeight === void 0 ? [] : [h.Style({
  maxHeight: config.maxHeight
})]), ...(config.ariaLabel === void 0 ? [] : [h.Role("region"), h.AriaLabel(config.ariaLabel), h.Tabindex(0)])], config.children);
var resizable = (config, h) => h.div([...styledAttrs(config, h, catalogStyles.surface, catalogStyles.resizable), ...(config.ariaLabel === void 0 ? [] : [h.Role("region"), h.AriaLabel(config.ariaLabel)])], config.children);
var carousel = (config, h) => h.div([...styledAttrs(config, h, catalogStyles.carousel), h.Role("region"), h.AriaRoleDescription("carousel"), h.AriaLabel(config.ariaLabel ?? "Carousel"), h.Tabindex(0)], config.slides.map((slide, index) => h.section([...sxAttrs(h, catalogStyles.surface, catalogStyles.carouselItem), h.Id(`${config.id}-slide-${index + 1}`), h.Role("group"), h.AriaRoleDescription("slide"), h.AriaLabel(`${index + 1} of ${config.slides.length}: ${slide.label}`)], slide.content)));
var Carousel = {
  view: carousel
};
var Resizable = {
  view: resizable
};
var ScrollArea = {
  view: scrollArea
};

// src/ai.ts
var attachment = (config, h) => h.div(styledAttrs(config, h, catalogStyles.inset, catalogStyles.attachment), [...(config.media === void 0 ? [] : [config.media]), h.div(sxAttrs(h, catalogStyles.itemContent), [h.div(sxAttrs(h, catalogStyles.title), [config.name]), ...(config.metadata === void 0 ? [] : [h.div(sxAttrs(h, catalogStyles.description), [config.metadata])])]), ...(config.action === void 0 ? [] : [config.action])]);
var bubble = (config, h) => h.div(styledAttrs(config, h, catalogStyles.bubble, config.isOwn === true && catalogStyles.bubbleOwn), config.children);
var marker = (config, h) => h.mark(styledAttrs(config, h, catalogStyles.marker), config.children);
var message2 = (config, h) => h.article([...styledAttrs(config, h, catalogStyles.message, config.isOwn === true && catalogStyles.messageOwn), h.AriaLabel(`${config.author} message`)], [...(config.avatar === void 0 ? [] : [config.avatar]), bubble({
  children: config.children,
  ...(config.isOwn === void 0 ? {} : {
    isOwn: config.isOwn
  })
}, h)]);
var messageScroller = (config, h) => h.div([...styledAttrs(config, h, catalogStyles.messageScroller), h.Role("log"), h.AriaLive("polite"), h.AriaLabel(config.ariaLabel ?? "Messages"), h.Tabindex(0)], config.children);
var Attachment = {
  view: attachment
};
var Bubble = {
  view: bubble
};
var Marker = {
  view: marker
};
var Message5 = {
  view: message2
};
var MessageScroller = {
  view: messageScroller
};

// src/headless.ts
var headless_exports = {};
__export(headless_exports, {
  Anchor: () => Anchor,
  Animation: () => Animation2,
  Calendar: () => Calendar2,
  Combobox: () => Combobox3,
  DatePicker: () => DatePicker,
  Dialog: () => Dialog2,
  Disclosure: () => Disclosure2,
  HoverIntent: () => HoverIntent,
  Listbox: () => Listbox,
  Measurement: () => measurement_exports,
  Menu: () => Menu,
  Popover: () => Popover2,
  RadioGroup: () => RadioGroup2,
  Select: () => Select2,
  Slider: () => Slider2,
  Tabs: () => Tabs2,
  Toast: () => Toast,
  Tooltip: () => Tooltip2
});

// src/measurement.ts
var measurement_exports = {};
__export(measurement_exports, {
  Box: () => Box,
  Message: () => Message6,
  Model: () => Model5,
  Observe: () => Observe,
  init: () => init5,
  update: () => update5
});
var Box = Schema.Struct({
  width: Schema.Number,
  height: Schema.Number
});
var Model5 = Schema.Record(Schema.String, Box);
var Message6 = defineMessageUnion({
  Measured: {
    boxes: Model5
  }
});
var init5 = () => ({});
var update5 = (_model, message3) => ({
  model: message3.boxes
});
var Observe = Mount.defineStream("ObserveElementBoxes", {
  messages: [Message6.Measured],
  execute: ({
    element
  }) => Stream.callback(queue => Effect.gen(function* () {
    if (typeof ResizeObserver === "undefined") return;
    yield* Effect.acquireRelease(Effect.sync(() => {
      let frame = 0;
      const boxes = {};
      const observed = /* @__PURE__ */new Set();
      const emit = () => {
        frame = 0;
        Queue.offerUnsafe(queue, Message6.Measured({
          boxes: {
            ...boxes
          }
        }));
      };
      const schedule = () => {
        if (!frame) frame = requestAnimationFrame(emit);
      };
      const observer = new ResizeObserver(entries => {
        for (const entry of entries) {
          const key2 = entry.target === element ? "$root" : entry.target.dataset.measure;
          if (!key2) continue;
          const box = entry.borderBoxSize[0];
          boxes[key2] = {
            width: entry.target === element ? entry.contentRect.width : box?.inlineSize ?? entry.contentRect.width,
            height: entry.target === element ? entry.contentRect.height : box?.blockSize ?? entry.contentRect.height
          };
        }
        schedule();
      });
      const reconcile3 = () => {
        const next = /* @__PURE__ */new Set([element, ...Array.from(element.querySelectorAll("[data-measure]"))]);
        for (const node of observed) if (!next.has(node)) {
          observer.unobserve(node);
          observed.delete(node);
          const key2 = node.dataset.measure;
          if (key2) delete boxes[key2];
        }
        for (const node of next) if (!observed.has(node)) {
          observer.observe(node);
          observed.add(node);
        }
        schedule();
      };
      const mutation = new MutationObserver(reconcile3);
      mutation.observe(element, {
        childList: true,
        subtree: true
      });
      reconcile3();
      return () => {
        observer.disconnect();
        mutation.disconnect();
        cancelAnimationFrame(frame);
      };
    }), dispose => Effect.sync(dispose));
    return yield* Effect.never;
  }))
});

// src/stateful.ts
var stateful_exports = {};
__export(stateful_exports, {
  AlertDialog: () => alert_dialog_exports,
  Animation: () => animation_exports,
  Combobox: () => combobox_exports,
  Command: () => command_exports,
  ContextMenu: () => menu_tree_exports,
  DatePicker: () => date_picker_exports,
  Dialog: () => dialog_exports,
  Drawer: () => drawer_exports,
  Layer: () => layer_exports,
  Menu: () => menu_exports,
  Popover: () => popover_exports,
  Select: () => select_exports2,
  Sheet: () => sheet_exports,
  Tabs: () => tabs_exports,
  Toast: () => toast_exports,
  Tooltip: () => tooltip_exports
});

// src/stateful/tabs.ts
var tabs_exports = {};
__export(tabs_exports, {
  styledViewInputs: () => styledViewInputs
});
var statefulStyles = {
  verticalTabs: {
    kGNEyG: "x1qjc9v5",
    kXwgrk: "xdt5ytf",
    $$css: true
  },
  disabled: {
    kkrTdU: "x1h6gzvc",
    kSiTet: "xbyyjgo",
    $$css: true
  },
  dialogLayout: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    kpwlN0: "x10a8y8t",
    kjj79g: "xl56j7k",
    kmVPX3: "xaodzvu",
    kVAEAm: "xixxii4",
    kfzvcC: "x47corl",
    $$css: true
  },
  backdrop: {
    kWkggS: "x1ccwxe3",
    kpwlN0: "x10a8y8t",
    kVAEAm: "xixxii4",
    $$css: true
  },
  panel: {
    kWkggS: "x1rnmz67",
    kMwMTN: "xl26v19",
    kskxy: "xs8sm83",
    kORKVm: "x1odjw0f",
    kfzvcC: "x67bb7w",
    $$css: true
  },
  dialogSm: {
    ks0D6T: "xrlsmeg",
    kzqmXN: "x1oq7s47",
    $$css: true
  },
  dialogMd: {
    ks0D6T: "x1dtb55y",
    kzqmXN: "xk8t1qo",
    $$css: true
  },
  dialogHeading: {
    kGNEyG: "x7a106z",
    k1xSpc: "xrvj5dj",
    kOIVth: "x1ngs94h",
    kumcoG: "xju1xpo",
    $$css: true
  },
  dialogHeaderActions: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    kOIVth: "x1kd3ua",
    kjj79g: "x13a6bvl",
    $$css: true
  },
  dialogDividedContent: {
    k5QoK5: "x9f3blh",
    kDUl1X: "xykt701",
    kLoX6v: "x1kbiq1m",
    k8WAf4: "x1ok2n87",
    $$css: true
  },
  transition: {
    kSiTet: "x1hc1fzr xjmin83",
    k1ekBW: "x19991ni",
    kIyJzY: "x1xy946n x12w9bfk",
    $$css: true
  },
  selectButton: {
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    kOIVth: "x7agqhd",
    kjj79g: "x1qughib",
    kSiTet: "x1hc1fzr xxh3kiz",
    $$css: true
  },
  selectItem: {
    kMwMTN: "x1heor9g",
    kkrTdU: "xt0e3qv",
    $$css: true
  },
  activeItem: {
    kWkggS: "xtvgv0j",
    kMwMTN: "x1vn8azr",
    $$css: true
  },
  layerRoot: {
    k1xSpc: "x1rg5ohu",
    kVAEAm: "x1n2onr6",
    $$css: true
  },
  layerBackdrop: {
    kWkggS: "xjbqb8w",
    kpwlN0: "x10a8y8t",
    kVAEAm: "xixxii4",
    kY2c9j: "x1ygf0dq",
    $$css: true
  },
  layerPanel: {
    kWkggS: "x1rnmz67",
    kVAM5u: "x1ubh2qd",
    kaIpWk: "xbin24w",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kGVxlE: "x4fn6gb",
    kMwMTN: "xl26v19",
    kskxy: "xavv6ry",
    ks0D6T: "x180skxv",
    kORKVm: "x1odjw0f",
    kmVPX3: "x1a2zjlo",
    kY2c9j: "xa9119d",
    $$css: true
  },
  layerArrow: {
    kWkggS: "x1rnmz67",
    kVAM5u: "x1ubh2qd",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kZKoxP: "xdk7pt",
    kVAEAm: "x10l6tqk",
    k3aq6I: "x1158fpu",
    kzqmXN: "x1xc55vz",
    $$css: true
  },
  menuShortcut: {
    kMwMTN: "xyu5t3h",
    keTefX: "xvc5jky",
    $$css: true
  },
  tooltipPanel: {
    ks0D6T: "x1jkqq1h",
    kY2c9j: "x1aciyhk",
    $$css: true
  },
  toastTopLeft: {
    kGNEyG: "x1cy8zhl",
    kXwgrk: "xdt5ytf",
    k87sOh: "x4j1kjz",
    kLqNvP: "xzadtv4",
    $$css: true
  },
  toastTopCenter: {
    kGNEyG: "x6s0dn4",
    kXwgrk: "xdt5ytf",
    k87sOh: "x4j1kjz",
    kLqNvP: "xbudbmw",
    k3aq6I: "xuuh30",
    $$css: true
  },
  toastTopRight: {
    kGNEyG: "xuk3077",
    kXwgrk: "xdt5ytf",
    k87sOh: "x4j1kjz",
    kt4wiu: "x1ftjcbi",
    $$css: true
  },
  toastBottomLeft: {
    kGNEyG: "x1cy8zhl",
    kXwgrk: "x3ieub6",
    krVfgx: "xme5hd9",
    kLqNvP: "xzadtv4",
    $$css: true
  },
  toastBottomCenter: {
    kGNEyG: "x6s0dn4",
    kXwgrk: "x3ieub6",
    krVfgx: "xme5hd9",
    kLqNvP: "xbudbmw",
    k3aq6I: "xuuh30",
    $$css: true
  },
  toastBottomRight: {
    kGNEyG: "xuk3077",
    kXwgrk: "x3ieub6",
    krVfgx: "xme5hd9",
    kt4wiu: "x1ftjcbi",
    $$css: true
  }
};

// src/stateful/tabs.ts
__reExport(tabs_exports, Tabs2);
var styledViewInputs = (config, h) => ({
  tabs: config.tabs.map(tab => tab.value),
  selectedValue: config.selectedValue,
  ariaLabel: config.ariaLabel,
  ...(config.orientation === void 0 ? {} : {
    orientation: config.orientation
  }),
  isTabDisabled: (_value, index) => config.tabs[index]?.isDisabled === true,
  toView: ({
    tablist,
    tabs: tabs2
  }) => h.div(rootAttrs(config, h, catalogStyles.tabs), [h.div([...tablist, ...slotAttrs(config.slotProps?.list, h, catalogStyles.tabsList, config.orientation === "Vertical" && statefulStyles.verticalTabs)], tabs2.map(tab => h.button([...tab.tab, ...slotAttrs(config.slotProps?.trigger, h, catalogStyles.tabsTrigger, catalogStyles.focusable, tab.isActive && catalogStyles.tabsTriggerActive, tab.isDisabled && statefulStyles.disabled)], [config.tabs[tab.index]?.label ?? tab.value]))), ...tabs2.map(tab => h.div([...tab.panel, ...slotAttrs(config.slotProps?.panel, h), h.Hidden(!tab.isActive)], config.tabs[tab.index]?.content ?? []))])
});

// src/stateful/animation.ts
var animation_exports = {};
__export(animation_exports, {
  Message: () => Message$1,
  Model: () => Model$1,
  OutMessage: () => OutMessage$1,
  TransitionState: () => TransitionState,
  WaitForAnimationSettled: () => WaitForAnimationSettled,
  WaitForPaint: () => WaitForPaint,
  defaultLeaveCommand: () => defaultLeaveCommand,
  init: () => init$1,
  update: () => update7,
  view: () => view29
});
var animationStyles = {
  fade: {
    kSiTet: "x1hc1fzr xjmin83",
    k1ekBW: "x19991ni",
    kIyJzY: "x6xk6gu x12w9bfk",
    kAMwcw: "xe36upo",
    $$css: true
  },
  slideUp: {
    k3aq6I: "xnn1q72 x1sbms7j",
    k1ekBW: "x6o7n8i",
    kIyJzY: "x6xk6gu x12w9bfk",
    kAMwcw: "xe36upo",
    $$css: true
  },
  slideLeft: {
    k3aq6I: "xbryuvx x1fkvzfd",
    k1ekBW: "x6o7n8i",
    kIyJzY: "x6xk6gu x12w9bfk",
    kAMwcw: "xe36upo",
    $$css: true
  },
  slideRight: {
    k3aq6I: "xbryuvx xd2pdt2",
    k1ekBW: "x6o7n8i",
    kIyJzY: "x6xk6gu x12w9bfk",
    kAMwcw: "xe36upo",
    $$css: true
  }
};
var update7 = (model, message3) => {
  const result = Animation2.update(model, message3);
  if (result.outMessage?._tag !== "StartedLeaveAnimating") return result;
  return {
    ...result,
    outMessage: void 0,
    commands: [...(result.commands ?? []), Animation2.defaultLeaveCommand(result.model)]
  };
};
var effectClasses = {
  fade: {
    className: "x1hc1fzr xjmin83 x19991ni x6xk6gu x12w9bfk xe36upo"
  }.className ?? "",
  collapse: {
    className: "xrvj5dj x1tu4anv x2m5oso x1hc1fzr xjmin83 xb3r6kr x1erjwpq x6xk6gu x12w9bfk xe36upo"
  }.className ?? "",
  slideUp: {
    className: "x1hc1fzr xjmin83 xnn1q72 x1sbms7j x6o7n8i x6xk6gu x12w9bfk xe36upo"
  }.className ?? "",
  slideDown: {
    className: "x1hc1fzr xjmin83 xnn1q72 xp59wdf x6o7n8i x6xk6gu x12w9bfk xe36upo"
  }.className ?? "",
  slideLeft: {
    className: "x1hc1fzr xjmin83 xbryuvx x1fkvzfd x6o7n8i x6xk6gu x12w9bfk xe36upo"
  }.className ?? "",
  slideRight: {
    className: "x1hc1fzr xjmin83 xbryuvx xd2pdt2 x6o7n8i x6xk6gu x12w9bfk xe36upo"
  }.className ?? ""
};
var view29 = defineView((model, inputs, h) => {
  const effect = inputs.effect ?? "fade";
  const phase = model.transitionState;
  const leaving = phase === "LeaveStart" || phase === "LeaveAnimating";
  const visible = model.isShowing || leaving;
  if (!visible && effect !== "collapse") return h.empty;
  const closed = !visible || phase === "EnterStart" || phase === "LeaveAnimating";
  const transitioning = phase !== "Idle";
  const className = [effectClasses[effect], inputs.className].filter(Boolean).join(" ");
  return h.keyed("div")(model.id, [h.Id(model.id), ...(className ? [h.Class(className)] : []), ...(closed ? [h.DataAttribute("closed", "")] : []), ...(phase === "EnterStart" || phase === "EnterAnimating" ? [h.DataAttribute("enter", "")] : []), ...(leaving ? [h.DataAttribute("leave", "")] : []), ...(transitioning ? [h.DataAttribute("transition", "")] : []), ...(effect === "collapse" && !model.isShowing ? [h.Inert(true), h.AriaHidden(true)] : [])], effect === "collapse" ? [h.div([h.Style({
    minHeight: "0px",
    overflow: "hidden"
  })], [inputs.content])] : [inputs.content]);
});

// src/stateful/dialog.ts
var dialog_exports = {};
__export(dialog_exports, {
  styledViewInputs: () => styledViewInputs2
});
__reExport(dialog_exports, Dialog2);
var titleContent = title => typeof title === "string" ? [title] : title;
var panelMotion = placement2 => placement2 === "left" ? animationStyles.slideRight : placement2 === "right" ? animationStyles.slideLeft : animationStyles.slideUp;
var styledViewInputs2 = (config, h) => ({
  toView: ({
    dialog: dialog2,
    backdrop,
    panel,
    title,
    description,
    closeButton,
    initialFocus,
    isVisible
  }) => h.dialog([...rootAttrs(config, h), ...dialog2, h.AriaModal(true), h.Role(config.role ?? "dialog")], isVisible ? [h.div([...backdrop, ...slotAttrs(config.slotProps?.backdrop, h, statefulStyles.backdrop, animationStyles.fade)]), h.div([...slotAttrs(config.slotProps?.layout, h, statefulStyles.dialogLayout), h.Style({
    justifyContent: config.placement === "left" ? "flex-start" : config.placement === "right" ? "flex-end" : "center",
    alignItems: config.placement === "bottom" ? "flex-end" : "center"
  })], [h.section([...panel, h.DataAttribute("size", config.size ?? "default"), ...(config.placement && config.placement !== "center" ? [h.Style({
    width: config.placement === "bottom" ? "100%" : "min(420px, 100%)",
    height: config.placement === "bottom" ? "auto" : "calc(100dvh - 32px)",
    maxWidth: config.placement === "bottom" ? "100%" : "420px"
  })] : []), ...slotAttrs(config.slotProps?.panel, h, catalogStyles.dialogPanel, statefulStyles.panel, animationStyles.fade, panelMotion(config.placement), config.size === "sm" && statefulStyles.dialogSm, config.size === "md" && statefulStyles.dialogMd)], [h.header(slotAttrs(config.slotProps?.header, h, catalogStyles.dialogHeader), [h.div(slotAttrs(void 0, h, statefulStyles.dialogHeading), [h.h2([...title, ...slotAttrs(config.slotProps?.title, h, catalogStyles.title)], titleContent(config.title)), ...(config.headerActions === void 0 ? [] : [h.div(slotAttrs(config.slotProps?.headerActions, h, statefulStyles.dialogHeaderActions), config.headerActions({
    closeButton,
    initialFocus
  }, h))])]), h.p([...description, ...slotAttrs(config.slotProps?.description, h, catalogStyles.description), h.Hidden(config.description === void 0)], config.description === void 0 ? [] : [config.description])]), h.div([...slotAttrs(config.slotProps?.content, h, config.dividers === true && statefulStyles.dialogDividedContent), h.DataAttribute("dividers", config.dividers === true ? "true" : "false")], config.content({
    closeButton,
    initialFocus
  }, h)), ...(config.footer === void 0 ? [] : [h.footer(slotAttrs(config.slotProps?.footer, h, catalogStyles.dialogFooter), config.footer({
    closeButton,
    initialFocus
  }, h))])])])] : [])
});

// src/stateful/select.ts
var select_exports2 = {};
__export(select_exports2, {
  create: () => create18,
  styledViewInputs: () => styledViewInputs3
});
__reExport(select_exports2, Listbox);
var create18 = () => Listbox.create();
var styledViewInputs3 = (config, h) => {
  const selected = config.options.find(option => option.value === config.value);
  return {
    items: config.options,
    maybeSelectedValue: config.value === void 0 ? Option.none() : Option.some(config.value),
    itemToValue: item2 => item2.value,
    itemToSearchText: item2 => item2.label,
    isItemDisabled: item2 => item2.isDisabled === true,
    ariaLabel: config.ariaLabel,
    ...(config.isDisabled === void 0 ? {} : {
      isDisabled: config.isDisabled
    }),
    ...(config.isReadOnly === void 0 ? {} : {
      isReadOnly: config.isReadOnly
    }),
    ...(config.isInvalid === void 0 ? {} : {
      isInvalid: config.isInvalid
    }),
    ...(config.name === void 0 ? {} : {
      name: config.name
    }),
    ...(config.form === void 0 ? {} : {
      form: config.form
    }),
    anchor: config.anchor ?? {
      placement: "bottom-start",
      gap: 4,
      padding: 8
    },
    buttonContent: h.span(sxAttrs(h, statefulStyles.selectButton), [selected?.label ?? config.placeholder ?? "Select an option", view2({
      icon: ChevronDown,
      size: 14
    }, h)]),
    buttonClassName: {
      0: {
        className: "x1f6rtwf x15nqw3 x1rwf2kx xbin24w x1y0btm7 xmkeg23 x1heor9g xajfy2p xif65rj x21xpn4 x1a2a7pz x6454uj x1wfwxd8 x1lqa7cf xcicffo xh8yej3 x1gnnqk1 x1xy946n x12zzom9 xe36upo x6s0dn4 x78zum5 x7agqhd x1qughib x1hc1fzr xxh3kiz"
      },
      1: {
        className: "x1f6rtwf xbin24w x1y0btm7 xmkeg23 x1heor9g xajfy2p xif65rj x21xpn4 x1a2a7pz x6454uj x1wfwxd8 x1lqa7cf xcicffo xh8yej3 x1xy946n x12zzom9 xe36upo x6s0dn4 x78zum5 x7agqhd x1qughib x1hc1fzr xxh3kiz xuj4g81 x1c8vacq"
      }
    }[!!(config.isInvalid === true) << 0].className ?? "",
    itemsClassName: {
      className: "x1ubh2qd x3wpolg x1y0btm7 xmkeg23 x13y627i x1n2onr6 xrvj5dj x195vfkc xe8uvvx x1ghz6dp xfawy5m x1rnmz67 xl26v19 x12dd5wy x1odjw0f x5glrxg xa9119d x1hc1fzr xjmin83 x19991ni x1xy946n x12w9bfk"
    }.className ?? "",
    backdropClassName: {
      className: "x10a8y8t xixxii4"
    }.className ?? "",
    className: {
      className: "x1rg5ohu x1n2onr6"
    }.className ?? "",
    itemToConfig: (item2, context) => ({
      // The engine accepts a class for each option. These recipes are static, with no inline values.
      className: {
        0: {
          className: "x6s0dn4 xjbqb8w x7pwlv5 x5i151u x78zum5 x14t0e4u x4z9k3i x7agqhd x1rz828m x8lhhth xdpxx8g xh8yej3 x1heor9g xt0e3qv"
        },
        4: {
          className: "x6s0dn4 x5i151u x78zum5 x14t0e4u x4z9k3i x7agqhd x1rz828m x8lhhth xdpxx8g xh8yej3 xt0e3qv xtvgv0j x1vn8azr"
        },
        2: {
          className: "x6s0dn4 xjbqb8w x7pwlv5 x5i151u x78zum5 x14t0e4u x4z9k3i x7agqhd x1rz828m x8lhhth xdpxx8g xh8yej3 x1heor9g xt0e3qv x1s688f"
        },
        6: {
          className: "x6s0dn4 x5i151u x78zum5 x14t0e4u x4z9k3i x7agqhd x1rz828m x8lhhth xdpxx8g xh8yej3 xt0e3qv xtvgv0j x1vn8azr x1s688f"
        },
        1: {
          className: "x6s0dn4 xjbqb8w x7pwlv5 x5i151u x78zum5 x14t0e4u x4z9k3i x7agqhd x1rz828m x8lhhth xdpxx8g xh8yej3 x1heor9g x1h6gzvc xbyyjgo"
        },
        5: {
          className: "x6s0dn4 x5i151u x78zum5 x14t0e4u x4z9k3i x7agqhd x1rz828m x8lhhth xdpxx8g xh8yej3 xtvgv0j x1vn8azr x1h6gzvc xbyyjgo"
        },
        3: {
          className: "x6s0dn4 xjbqb8w x7pwlv5 x5i151u x78zum5 x14t0e4u x4z9k3i x7agqhd x1rz828m x8lhhth xdpxx8g xh8yej3 x1heor9g x1s688f x1h6gzvc xbyyjgo"
        },
        7: {
          className: "x6s0dn4 x5i151u x78zum5 x14t0e4u x4z9k3i x7agqhd x1rz828m x8lhhth xdpxx8g xh8yej3 xtvgv0j x1vn8azr x1s688f x1h6gzvc xbyyjgo"
        }
      }[!!context.isActive << 2 | !!context.isSelected << 1 | !!context.isDisabled << 0].className ?? "",
      content: h.span(sxAttrs(h, statefulStyles.selectButton), [item2.label, ...(context.isSelected ? [view2({
        icon: Check,
        size: 14
      }, h)] : [])])
    })
  };
};

// src/stateful/command.ts
var command_exports = {};
__export(command_exports, {
  Message: () => Message8,
  Model: () => Model7,
  OutMessage: () => OutMessage5,
  ScrollActive: () => ScrollActive,
  activeItem: () => activeItem,
  fromCommand: () => fromCommand,
  getResults: () => getResults,
  init: () => init7,
  score: () => score,
  update: () => update8,
  view: () => view30
});
var Model7 = Schema.Struct({
  id: Schema.String,
  query: Schema.String,
  activeValue: Schema.Option(Schema.String)
});
var Message8 = defineMessageUnion({
  ChangedSearch: {
    query: Schema.String
  },
  Activated: {
    value: Schema.String,
    isKeyboard: Schema.Boolean
  },
  Selected: {
    value: Schema.String
  },
  IgnoredSelection: {},
  CompletedScroll: {}
});
var OutMessage5 = defineMessageUnion({
  SearchChanged: {
    query: Schema.String
  },
  Selected: {
    value: Schema.String
  }
});
var init7 = config => ({
  id: config.id,
  query: config.query ?? "",
  activeValue: Option.none()
});
var ScrollActive = Command.define("ScrollCommandResult", {
  args: {
    id: Schema.String,
    value: Schema.String
  },
  messages: [Message8.CompletedScroll],
  execute: ({
    id,
    value
  }) => Dom5.scrollIntoView(`[id="${itemId(id, value)}"]`, {
    block: "nearest"
  }).pipe(Effect.ignore, Effect.as(Message8.CompletedScroll()))
});
var update8 = (model, message3) => Message8.match(message3, {
  ChangedSearch: ({
    query
  }) => ({
    model: {
      ...model,
      query,
      activeValue: Option.none()
    },
    outMessage: OutMessage5.SearchChanged({
      query
    })
  }),
  Activated: ({
    value,
    isKeyboard
  }) => ({
    model: {
      ...model,
      activeValue: Option.some(value)
    },
    commands: isKeyboard ? [ScrollActive({
      id: model.id,
      value
    })] : []
  }),
  Selected: ({
    value
  }) => ({
    model,
    outMessage: OutMessage5.Selected({
      value
    })
  }),
  IgnoredSelection: () => ({
    model
  }),
  CompletedScroll: () => ({
    model
  })
});
var score = (text2, query) => {
  const value = text2.toLocaleLowerCase();
  const search = query.trim().toLocaleLowerCase();
  if (search === "") return 1;
  if (value === search) return 4;
  if (value.startsWith(search)) return 3;
  if (value.split(/\s+/).some(word => word.startsWith(search))) return 2;
  const contiguous = value.indexOf(search);
  if (contiguous >= 0) return 1 + 1 / (contiguous + 2);
  let cursor = 0;
  let gaps = 0;
  for (const character of search) {
    const index = value.indexOf(character, cursor);
    if (index < 0) return 0;
    gaps += index - cursor;
    cursor = index + 1;
  }
  return 1 / (gaps + 2);
};
var getResults = (query, config) => {
  const groups = /* @__PURE__ */new Map();
  for (const item2 of config.items) {
    const rank = config.shouldFilter === false || query.trim() === "" ? 1 : config.filter?.(query, item2) ?? Math.max(score(item2.label, query), ...(item2.keywords ?? []).map(keyword => score(keyword, query)));
    if (!Number.isFinite(rank) || rank <= 0) continue;
    const group2 = item2.group ?? "Commands";
    const entries = groups.get(group2) ?? [];
    entries.push({
      item: item2,
      score: rank
    });
    groups.set(group2, entries);
  }
  return [...groups.values()].map(entries => entries.sort((a, b) => b.score - a.score)).sort((a, b) => (b[0]?.score ?? 0) - (a[0]?.score ?? 0)).flatMap(entries => entries.map(({
    item: item2
  }) => item2));
};
var activeItem = (model, items) => items.find(item2 => !item2.isDisabled && Option.contains(model.activeValue, item2.value)) ?? items.find(item2 => !item2.isDisabled);
var itemId = (id, value) => `${encodeURIComponent(id)}-item-${encodeURIComponent(value)}`;
var view30 = defineView((model, inputs, h) => {
  const items = getResults(model.query, inputs);
  const active = activeItem(model, items);
  const enabled = items.filter(item2 => !item2.isDisabled);
  const activeIndex2 = enabled.findIndex(item2 => item2.value === active?.value);
  const groups = /* @__PURE__ */new Map();
  for (const item2 of items) {
    const key2 = item2.group ?? "Commands";
    groups.set(key2, [...(groups.get(key2) ?? []), item2]);
  }
  const onKeyDown = key2 => {
    if (key2 === "Enter") return Option.some(active === void 0 ? Message8.IgnoredSelection() : Message8.Selected({
      value: active.value
    }));
    if (!["ArrowDown", "ArrowUp", "Home", "End"].includes(key2) || enabled.length === 0) return Option.none();
    const next = key2 === "Home" ? 0 : key2 === "End" ? enabled.length - 1 : activeIndex2 + (key2 === "ArrowDown" ? 1 : -1);
    const index = inputs.loop === true ? (next + enabled.length) % enabled.length : Math.max(0, Math.min(enabled.length - 1, next));
    const item2 = enabled[index];
    return item2 === void 0 ? Option.none() : Option.some(Message8.Activated({
      value: item2.value,
      isKeyboard: true
    }));
  };
  return h.div(sxAttrs(h, catalogStyles.surface, catalogStyles.command), [h.input([...sxAttrs(h, catalogStyles.control, catalogStyles.focusable), h.Role("combobox"), h.AriaLabel(inputs.ariaLabel), h.AriaExpanded(true), h.AriaAutocomplete("list"), h.AriaControls(`${model.id}-results`), ...(active === void 0 ? [] : [h.AriaActiveDescendant(itemId(model.id, active.value))]), h.Value(model.query), h.Placeholder(inputs.placeholder ?? "Type a command or search\u2026"), h.OnInput(query => Message8.ChangedSearch({
    query
  })), h.OnKeyDownPreventDefault(onKeyDown)]), h.div([h.Id(`${model.id}-results`), h.Role("listbox"), h.AriaLabel(inputs.ariaLabel), ...sxAttrs(h, catalogStyles.commandList)], [...groups].map(([group2, entries], index) => h.div([h.Role("group"), h.AriaLabelledBy(`${model.id}-group-${index}`)], [h.div([h.Id(`${model.id}-group-${index}`), ...sxAttrs(h, catalogStyles.menuLabel)], [group2]), ...entries.map(item2 => h.div([h.Id(itemId(model.id, item2.value)), h.Role("option"), h.AriaSelected(item2.value === active?.value), h.AriaDisabled(item2.isDisabled === true), ...(item2.command ? [h.AriaKeyshortcuts(Keyboard5.aria(item2.command.shortcut, inputs.platform ?? "other"))] : []), ...sxAttrs(h, catalogStyles.menuItem, statefulStyles.selectItem, item2.value === active?.value && statefulStyles.activeItem, item2.isDisabled === true && statefulStyles.disabled), ...(item2.isDisabled === true ? [] : [h.OnMouseEnter(Message8.Activated({
    value: item2.value,
    isKeyboard: false
  })), h.OnClick(Message8.Selected({
    value: item2.value
  }))])], [...(item2.media ?? []), item2.label, ...(item2.command ? [h.kbd(sxAttrs(h, statefulStyles.menuShortcut), [Keyboard5.display(item2.command.shortcut, inputs.platform ?? "other")])] : [])]))]))), ...(items.length === 0 ? [h.p([h.Role("status"), ...sxAttrs(h, catalogStyles.description)], [inputs.emptyLabel ?? "No results found."])] : [])]);
});
var fromCommand = command2 => ({
  value: command2.id,
  label: command2.label,
  command: command2,
  ...(command2.isDisabled === void 0 ? {} : {
    isDisabled: command2.isDisabled
  })
});

// src/stateful/layer.ts
var layer_exports = {};
__export(layer_exports, {
  anchor: () => anchor,
  classNames: () => classNames,
  placement: () => placement
});
var anchor = (config = {}) => ({
  placement: config.placement ?? "bottom-start",
  gap: config.gap ?? 6,
  padding: config.padding ?? 8,
  portal: config.portal ?? true,
  ...(config.offset === void 0 ? {} : {
    offset: config.offset
  }),
  ...(config.isPlacementLocked === void 0 ? {} : {
    isPlacementLocked: config.isPlacementLocked
  })
});
var classNames = {
  root: {
    className: "x1rg5ohu x1n2onr6"
  }.className ?? "",
  panel: {
    className: "x1rnmz67 x1ubh2qd xbin24w x1y0btm7 xmkeg23 x4fn6gb xl26v19 xavv6ry x180skxv x1odjw0f x1a2zjlo xa9119d x1hc1fzr xjmin83 x19991ni x1xy946n x12w9bfk"
  }.className ?? "",
  backdrop: {
    className: "xjbqb8w x10a8y8t xixxii4 x1ygf0dq"
  }.className ?? "",
  arrow: {
    className: "x1rnmz67 x1ubh2qd x1y0btm7 xmkeg23 xdk7pt x10l6tqk x1158fpu x1xc55vz"
  }.className ?? "",
  trigger: {
    className: "x6s0dn4 xjbqb8w x7pwlv5 x9r1u3d x3wpolg x1y0btm7 xmkeg23 xyu5t3h x1ypdohk x3nfvp2 x14t0e4u x4z9k3i x1b3j4lt x10w6t97 xl56j7k x1p3i4rr x1a2a7pz x6454uj x1wfwxd8"
  }.className ?? ""
};
var placement = value => anchor({
  placement: value
});

// src/stateful/menu.ts
var menu_exports = {};
__export(menu_exports, {
  Nested: () => menu_tree_exports,
  create: () => create20,
  fromCommand: () => fromCommand2,
  styledViewInputs: () => styledViewInputs4
});
__reExport(menu_exports, Menu);

// src/stateful/menu-tree.ts
var menu_tree_exports = {};
__export(menu_tree_exports, {
  Message: () => Message9,
  Model: () => Model8,
  OutMessage: () => OutMessage6,
  init: () => init8,
  itemsAt: () => itemsAt,
  reconcile: () => reconcile2,
  update: () => update9,
  view: () => view31
});
var Model8 = Schema.Struct({
  id: Schema.String,
  isOpen: Schema.Boolean,
  x: Schema.NullOr(Schema.Number),
  y: Schema.NullOr(Schema.Number),
  path: Schema.Array(Schema.String)
});
var Message9 = defineMessageUnion({
  Opened: {
    x: Schema.NullOr(Schema.Number),
    y: Schema.NullOr(Schema.Number)
  },
  Closed: {
    restore: Schema.Boolean
  },
  Key: {
    key: Schema.String
  },
  Hovered: {
    path: Schema.Array(Schema.String)
  },
  Selected: {
    path: Schema.Array(Schema.String)
  },
  Focused: {}
});
var OutMessage6 = defineMessageUnion({
  Selected: {
    id: Schema.String,
    isChecked: Schema.Boolean
  }
});
var init8 = id => ({
  id,
  isOpen: false,
  x: null,
  y: null,
  path: []
});
var itemsAt = (items, ancestors) => ancestors.reduce((list, id) => list.find(item2 => item2.id === id)?.children ?? [], items);
var disabled = item2 => item2.isDisabled === true || item2.command?.isDisabled === true;
var reconcile2 = (model, items) => {
  const validate2 = entries => {
    if (entries.some(item2 => !item2.id) || new Set(entries.map(item2 => item2.id)).size !== entries.length) throw new Error("Menu sibling IDs must be nonempty and unique.");
    for (const item2 of entries) if (item2.children) validate2(item2.children);
  };
  validate2(items);
  if (!model.isOpen) return model;
  const path = [];
  let siblings = items;
  for (const id of model.path.length ? model.path : [""]) {
    const active = siblings.find(item2 => item2.id === id && !disabled(item2)) ?? siblings.find(item2 => !disabled(item2));
    if (!active) break;
    path.push(active.id);
    if (active.id !== id || !active.children) break;
    siblings = active.children;
  }
  return {
    ...model,
    path
  };
};
var Focus4 = Command.define("FocusCascadingMenu", {
  args: {
    id: Schema.String
  },
  messages: [Message9.Focused],
  execute: ({
    id
  }) => Dom.focus(`#${CSS.escape(id)}`).pipe(Effect.ignore, Effect.as(Message9.Focused()))
});
var update9 = (previous, message3, items) => {
  const model = reconcile2(previous, items);
  const close = restore => ({
    model: {
      ...model,
      isOpen: false,
      path: []
    },
    commands: restore ? [Focus4({
      id: `${model.id}-trigger`
    })] : []
  });
  switch (message3._tag) {
    case "Focused":
      return {
        model
      };
    case "Opened":
      return {
        model: {
          ...model,
          isOpen: true,
          x: message3.x,
          y: message3.y,
          path: items.find(item2 => !disabled(item2)) ? [items.find(item2 => !disabled(item2)).id] : []
        }
      };
    case "Closed":
      return close(message3.restore);
    case "Hovered":
      {
        const item2 = itemsAt(items, message3.path.slice(0, -1)).find(item3 => item3.id === message3.path.at(-1));
        return {
          model: model.isOpen && item2 && !disabled(item2) ? {
            ...model,
            path: item2.children ? [...message3.path, ...item2.children.filter(child => !disabled(child)).slice(0, 1).map(child => child.id)] : message3.path
          } : model
        };
      }
    case "Selected":
      {
        if (!model.isOpen) return {
          model
        };
        const item2 = itemsAt(items, message3.path.slice(0, -1)).find(item3 => item3.id === message3.path.at(-1));
        if (!item2 || disabled(item2)) return {
          model
        };
        if (item2.children) return {
          model: {
            ...model,
            path: [...message3.path, ...item2.children.filter(child => !disabled(child)).slice(0, 1).map(child => child.id)]
          }
        };
        return {
          ...(item2.kind ? {
            model
          } : close(true)),
          outMessage: OutMessage6.Selected({
            id: item2.command?.id ?? item2.id,
            isChecked: item2.kind === "radio" || !item2.isChecked
          })
        };
      }
    case "Key":
      {
        if (!model.isOpen) return {
          model
        };
        if (message3.key === "Escape") return model.path.length > 1 ? {
          model: {
            ...model,
            path: model.path.slice(0, -1)
          }
        } : close(true);
        if (message3.key === "Tab") return close(false);
        const ancestors = model.path.slice(0, -1);
        const siblings = itemsAt(items, ancestors).filter(item2 => !disabled(item2));
        const index = siblings.findIndex(item2 => item2.id === model.path.at(-1));
        if (message3.key === "ArrowLeft") return {
          model: {
            ...model,
            path: model.path.length > 1 ? ancestors : model.path
          }
        };
        if (["ArrowRight", "Enter", " "].includes(message3.key)) {
          const item2 = siblings[index];
          return item2 && (message3.key !== "ArrowRight" || item2.children) ? update9(model, Message9.Selected({
            path: model.path
          }), items) : {
            model
          };
        }
        const next = message3.key === "Home" ? siblings[0] : message3.key === "End" ? siblings.at(-1) : message3.key === "ArrowDown" ? siblings[(index + 1) % siblings.length] : message3.key === "ArrowUp" ? siblings[(index - 1 + siblings.length) % siblings.length] : message3.key.length === 1 ? [...siblings.slice(index + 1), ...siblings.slice(0, index + 1)].find(item2 => item2.label.toLocaleLowerCase().startsWith(message3.key.toLocaleLowerCase())) : void 0;
        return {
          model: next ? {
            ...model,
            path: [...ancestors, next.id]
          } : model
        };
      }
  }
};
var Context = Mount.defineStream("ContextMenuTrigger", {
  messages: [Message9.Opened],
  execute: ({
    element
  }) => Stream.callback(queue => Effect.gen(function* () {
    yield* Effect.acquireRelease(Effect.sync(() => {
      const open = event => {
        if (event instanceof KeyboardEvent && event.key !== "ContextMenu" && !(event.shiftKey && event.key === "F10")) return;
        event.preventDefault();
        event.stopPropagation();
        Queue.offerUnsafe(queue, Message9.Opened({
          x: event instanceof MouseEvent ? event.clientX : null,
          y: event instanceof MouseEvent ? event.clientY : null
        }));
      };
      element.addEventListener("contextmenu", open);
      element.addEventListener("keydown", open);
      return () => {
        element.removeEventListener("contextmenu", open);
        element.removeEventListener("keydown", open);
      };
    }), dispose => Effect.sync(dispose));
    return yield* Effect.never;
  }))
});
var stacks = /* @__PURE__ */new WeakMap();
var Layer = Mount.defineStream("CascadingMenuLayer", {
  args: {
    trigger: Schema.String,
    x: Schema.NullOr(Schema.Number),
    y: Schema.NullOr(Schema.Number)
  },
  messages: [Message9.Closed, Message9.Key, Message9.Hovered],
  execute: ({
    element,
    trigger,
    x,
    y
  }) => Stream.callback(queue => Effect.gen(function* () {
    yield* Effect.acquireRelease(Effect.sync(() => {
      const panel = element;
      const doc = panel.ownerDocument;
      const stack2 = stacks.get(doc) ?? [];
      stacks.set(doc, stack2);
      stack2.push(panel);
      let timer;
      const emit = message3 => Queue.offerUnsafe(queue, message3);
      panel.showPopover();
      const anchor2 = doc.getElementById(trigger)?.getBoundingClientRect();
      const box = panel.getBoundingClientRect();
      const position = (width, height) => {
        panel.style.left = `${Math.max(8, Math.min(x ?? anchor2?.left ?? 8, innerWidth - width - 8))}px`;
        panel.style.top = `${Math.max(8, Math.min(y ?? anchor2?.bottom ?? 8, innerHeight - height - 8))}px`;
      };
      position(box.width, box.height);
      let frame = 0;
      const observer = new ResizeObserver(entries => {
        const entry = entries[0];
        if (!entry) return;
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => position(entry.contentRect.width, entry.contentRect.height));
      });
      observer.observe(panel);
      const activeObserver = new MutationObserver(() => {
        const active = doc.getElementById(panel.getAttribute("aria-activedescendant") ?? "");
        active?.scrollIntoView({
          block: "nearest",
          inline: "nearest"
        });
      });
      activeObserver.observe(panel, {
        attributes: true,
        attributeFilter: ["aria-activedescendant"]
      });
      panel.focus();
      const top = () => stack2.at(-1) === panel;
      const down = event => {
        if (top() && !event.composedPath().includes(panel) && !(event.target instanceof Element && doc.getElementById(trigger)?.contains(event.target))) emit(Message9.Closed({
          restore: false
        }));
      };
      const key2 = event => {
        if (!top() || event.isComposing || event.defaultPrevented) return;
        if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Home", "End", "Enter", " ", "Escape", "Tab"].includes(event.key) || event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
          if (event.key !== "Tab") event.preventDefault();
          event.stopPropagation();
          emit(Message9.Key({
            key: event.key
          }));
        }
      };
      const over = event => {
        const item2 = event.target.closest("[data-menu-path]");
        clearTimeout(timer);
        if (item2 && !item2.contains(event.relatedTarget)) timer = setTimeout(() => emit(Message9.Hovered({
          path: JSON.parse(item2.dataset.menuPath)
        })), 160);
      };
      const leave = () => clearTimeout(timer);
      const resize = () => emit(Message9.Closed({
        restore: true
      }));
      doc.addEventListener("pointerdown", down, true);
      panel.addEventListener("keydown", key2);
      panel.addEventListener("pointerover", over);
      panel.addEventListener("pointerleave", leave);
      window.addEventListener("resize", resize);
      return () => {
        clearTimeout(timer);
        cancelAnimationFrame(frame);
        observer.disconnect();
        activeObserver.disconnect();
        doc.removeEventListener("pointerdown", down, true);
        panel.removeEventListener("keydown", key2);
        panel.removeEventListener("pointerover", over);
        panel.removeEventListener("pointerleave", leave);
        window.removeEventListener("resize", resize);
        const index = stack2.indexOf(panel);
        if (index >= 0) stack2.splice(index, 1);
        if (panel.matches(":popover-open")) panel.hidePopover();
      };
    }), dispose => Effect.sync(dispose));
    return yield* Effect.never;
  }))
});
var rowId2 = (id, path) => `${id}-item-${path.map(encodeURIComponent).join("/")}`;
var view31 = (config, h) => {
  const model = reconcile2(config.model, config.items);
  const send = config.toParentMessage;
  const render = (items, ancestors) => h.div([h.Role(ancestors.length ? "menu" : "group"), h.AriaLabel(ancestors.length ? itemsAt(config.items, ancestors.slice(0, -1)).find(item2 => item2.id === ancestors.at(-1))?.label ?? config.label : config.label), ...sxAttrs(h, desktopStyles.menu, desktopStyles.column)], items.map(item2 => {
    const path = [...ancestors, item2.id];
    const active = model.path[ancestors.length] === item2.id;
    return h.div([h.Key(item2.id)], [h.div([h.Id(rowId2(model.id, path)), h.Role(item2.kind ? `menuitem${item2.kind}` : "menuitem"), h.Tabindex(-1), h.AriaDisabled(disabled(item2)), h.DataAttribute("menu-path", JSON.stringify(path)), ...sxAttrs(h, desktopStyles.button, desktopStyles.row, active && desktopStyles.selected), ...(item2.kind ? [h.AriaChecked(item2.isChecked === true)] : []), ...(item2.children ? [h.Attribute("aria-haspopup", "menu"), h.AriaExpanded(active && model.path.length > path.length)] : []), ...(item2.command ? [h.AriaKeyshortcuts(Keyboard5.aria(item2.command.shortcut, config.platform ?? "other"))] : []), h.OnClick(send(Message9.Selected({
      path
    })))], [h.span([h.AriaHidden(true)], [item2.kind ? item2.isChecked ? "\u2713" : "\u25CB" : ""]), item2.label, ...(item2.command ? [h.kbd(sxAttrs(h, desktopStyles.muted), [Keyboard5.display(item2.command.shortcut, config.platform ?? "other")])] : []), h.span([h.AriaHidden(true)], [item2.children ? "\u203A" : ""])]), ...(active && item2.children && model.path.length > path.length ? [h.div([h.Style({
      marginInlineStart: "16px"
    })], [render(item2.children, path)])] : [])]);
  }));
  return h.div(sxAttrs(h, desktopStyles.column), [h.div([h.Id(`${model.id}-trigger`), h.Tabindex(0), h.Role(config.context ? "group" : "button"), h.AriaLabel(config.label), h.Attribute("aria-haspopup", "menu"), h.AriaExpanded(model.isOpen), ...(config.context ? [h.OnMount(Mount.mapMessage(Context(), send))] : [h.OnClick(send(model.isOpen ? Message9.Closed({
    restore: true
  }) : Message9.Opened({
    x: null,
    y: null
  }))), h.OnKeyDownPreventDefault(key2 => model.isOpen && ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Home", "End", "Enter", " ", "Escape"].includes(key2) ? Option.some(send(Message9.Key({
    key: key2
  }))) : ["Enter", " ", "ArrowDown"].includes(key2) ? Option.some(send(Message9.Opened({
    x: null,
    y: null
  }))) : Option.none())]), ...sxAttrs(h, desktopStyles.button)], config.trigger ?? [config.label]), ...(model.isOpen ? [h.div([h.Id(`${model.id}-layer`), h.Key(JSON.stringify([model.id, model.x, model.y])), h.Attribute("popover", "manual"), h.Tabindex(-1), h.Role("menu"), h.AriaLabel(config.label), ...(model.path.length ? [h.AriaActiveDescendant(rowId2(model.id, model.path))] : []), h.Style({
    position: "fixed",
    margin: "0",
    inset: "auto",
    border: "none",
    padding: "0",
    background: "transparent",
    maxHeight: "calc(100vh - 16px)",
    overflow: "auto"
  }), h.OnMount(Mount.mapMessage(Layer({
    trigger: `${model.id}-trigger`,
    x: model.x,
    y: model.y
  }), send))], [render(config.items, [])])] : [])]);
};

// src/stateful/menu.ts
var create20 = () => Menu.create();
var styledViewInputs4 = (config, h) => {
  const byValue = new Map(config.items.map(item2 => [item2.value, item2]));
  return {
    items: config.items.map(item2 => item2.value),
    buttonContent: h.span(sxAttrs(h, statefulStyles.selectButton), config.trigger),
    buttonClassName: classNames.trigger,
    itemsClassName: {
      className: "x1rnmz67 x1ubh2qd xbin24w x1y0btm7 xmkeg23 x4fn6gb xl26v19 xavv6ry x180skxv x1odjw0f xa9119d x1hc1fzr xjmin83 x19991ni x1xy946n x12w9bfk x18zocjo xrvj5dj x195vfkc xe8uvvx x1ghz6dp xfawy5m"
    }.className ?? "",
    backdropClassName: classNames.backdrop,
    className: classNames.root,
    groupClassName: {
      className: "xrvj5dj x195vfkc"
    }.className ?? "",
    separatorClassName: {
      className: "xzm8oiv xjm9jq1 xso6zq5"
    }.className ?? "",
    anchor: anchor(config.anchor),
    ...(config.ariaLabel === void 0 ? {} : {
      ariaLabel: config.ariaLabel
    }),
    ...(config.isDisabled === void 0 ? {} : {
      isButtonDisabled: config.isDisabled
    }),
    isItemDisabled: value => byValue.get(value)?.isDisabled === true,
    itemToSearchText: value => byValue.get(value)?.label ?? value,
    itemGroupKey: value => byValue.get(value)?.group ?? "",
    groupToHeading: group2 => group2 === "" ? void 0 : {
      content: h.span([], [group2]),
      className: {
        className: "xyu5t3h x14t0e4u x1j6dyjg x1s688f x18tqr4w"
      }.className ?? ""
    },
    itemToConfig: (value, context) => {
      const item2 = byValue.get(value);
      const content = h.span([...sxAttrs(h, statefulStyles.selectButton), ...(item2?.command ? [h.AriaKeyshortcuts(Keyboard5.aria(item2.command.shortcut, config.platform ?? "other"))] : [])], [...(item2?.media ?? []), item2?.label ?? value, ...(item2?.command ? [h.kbd(sxAttrs(h, statefulStyles.menuShortcut), [Keyboard5.display(item2.command.shortcut, config.platform ?? "other")])] : item2?.shortcut === void 0 ? [] : [h.span(sxAttrs(h, statefulStyles.menuShortcut), [item2.shortcut])])]);
      return {
        content,
        className: {
          0: {
            className: "x6s0dn4 xjbqb8w x7pwlv5 x5i151u x78zum5 x14t0e4u x4z9k3i x7agqhd x1rz828m x8lhhth xdpxx8g xh8yej3 x1heor9g xt0e3qv"
          },
          4: {
            className: "x6s0dn4 x5i151u x78zum5 x14t0e4u x4z9k3i x7agqhd x1rz828m x8lhhth xdpxx8g xh8yej3 xt0e3qv xtvgv0j x1vn8azr"
          },
          2: {
            className: "x6s0dn4 xjbqb8w x7pwlv5 x5i151u x78zum5 x14t0e4u x4z9k3i x7agqhd x1rz828m x8lhhth xdpxx8g xh8yej3 x1heor9g x1h6gzvc xbyyjgo"
          },
          6: {
            className: "x6s0dn4 x5i151u x78zum5 x14t0e4u x4z9k3i x7agqhd x1rz828m x8lhhth xdpxx8g xh8yej3 xtvgv0j x1vn8azr x1h6gzvc xbyyjgo"
          },
          1: {
            className: "x6s0dn4 xjbqb8w x7pwlv5 x5i151u x78zum5 x14t0e4u x4z9k3i x7agqhd x1rz828m x8lhhth xdpxx8g xh8yej3 xt0e3qv x1g3r7qa"
          },
          5: {
            className: "x6s0dn4 x5i151u x78zum5 x14t0e4u x4z9k3i x7agqhd x1rz828m x8lhhth xdpxx8g xh8yej3 xt0e3qv xtvgv0j x1g3r7qa"
          },
          3: {
            className: "x6s0dn4 xjbqb8w x7pwlv5 x5i151u x78zum5 x14t0e4u x4z9k3i x7agqhd x1rz828m x8lhhth xdpxx8g xh8yej3 x1h6gzvc xbyyjgo x1g3r7qa"
          },
          7: {
            className: "x6s0dn4 x5i151u x78zum5 x14t0e4u x4z9k3i x7agqhd x1rz828m x8lhhth xdpxx8g xh8yej3 xtvgv0j x1h6gzvc xbyyjgo x1g3r7qa"
          }
        }[!!context.isActive << 2 | !!context.isDisabled << 1 | !!(item2?.isDestructive === true) << 0].className ?? ""
      };
    }
  };
};
var fromCommand2 = command2 => ({
  value: command2.id,
  label: command2.label,
  command: command2,
  ...(command2.isDisabled === void 0 ? {} : {
    isDisabled: command2.isDisabled
  })
});

// src/stateful/popover.ts
var popover_exports = {};
__export(popover_exports, {
  styledViewInputs: () => styledViewInputs5
});
__reExport(popover_exports, Popover2);
var styledViewInputs5 = (config, h) => ({
  anchor: anchor(config.anchor),
  ...(config.ariaLabel === void 0 ? {} : {
    ariaLabel: config.ariaLabel
  }),
  ...(config.isDisabled === void 0 ? {} : {
    isDisabled: config.isDisabled
  }),
  ...(config.focusSelector === void 0 ? {} : {
    focusSelector: config.focusSelector
  }),
  ...(config.showArrow === true ? {
    arrowPadding: 8
  } : {}),
  toView: ({
    button,
    panel,
    backdrop,
    arrow,
    isVisible
  }) => h.span(rootAttrs(config, h, statefulStyles.layerRoot), [h.button([...button, ...slotAttrs(config.slotProps?.trigger, h, catalogStyles.toggle, catalogStyles.focusable)], config.trigger), ...(isVisible ? [h.div([...backdrop, ...slotAttrs(config.slotProps?.backdrop, h, statefulStyles.layerBackdrop)]), h.div([...panel, h.Role("dialog"), h.AriaLabel(config.ariaLabel ?? "Popover"), ...slotAttrs(config.slotProps?.panel, h, statefulStyles.layerPanel, statefulStyles.transition)], [...config.content, ...(config.showArrow === true ? [h.span([...arrow, ...slotAttrs(config.slotProps?.arrow, h, statefulStyles.layerArrow)])] : [])])] : [])])
});

// src/stateful/tooltip.ts
var tooltip_exports = {};
__export(tooltip_exports, {
  styledViewInputs: () => styledViewInputs6
});
__reExport(tooltip_exports, Tooltip2);
var styledViewInputs6 = (config, h) => ({
  anchor: anchor({
    placement: "top",
    gap: 6,
    ...config.anchor
  }),
  ...(config.ariaLabel === void 0 ? {} : {
    ariaLabel: config.ariaLabel
  }),
  ...(config.isDisabled === void 0 ? {} : {
    isDisabled: config.isDisabled
  }),
  toView: ({
    trigger,
    panel,
    isVisible
  }) => h.span(rootAttrs(config, h, statefulStyles.layerRoot), [...(config.renderTrigger === void 0 ? [h.button([...trigger, ...slotAttrs(config.slotProps?.trigger, h, catalogStyles.toggle, catalogStyles.focusable)], config.trigger)] : [config.renderTrigger(trigger, config.trigger, h)]), ...(isVisible ? [h.span([...panel, ...slotAttrs(config.slotProps?.panel, h, catalogStyles.tooltip, statefulStyles.tooltipPanel)], typeof config.label === "string" ? [config.label] : config.label)] : [])])
});

// src/stateful/combobox.ts
var combobox_exports = {};
__export(combobox_exports, {
  Multi: () => Multi2,
  create: () => create22,
  filterOptions: () => filterOptions,
  score: () => score2,
  styledViewInputs: () => styledViewInputs7
});
__reExport(combobox_exports, Combobox3);
var score2 = (option, query) => {
  const search = query.trim().toLocaleLowerCase();
  if (search === "") return 1;
  const values = [option.label, ...(option.keywords ?? [])].map(value => value.toLocaleLowerCase());
  if (values.some(value => value === search)) return 4;
  if (values.some(value => value.startsWith(search))) return 3;
  if (values.some(value => value.split(/\s+/).some(word => word.startsWith(search)))) return 2;
  return values.some(value => value.includes(search)) ? 1 : 0;
};
var filterOptions = (options, query) => options.map((option, index) => ({
  option,
  index,
  rank: score2(option, query)
})).filter(({
  rank
}) => rank > 0).sort((a, b) => b.rank - a.rank || a.index - b.index).map(({
  option
}) => option);
var commonInputs = (config, h) => {
  const options = config.shouldFilter === false ? config.options : filterOptions(config.options, config.query ?? "");
  const byValue = new Map(config.options.map(option => [option.value, option]));
  return {
    items: options.map(option => option.value),
    itemToValue: value => value,
    itemToDisplayText: value => byValue.get(value)?.label ?? value,
    isItemDisabled: value => byValue.get(value)?.isDisabled === true,
    restingInputValue: "",
    inputPlaceholder: config.placeholder ?? "Search\u2026",
    inputClassName: {
      0: {
        className: "x1f6rtwf x15nqw3 x1rwf2kx xbin24w x1y0btm7 xmkeg23 x1heor9g xajfy2p xif65rj x21xpn4 x1lqa7cf xcicffo xh8yej3 x1gnnqk1 x1xy946n x12zzom9 xe36upo x1a2a7pz x6454uj x1wfwxd8 xjppbhk x1a2w583 xeuugli"
      },
      1: {
        className: "x1f6rtwf xbin24w x1y0btm7 xmkeg23 x1heor9g xajfy2p xif65rj x21xpn4 x1lqa7cf xcicffo xh8yej3 x1xy946n x12zzom9 xe36upo x1a2a7pz x6454uj x1wfwxd8 xjppbhk x1a2w583 xeuugli xuj4g81 x1c8vacq"
      }
    }[!!(config.isInvalid === true) << 0].className ?? "",
    inputWrapperClassName: {
      className: "x1qjc9v5 xrvj5dj x13ylbr2"
    }.className ?? "",
    buttonContent: view2({
      icon: ChevronsUpDown,
      size: 14
    }, h),
    buttonClassName: {
      className: "x13zjy52 x1hza1xs x1rj7npj x1y0btm7 xi67cz2 xmkeg23 x14e42zd xyu5t3h x1ypdohk x1a2a7pz x6454uj x1wfwxd8"
    }.className ?? "",
    itemsClassName: {
      className: "x1rnmz67 x1ubh2qd xbin24w x1y0btm7 xmkeg23 x4fn6gb xl26v19 xavv6ry x180skxv x1odjw0f x1a2zjlo xa9119d x1hc1fzr xjmin83 x19991ni x1xy946n x12w9bfk xl49voo"
    }.className ?? "",
    itemsScrollClassName: {
      className: "xrvj5dj x195vfkc x12dd5wy x1odjw0f"
    }.className ?? "",
    backdropClassName: classNames.backdrop,
    className: {
      className: "xrvj5dj xeuugli x1n2onr6"
    }.className ?? "",
    groupClassName: {
      className: "xrvj5dj x195vfkc"
    }.className ?? "",
    separatorClassName: {
      className: "xzm8oiv xjm9jq1 xso6zq5"
    }.className ?? "",
    groupToHeading: group2 => group2 === "" ? void 0 : {
      content: h.span([], [group2]),
      className: {
        className: "xyu5t3h x14t0e4u x1j6dyjg x1s688f x18tqr4w"
      }.className ?? ""
    },
    itemGroupKey: value => byValue.get(value)?.group ?? "",
    itemToConfig: (value, context) => ({
      className: {
        0: {
          className: "x6s0dn4 xjbqb8w x7pwlv5 x5i151u x78zum5 x14t0e4u x4z9k3i x7agqhd x1rz828m x8lhhth xdpxx8g xh8yej3 x1heor9g xt0e3qv"
        },
        4: {
          className: "x6s0dn4 x5i151u x78zum5 x14t0e4u x4z9k3i x7agqhd x1rz828m x8lhhth xdpxx8g xh8yej3 xt0e3qv xtvgv0j x1vn8azr"
        },
        2: {
          className: "x6s0dn4 xjbqb8w x7pwlv5 x5i151u x78zum5 x14t0e4u x4z9k3i x7agqhd x1rz828m x8lhhth xdpxx8g xh8yej3 x1heor9g xt0e3qv x1s688f"
        },
        6: {
          className: "x6s0dn4 x5i151u x78zum5 x14t0e4u x4z9k3i x7agqhd x1rz828m x8lhhth xdpxx8g xh8yej3 xt0e3qv xtvgv0j x1vn8azr x1s688f"
        },
        1: {
          className: "x6s0dn4 xjbqb8w x7pwlv5 x5i151u x78zum5 x14t0e4u x4z9k3i x7agqhd x1rz828m x8lhhth xdpxx8g xh8yej3 x1heor9g x1h6gzvc xbyyjgo"
        },
        5: {
          className: "x6s0dn4 x5i151u x78zum5 x14t0e4u x4z9k3i x7agqhd x1rz828m x8lhhth xdpxx8g xh8yej3 xtvgv0j x1vn8azr x1h6gzvc xbyyjgo"
        },
        3: {
          className: "x6s0dn4 xjbqb8w x7pwlv5 x5i151u x78zum5 x14t0e4u x4z9k3i x7agqhd x1rz828m x8lhhth xdpxx8g xh8yej3 x1heor9g x1s688f x1h6gzvc xbyyjgo"
        },
        7: {
          className: "x6s0dn4 x5i151u x78zum5 x14t0e4u x4z9k3i x7agqhd x1rz828m x8lhhth xdpxx8g xh8yej3 xtvgv0j x1vn8azr x1s688f x1h6gzvc xbyyjgo"
        }
      }[!!context.isActive << 2 | !!context.isSelected << 1 | !!context.isDisabled << 0].className ?? "",
      content: h.span(sxAttrs(h, statefulStyles.selectButton), [byValue.get(value)?.label ?? value, ...(context.isSelected ? [view2({
        icon: Check,
        size: 14
      }, h)] : [])])
    }),
    anchor: anchor(config.anchor),
    ariaLabel: config.ariaLabel,
    ...(config.isDisabled === void 0 ? {} : {
      isDisabled: config.isDisabled
    }),
    ...(config.isReadOnly === void 0 ? {} : {
      isReadOnly: config.isReadOnly
    }),
    ...(config.isInvalid === void 0 ? {} : {
      isInvalid: config.isInvalid
    }),
    ...(config.name === void 0 ? {} : {
      formName: config.name
    }),
    ...(config.openOnFocus === void 0 ? {} : {
      openOnFocus: config.openOnFocus
    })
  };
};
var create22 = () => Combobox3.create();
var styledViewInputs7 = (config, h) => {
  const common = commonInputs(config, h);
  const selected = config.options.find(option => option.value === config.value);
  return {
    ...common,
    restingInputValue: selected?.label ?? "",
    maybeSelectedValue: config.value === void 0 ? Option.none() : Option.some(config.value)
  };
};
var multiStyledViewInputs = (config, h) => ({
  ...commonInputs(config, h),
  selectedValues: config.values
});
var Multi2 = {
  Model: Combobox3.Multi.Model,
  init: Combobox3.Multi.init,
  create: () => Combobox3.Multi.create(),
  styledViewInputs: multiStyledViewInputs
};

// src/stateful/toast.ts
var toast_exports = {};
__export(toast_exports, {
  Entry: () => Entry,
  Message: () => Message10,
  Model: () => Model9,
  OutMessage: () => OutMessage7,
  Payload: () => Payload,
  Position: () => Position,
  Variant: () => Variant,
  WaitBeforeDismissal: () => WaitBeforeDismissal,
  dismiss: () => dismiss,
  dismissAll: () => dismissAll,
  init: () => init9,
  show: () => show,
  styledViewInputs: () => styledViewInputs8,
  update: () => update10,
  view: () => view32
});
var Payload = Schema.Struct({
  title: Schema.String,
  description: Schema.optional(Schema.String)
});
var Engine = Toast.make(Payload);
var Entry = Engine.Entry;
var Model9 = Engine.Model;
var Message10 = Engine.Message;
var OutMessage7 = Engine.OutMessage;
var init9 = Engine.init;
var update10 = Engine.update;
var show = Engine.show;
var dismiss = Engine.dismiss;
var dismissAll = Engine.dismissAll;
var view32 = Engine.view;
var positionStyle = position => ({
  TopLeft: statefulStyles.toastTopLeft,
  TopCenter: statefulStyles.toastTopCenter,
  TopRight: statefulStyles.toastTopRight,
  BottomLeft: statefulStyles.toastBottomLeft,
  BottomCenter: statefulStyles.toastBottomCenter,
  BottomRight: statefulStyles.toastBottomRight
})[position];
var variantStyle2 = variant => ({
  Info: primitiveStyles.toastInfo,
  Success: primitiveStyles.toastSuccess,
  Warning: primitiveStyles.toastWarning,
  Error: primitiveStyles.toastError
})[variant];
var styledViewInputs8 = (config = {}, h) => {
  const position = config.position ?? "BottomRight";
  return {
    position,
    ...(config.ariaLabel === void 0 ? {} : {
      ariaLabel: config.ariaLabel
    }),
    containerClassName: stylex2.props(primitiveStyles.toastViewport, positionStyle(position)).className ?? "",
    entryClassName: "",
    entryToView: (entry, handlers) => h.div([...sxAttrs(h, primitiveStyles.toast, variantStyle2(entry.variant), entry.animation.transitionState === "EnterStart" || entry.animation.transitionState === "LeaveAnimating" ? primitiveStyles.toastClosed : void 0), h.DataAttribute("toast-id", entry.id)], [h.div(sxAttrs(h, primitiveStyles.toastTitle), [entry.payload.title]), ...(entry.payload.description === void 0 ? [] : [h.p(sxAttrs(h, primitiveStyles.toastDescription), [entry.payload.description])]), h.button([...handlers.dismiss, ...sxAttrs(h, primitiveStyles.toastDismiss), h.Type("button"), h.AriaLabel(`Dismiss ${entry.payload.title}`)], ["Dismiss"])])
  };
};

// src/stateful/alert-dialog.ts
var alert_dialog_exports = {};
__export(alert_dialog_exports, {
  styledViewInputs: () => styledViewInputs9
});
__reExport(alert_dialog_exports, dialog_exports);
var styledViewInputs9 = (config, h) => styledViewInputs2({
  ...config,
  placement: config.placement ?? "center",
  role: "alertdialog"
}, h);

// src/stateful/drawer.ts
var drawer_exports = {};
__export(drawer_exports, {
  styledViewInputs: () => styledViewInputs10
});
__reExport(drawer_exports, dialog_exports);
var styledViewInputs10 = (config, h) => styledViewInputs2({
  ...config,
  placement: config.placement ?? "bottom",
  role: "dialog"
}, h);

// src/stateful/sheet.ts
var sheet_exports = {};
__export(sheet_exports, {
  styledViewInputs: () => styledViewInputs11
});
__reExport(sheet_exports, dialog_exports);
var styledViewInputs11 = (config, h) => styledViewInputs2({
  ...config,
  placement: config.placement ?? "right",
  role: "dialog"
}, h);

// src/stateful/date-picker.ts
var date_picker_exports = {};
__export(date_picker_exports, {
  calendarView: () => calendarView,
  styledViewInputs: () => styledViewInputs12
});
__reExport(date_picker_exports, DatePicker);
var calendarView = (attributes, h) => {
  const heading2 = h.h3([h.Id(attributes.heading.id)], [attributes.heading.text]);
  const button = (attrs, text2) => h.button([...attrs, ...sxAttrs(h, desktopStyles.button)], [text2]);
  return h.div([...attributes.root, ...sxAttrs(h, desktopStyles.calendar)], [h.header(sxAttrs(h, desktopStyles.row), attributes._tag === "Days" ? [button(attributes.previousMonthButton, "\u2039"), button([...attributes.headingButton, h.Id(attributes.heading.id)], attributes.heading.text), button(attributes.nextMonthButton, "\u203A")] : attributes._tag === "Months" ? [button([...attributes.headingButton, h.Id(attributes.heading.id)], attributes.heading.text)] : [button(attributes.previousPageButton, "\u2039"), heading2, button(attributes.nextPageButton, "\u203A")]), attributes._tag === "Days" ? h.div(attributes.grid, [h.div([...attributes.headerRow, ...sxAttrs(h, desktopStyles.week, desktopStyles.muted)], attributes.columnHeaders.map(header => h.div(header.attributes, [header.name]))), ...attributes.weeks.map(week => h.div([...week.attributes, ...sxAttrs(h, desktopStyles.week)], week.cells.map(cell => h.div([...cell.cellAttributes], [h.button([...cell.buttonAttributes, ...sxAttrs(h, desktopStyles.button, desktopStyles.calendarCell, cell.isFocused && desktopStyles.focused, cell.isSelected && desktopStyles.selected), h.Style({
    opacity: cell.isDisabled ? "0.35" : cell.isInViewMonth ? "1" : "0.6"
  })], [cell.label])]))))]) : h.div([...attributes.grid, h.AriaRowcount(4), h.AriaColcount(3)], Array.from({
    length: 4
  }, (_, row2) => h.div([h.Role("row"), ...sxAttrs(h, desktopStyles.months)], attributes.cells.slice(row2 * 3, row2 * 3 + 3).map(cell => h.div(cell.cellAttributes, [h.button([...cell.buttonAttributes, ...sxAttrs(h, desktopStyles.button, desktopStyles.calendarCell, cell.isSelected && desktopStyles.selected, cell.isFocused && desktopStyles.focused)], [cell.label])])))))]);
};
var styledViewInputs12 = (config, h) => ({
  maybeSelectedDate: Option.fromNullishOr(config.value),
  anchor: anchor(config.anchor),
  ariaLabel: config.label,
  triggerContent: value => h.span([], [Option.isSome(value) ? config.format?.(value.value) ?? `${value.value.year}-${String(value.value.month).padStart(2, "0")}-${String(value.value.day).padStart(2, "0")}` : "Choose date"]),
  toCalendarView: attrs => calendarView(attrs, h),
  triggerClassName: classNames.trigger,
  panelClassName: `${classNames.panel} ${{
    className: "xrvj5dj x1jnr06f x1dz1jew x193iq5w"
  }.className ?? ""}`,
  backdropClassName: classNames.backdrop,
  ...(config.isDisabled === void 0 ? {} : {
    isDisabled: config.isDisabled
  }),
  ...(config.name === void 0 || config.isDisabled ? {} : {
    name: config.name
  })
});

// src/shortcuts.ts
var shortcuts_exports = {};
__export(shortcuts_exports, {
  Message: () => Message11,
  Register: () => Register,
  reference: () => reference,
  registration: () => registration
});
__reExport(shortcuts_exports, Keyboard5);
var Message11 = defineMessageUnion({
  Invoked: {
    id: Schema.String
  }
});
var Register = Mount.defineStream("RegisterKeyboardCommands", {
  args: {
    bindings: Schema.Array(Keyboard5.Binding),
    platform: Keyboard5.Platform
  },
  messages: [Message11.Invoked],
  execute: ({
    bindings,
    platform,
    element
  }) => Keyboard5.events(() => element.isConnected ? bindings : [], platform).pipe(Stream.map(id => Message11.Invoked({
    id
  })))
});
var registration = (config, h) => h.span([h.Key(JSON.stringify([config.platform, config.bindings])), h.Hidden(true), h.OnMount(Mount.mapMessage(Register({
  bindings: config.bindings,
  platform: config.platform
}), config.toParentMessage))], []);
var reference = (config, h) => h.dl(sxAttrs(h, desktopStyles.column), config.bindings.map(binding => h.div(sxAttrs(h, desktopStyles.row), [h.dt([], [h.button([h.Type("button"), h.Disabled(binding.isDisabled === true), h.AriaKeyshortcuts(Keyboard5.aria(binding.shortcut, config.platform)), h.OnClick(config.onInvoke(binding.id)), ...sxAttrs(h, desktopStyles.button)], [binding.label])]), h.dd(sxAttrs(h, desktopStyles.muted), [h.kbd([], [Keyboard5.display(binding.shortcut, config.platform)]), binding.scope ? ` \xB7 ${binding.scope}` : " \xB7 Global"])])));

// src/overflow-list.ts
var overflow_list_exports = {};
__export(overflow_list_exports, {
  Message: () => Message12,
  Model: () => Model10,
  init: () => init10,
  partition: () => partition,
  update: () => update11,
  view: () => view33
});
var Model10 = Model5;
var Message12 = Message6;
var init10 = init5;
var update11 = update5;
var partition = (items, widths, available, triggerWidth, policy = {}) => {
  const ids = new Set(items.map(item2 => item2.id));
  if (ids.size !== items.length || items.some(item2 => !item2.id || item2.id.startsWith("$"))) throw new Error("Overflow IDs must be unique, nonempty, and not start with $. ");
  if ([available, triggerWidth, policy.gap, policy.minVisible, ...Object.values(widths)].some(value => value !== void 0 && (!Number.isFinite(value) || value < 0))) throw new Error("Overflow sizes and limits must be finite and nonnegative.");
  const gap = Math.max(0, policy.gap ?? 8);
  let visible = [...items];
  const overflow = [];
  if (available === void 0 || triggerWidth === void 0 || items.some(item2 => widths[item2.id] === void 0)) return {
    visible,
    overflow
  };
  const size = () => visible.reduce((sum, item2) => sum + Math.max(0, widths[item2.id]), 0) + gap * Math.max(0, visible.length - 1) + (overflow.length ? triggerWidth + (visible.length ? gap : 0) : 0);
  const minimum = Math.max(0, Math.min(items.length, Math.floor(policy.minVisible ?? 0)));
  while (visible.length > minimum && size() > available) {
    if (policy.direction === "start") overflow.push(visible.shift());else overflow.unshift(visible.pop());
  }
  return {
    visible,
    overflow
  };
};
var view33 = (config, h) => {
  const widths = Object.fromEntries(Object.entries(config.model).map(([key2, box]) => [key2, box.width]));
  const {
    visible,
    overflow
  } = partition(config.items, widths, widths.$root, widths.$trigger, config);
  const trigger = h.details([], [h.summary(sxAttrs(h, desktopStyles.button), ["More"]), h.ul(sxAttrs(h, desktopStyles.menu), overflow.map(item2 => h.li([], [config.renderItem(item2)])))]);
  const more = overflow.length ? [config.renderOverflow?.(overflow) ?? trigger] : [];
  return h.div([...sxAttrs(h, desktopStyles.overflow), h.OnMount(Mount.mapMessage(Observe(), config.toParentMessage))], [h.div([...sxAttrs(h, desktopStyles.scroller), h.Style({
    gap: `${config.gap ?? 8}px`
  }), h.Role("group"), h.AriaLabel(config.label)], [...(config.direction === "start" ? more : []), ...visible.map(item2 => h.div([h.Key(item2.id), ...sxAttrs(h, desktopStyles.item)], [config.renderItem(item2)])), ...(config.direction === "start" ? [] : more)]), h.div([...sxAttrs(h, desktopStyles.probes), h.AriaHidden(true), h.Attribute("inert", "")], [...config.items.map(item2 => h.div([h.Key(item2.id), h.DataAttribute("measure", item2.id), ...sxAttrs(h, desktopStyles.item)], [config.measureItem(item2)])), h.div([h.DataAttribute("measure", "$trigger"), ...sxAttrs(h, desktopStyles.item)], [config.measureOverflow ?? h.details([], [h.summary(sxAttrs(h, desktopStyles.button), ["More"])])])])]);
};

// src/token-field.ts
var token_field_exports = {};
__export(token_field_exports, {
  Message: () => Message14,
  Model: () => Model11,
  OutMessage: () => OutMessage8,
  add: () => add,
  init: () => init11,
  tokenize: () => tokenize,
  update: () => update12,
  view: () => view34
});
var Suggestions = Multi2.create();
var Model11 = Schema.Struct({
  id: Schema.String,
  combobox: Multi2.Model,
  active: Schema.NullOr(Schema.String),
  error: Schema.String
});
var Message14 = defineMessageUnion({
  GotCombobox: {
    message: combobox_exports.Message
  },
  Pasted: {
    text: Schema.String
  },
  Removed: {
    value: Schema.String
  },
  Navigated: {
    key: Schema.String
  },
  Activated: {
    value: Schema.String
  },
  Focused: {}
});
var OutMessage8 = defineMessageUnion({
  Changed: {
    values: Schema.Array(Schema.String)
  }
});
var init11 = id => ({
  id,
  combobox: Multi2.init({
    id: `${id}-suggestions`
  }),
  active: null,
  error: ""
});
var tokenize = (text2, config) => {
  let parts = [text2];
  for (const delimiter of config.delimiters ?? [",", ";", "\n"]) if (delimiter) parts = parts.flatMap(part => part.split(delimiter));
  return parts.map(value => config.trim === false ? value : value.trim()).filter(Boolean);
};
var add = (values, candidates, config) => {
  const next = [...values];
  const identity = config.deduplicate ?? (value => value);
  for (const candidate of candidates) {
    const value = config.trim === false ? candidate : candidate.trim();
    if (!value || next.some(existing => identity(existing) === identity(value))) continue;
    const option = config.options.find(option2 => option2.value === value);
    const error = option?.isDisabled ? `${value} is unavailable.` : !option && !config.allowCustom ? `${value} is not an available option.` : config.validate?.(value);
    if (error) return {
      values,
      error
    };
    next.push(value);
  }
  return next.length > (config.maxCount ?? Infinity) ? {
    values,
    error: `Choose at most ${config.maxCount} values.`
  } : {
    values: next,
    error: ""
  };
};
var Focus5 = Command.define("FocusTokenField", {
  args: {
    id: Schema.String,
    value: Schema.NullOr(Schema.String)
  },
  messages: [Message14.Focused],
  execute: ({
    id,
    value
  }) => (value === null ? Dom.focus(`#${CSS.escape(id)} input[role=combobox]`) : Dom.focus(`#${CSS.escape(id)} [data-token="${encodeURIComponent(value)}"] button`)).pipe(Effect.ignore, Effect.as(Message14.Focused()))
});
var focus4 = model => [Focus5({
  id: model.id,
  value: model.active
})];
var update12 = (model, message3, config) => {
  const blocked = config.isDisabled || config.isReadOnly;
  const changed = candidates => {
    const result = add(config.values, candidates, config);
    return {
      model: {
        ...model,
        active: null,
        error: result.error,
        combobox: {
          ...model.combobox,
          inputValue: result.error ? model.combobox.inputValue : ""
        }
      },
      ...(!result.error ? {
        outMessage: OutMessage8.Changed({
          values: result.values
        })
      } : {})
    };
  };
  switch (message3._tag) {
    case "Focused":
      return {
        model
      };
    case "GotCombobox":
      {
        const result = Suggestions.update(model.combobox, message3.message);
        const next = {
          ...model,
          combobox: result.model,
          active: message3.message._tag === "UpdatedInputValue" || message3.message._tag === "Opened" ? null : model.active
        };
        const commands = (result.commands ?? []).map(command2 => Command.mapMessage(command2, message4 => Message14.GotCombobox({
          message: message4
        })));
        if (result.outMessage?._tag === "Selected" && !blocked) {
          const value = result.outMessage.value;
          const addition = changed([value]);
          const selected = config.values.includes(value) ? {
            model: next,
            outMessage: OutMessage8.Changed({
              values: config.values.filter(item2 => item2 !== value)
            })
          } : {
            ...addition,
            model: {
              ...addition.model,
              combobox: {
                ...next.combobox,
                inputValue: addition.model.error ? model.combobox.inputValue : ""
              }
            }
          };
          return {
            ...selected,
            commands
          };
        }
        return {
          model: next,
          commands
        };
      }
    case "Pasted":
      return blocked ? {
        model
      } : changed(tokenize(message3.text, config));
    case "Removed":
      {
        if (blocked) return {
          model
        };
        const next = {
          ...model,
          active: null,
          error: ""
        };
        return {
          model: next,
          commands: focus4(next),
          outMessage: OutMessage8.Changed({
            values: config.values.filter(value => value !== message3.value)
          })
        };
      }
    case "Activated":
      {
        const next = {
          ...model,
          active: message3.value
        };
        return {
          model: next,
          commands: focus4(next)
        };
      }
    case "Navigated":
      {
        if (blocked) return {
          model
        };
        if ((message3.key === "Backspace" || message3.key === "Delete") && model.active) return update12(model, Message14.Removed({
          value: model.active
        }), config);
        const index = model.active === null ? config.values.length : config.values.indexOf(model.active);
        const active = message3.key === "ArrowRight" ? config.values[index + 1] ?? null : config.values[Math.max(0, index - 1)] ?? null;
        const next = {
          ...model,
          active
        };
        return {
          model: next,
          commands: focus4(next)
        };
      }
  }
};
var view34 = (config, h) => {
  const {
    model,
    toParentMessage: send
  } = config;
  const options = [...config.options];
  const query = model.combobox.inputValue.trim();
  if (config.allowCustom && query && !options.some(option => option.value === query)) options.push({
    value: query,
    label: `Add \u201C${query}\u201D`
  });
  const blocked = config.isDisabled || config.isReadOnly;
  return h.div([h.OnMount(GuardComposition()), h.Id(model.id), ...sxAttrs(h, desktopStyles.column), h.OnPastePreventDefault(text2 => blocked ? Option.none() : Option.some(send(Message14.Pasted({
    text: text2
  })))), h.OnKeyDownPreventDefault(key2 => !blocked && (!model.combobox.inputValue || model.active !== null) && ["ArrowLeft", "ArrowRight", "Backspace", "Delete"].includes(key2) ? Option.some(send(Message14.Navigated({
    key: key2
  }))) : Option.none())], [h.div([h.Role("group"), h.AriaLabel(`${config.label} selected values`), ...sxAttrs(h, desktopStyles.row, desktopStyles.wrap)], config.values.map(value => view28({
    label: config.options.find(option => option.value === value)?.label ?? value,
    isSelected: model.active === value,
    isDisabled: config.isDisabled === true,
    attributes: [h.DataAttribute("token", encodeURIComponent(value))],
    ...(!blocked ? {
      onRemove: send(Message14.Removed({
        value
      })),
      onSelect: send(Message14.Activated({
        value
      }))
    } : {})
  }, h))), h.submodel({
    slotId: model.combobox.id,
    model: model.combobox,
    toParentMessage: message3 => send(Message14.GotCombobox({
      message: message3
    })),
    view: Suggestions.view,
    viewInputs: {
      ...Multi2.styledViewInputs({
        ...config,
        options,
        ariaLabel: config.label,
        query: model.combobox.inputValue
      }, h),
      formName: "",
      inputAttributes: childAttributes([h.Disabled(config.isDisabled === true), h.AriaDescribedBy(`${model.id}-status`), h.AriaInvalid(Boolean(model.error))])
    }
  }), ...(config.name && !config.isDisabled ? config.values.map(value => h.input([h.Type("hidden"), h.Name(config.name), h.Value(value)])) : []), h.p([h.Id(`${model.id}-status`), h.Role("status"), ...sxAttrs(h, model.error ? desktopStyles.error : desktopStyles.muted)], [model.error || "Choose suggestions or paste values. Use Left or Backspace in an empty field to select a tag."])]);
};

// src/panel-stack.ts
var panel_stack_exports = {};
__export(panel_stack_exports, {
  Message: () => Message15,
  Model: () => Model12,
  OutMessage: () => OutMessage9,
  Panel: () => Panel,
  init: () => init12,
  pop: () => pop,
  push: () => push,
  update: () => update13,
  view: () => view35
});
var Panel = Schema.Struct({
  id: Schema.String,
  returnFocusId: Schema.String
});
var Model12 = Schema.Struct({
  id: Schema.String,
  panels: Schema.Array(Panel)
});
var Message15 = defineMessageUnion({
  RequestedPush: {
    id: Schema.String,
    returnFocusId: Schema.String
  },
  RequestedPop: {},
  Focused: {}
});
var OutMessage9 = defineMessageUnion({
  Push: {
    id: Schema.String,
    returnFocusId: Schema.String
  },
  Pop: {}
});
var init12 = (id, rootId) => {
  if (!id || !rootId) throw new Error("PanelStack requires nonempty stack and root IDs.");
  return {
    id,
    panels: [{
      id: rootId,
      returnFocusId: ""
    }]
  };
};
var Focus6 = Command.define("FocusPanelStack", {
  args: {
    id: Schema.String,
    fallback: Schema.String
  },
  messages: [Message15.Focused],
  execute: ({
    id,
    fallback
  }) => Dom.focus(`#${CSS.escape(id || fallback)}`).pipe(Effect.catch(() => Dom.focus(`#${CSS.escape(fallback)}`)), Effect.ignore, Effect.as(Message15.Focused()))
});
var update13 = (model, message3) => ({
  model,
  ...(message3._tag === "RequestedPush" ? {
    outMessage: OutMessage9.Push({
      id: message3.id,
      returnFocusId: message3.returnFocusId
    })
  } : message3._tag === "RequestedPop" && model.panels.length > 1 ? {
    outMessage: OutMessage9.Pop()
  } : {})
});
var push = (model, panel) => {
  if (!panel.id || model.panels.some(item2 => item2.id === panel.id)) throw new Error("Panel IDs must be nonempty and unique in the stack.");
  return {
    model: {
      ...model,
      panels: [...model.panels, panel]
    },
    commands: [Focus6({
      id: `${model.id}-heading`,
      fallback: `${model.id}-heading`
    })]
  };
};
var pop = model => model.panels.length <= 1 ? {
  model
} : {
  model: {
    ...model,
    panels: model.panels.slice(0, -1)
  },
  commands: [Focus6({
    id: model.panels.at(-1).returnFocusId,
    fallback: `${model.id}-heading`
  })]
};
var BackKey = Mount.defineStream("PanelStackBackKey", {
  messages: [Message15.RequestedPop],
  execute: ({
    element
  }) => Stream.callback(queue => Effect.gen(function* () {
    yield* Effect.acquireRelease(Effect.sync(() => {
      const key2 = event => {
        const keyboard = event;
        const editable = event.composedPath().some(node => node instanceof HTMLElement && (node.matches("input,textarea,select") || node.isContentEditable));
        if (element.getAttribute("data-can-pop") !== "true" || !Keyboard5.resolve([{
          id: "back",
          label: "Back",
          shortcut: Keyboard5.shortcut("ArrowLeft", "Alt")
        }], keyboard, "other", [], editable)) return;
        keyboard.preventDefault();
        keyboard.stopPropagation();
        Queue.offerUnsafe(queue, Message15.RequestedPop());
      };
      element.addEventListener("keydown", key2);
      return () => element.removeEventListener("keydown", key2);
    }), dispose => Effect.sync(dispose));
    return yield* Effect.never;
  }))
});
var view35 = (config, h) => {
  const active = config.model.panels.at(-1);
  if (!active) throw new Error("PanelStack requires a root panel.");
  return h.section([h.AriaLabelledBy(`${config.model.id}-heading`), h.DataAttribute("can-pop", String(config.model.panels.length > 1)), ...sxAttrs(h, desktopStyles.column, desktopStyles.surface), h.OnMount(Mount.mapMessage(BackKey(), config.toParentMessage))], [h.header(sxAttrs(h, desktopStyles.row), [...(config.model.panels.length > 1 ? [h.button([h.Type("button"), h.OnClick(config.toParentMessage(Message15.RequestedPop())), h.AriaLabel("Back to previous panel"), ...sxAttrs(h, desktopStyles.button)], ["\u2190 Back"])] : []), h.h3([h.Id(`${config.model.id}-heading`), h.Tabindex(-1)], [config.title(active.id)])]), h.div([h.Key(active.id), h.DataAttribute("panel-id", active.id), ...sxAttrs(h, desktopStyles.panel)], [config.render(active.id)])]);
};

// src/date-input.ts
var date_input_exports = {};
__export(date_input_exports, {
  Message: () => Message17,
  Model: () => Model14,
  OutMessage: () => OutMessage10,
  calendarLocale: () => calendarLocale,
  init: () => init14,
  isAllowed: () => isAllowed,
  iso: () => iso,
  numericLocale: () => numericLocale,
  update: () => update15,
  view: () => view37
});
var iso = {
  format: date => `${String(date.year).padStart(4, "0")}-${String(date.month).padStart(2, "0")}-${String(date.day).padStart(2, "0")}`,
  parse: text2 => {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(text2);
    if (!match) return;
    const date = {
      year: +match[1],
      month: +match[2],
      day: +match[3]
    };
    return Calendar$1.isCalendarDate(date) ? date : void 0;
  },
  hint: "YYYY-MM-DD"
};
var numericLocale = locale => {
  const formatter = new Intl.DateTimeFormat(locale, {
    calendar: "gregory",
    numberingSystem: "latn",
    timeZone: "UTC",
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  });
  const sample = formatter.formatToParts(new globalThis.Date("2006-11-22T12:00:00Z"));
  const fields = [];
  const pattern = sample.map(part => {
    if (["year", "month", "day"].includes(part.type)) {
      fields.push(part.type);
      return part.type === "year" ? "(\\d{4})" : "(\\d{1,2})";
    }
    return part.value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }).join("");
  return {
    hint: sample.map(part => part.type === "year" ? "YYYY" : part.type === "month" ? "MM" : part.type === "day" ? "DD" : part.value).join(""),
    format: date => {
      const value = new globalThis.Date(0);
      value.setUTCFullYear(date.year, date.month - 1, date.day);
      return formatter.format(value);
    },
    parse: text2 => {
      const match = new RegExp(`^${pattern}$`).exec(text2);
      if (!match) return;
      const parts = Object.fromEntries(fields.map((field, i) => [field, Number(match[i + 1])]));
      const date = {
        year: parts.year,
        month: parts.month,
        day: parts.day
      };
      return Calendar$1.isCalendarDate(date) ? date : void 0;
    }
  };
};
var calendarLocale = (locale, firstDayOfWeek) => {
  const format = (options, month, day) => new Intl.DateTimeFormat(locale, {
    ...options,
    calendar: "gregory",
    numberingSystem: "latn",
    timeZone: "UTC"
  }).format(new globalThis.Date(globalThis.Date.UTC(2026, month, day)));
  return Schema.decodeUnknownSync(Calendar$1.LocaleConfig)({
    ...Calendar$1.defaultEnglishLocale,
    firstDayOfWeek,
    monthNames: Array.from({
      length: 12
    }, (_, month) => format({
      month: "long"
    }, month, 1)),
    shortMonthNames: Array.from({
      length: 12
    }, (_, month) => format({
      month: "short"
    }, month, 1)),
    // March 1, 2026 is a Sunday. Foldkit stores day names Sunday-first.
    dayNames: Array.from({
      length: 7
    }, (_, day) => format({
      weekday: "long"
    }, 2, day + 1)),
    shortDayNames: Array.from({
      length: 7
    }, (_, day) => format({
      weekday: "short"
    }, 2, day + 1))
  });
};
var Model14 = Schema.Struct({
  id: Schema.String,
  picker: date_picker_exports.Model,
  draft: Schema.NullOr(Schema.String),
  error: Schema.String
});
var Message17 = defineMessageUnion({
  GotPicker: {
    message: date_picker_exports.Message
  },
  Changed: {
    text: Schema.String
  },
  Committed: {},
  Cancelled: {}
});
var OutMessage10 = defineMessageUnion({
  Changed: {
    value: Schema.NullOr(Calendar$1.CalendarDate)
  }
});
var init14 = config => ({
  id: config.id,
  picker: date_picker_exports.init({
    ...config,
    id: `${config.id}-picker`
  }),
  draft: null,
  error: ""
});
var constrained = (model, config) => ({
  ...model,
  calendar: {
    ...model.calendar,
    maybeMinDate: Option.fromNullishOr(config.min),
    maybeMaxDate: Option.fromNullishOr(config.max),
    disabledDates: config.disabledDates ?? [],
    disabledDaysOfWeek: config.disabledDaysOfWeek ?? []
  }
});
var isAllowed = (date, config) => Calendar$1.isCalendarDate(date) && (!config.min || !Calendar$1.isBefore(date, config.min)) && (!config.max || !Calendar$1.isAfter(date, config.max)) && !config.disabledDates?.some(disabled2 => Calendar$1.isEqual(date, disabled2)) && !config.disabledDaysOfWeek?.includes(Calendar$1.dayOfWeek(date));
var update15 = (model, message3, config) => {
  if (message3._tag === "GotPicker") {
    const result = date_picker_exports.update(constrained(model.picker, config), message3.message);
    const value2 = result.outMessage?._tag === "SelectedDate" ? result.outMessage.date : null;
    const changed = result.outMessage?._tag === "SelectedDate" || result.outMessage?._tag === "ClearedDate";
    return {
      model: {
        ...model,
        picker: result.model,
        ...(changed ? {
          draft: null,
          error: ""
        } : {})
      },
      commands: (result.commands ?? []).map(command2 => Command.mapMessage(command2, message4 => Message17.GotPicker({
        message: message4
      }))),
      ...(changed && !config.isDisabled && !config.isReadOnly && (value2 === null ? !config.required : isAllowed(value2, config)) ? {
        outMessage: OutMessage10.Changed({
          value: value2
        })
      } : {})
    };
  }
  if (config.isDisabled || config.isReadOnly) return {
    model
  };
  if (message3._tag === "Changed") return {
    model: {
      ...model,
      draft: message3.text,
      error: ""
    }
  };
  if (message3._tag === "Cancelled") return {
    model: {
      ...model,
      draft: null,
      error: ""
    }
  };
  if (model.draft === null) return {
    model
  };
  const text2 = model.draft.trim();
  const value = text2 === "" ? null : (config.codec ?? iso).parse(text2);
  const error = value === void 0 ? `Enter a date as ${(config.codec ?? iso).hint}.` : value === null ? config.required ? "Choose a date." : "" : !isAllowed(value, config) ? "This date is unavailable." : "";
  if (error) return {
    model: {
      ...model,
      error
    }
  };
  return {
    model: {
      ...model,
      draft: null,
      error: "",
      picker: value ? {
        ...model.picker,
        calendar: {
          ...model.picker.calendar,
          viewYear: value.year,
          viewMonth: value.month,
          maybeFocusedDate: Option.some(value)
        }
      } : model.picker
    },
    outMessage: OutMessage10.Changed({
      value: value ?? null
    })
  };
};
var view37 = (config, h) => {
  const {
    model,
    toParentMessage: send
  } = config;
  const codec = config.codec ?? iso;
  if (config.presentation === "value") {
    return h.div(sxAttrs(h, desktopStyles.column), [h.span([h.Id(`${model.id}-label`)], [config.label]), view9({
      id: `${model.id}-input`,
      ariaLabelledBy: `${model.id}-label`,
      ...(config.value ? {
        value: codec.format(config.value)
      } : {}),
      ...(config.name && !config.isDisabled ? {
        name: config.name,
        formValue: config.value ? iso.format(config.value) : ""
      } : {})
    }, h)]);
  }
  return h.div(sxAttrs(h, desktopStyles.column), [h.label([h.For(`${model.id}-input`)], [config.label]), h.div(sxAttrs(h, desktopStyles.row), [h.input([h.OnMount(GuardComposition()), h.Id(`${model.id}-input`), h.Type("text"), h.Value(model.draft ?? (config.value ? codec.format(config.value) : "")), h.Placeholder(codec.hint), h.Disabled(config.isDisabled === true), h.Readonly(config.isReadOnly === true), h.AriaInvalid(Boolean(model.error)), h.AriaDescribedBy(`${model.id}-status`), h.OnInput(text2 => send(Message17.Changed({
    text: text2
  }))), h.OnBlur(send(Message17.Committed())), h.OnKeyDownPreventDefault(key2 => key2 === "Enter" ? Option.some(send(Message17.Committed())) : key2 === "Escape" && model.draft !== null ? Option.some(send(Message17.Cancelled())) : Option.none()), ...sxAttrs(h, desktopStyles.control)]), h.submodel({
    slotId: model.picker.id,
    model: constrained(model.picker, config),
    toParentMessage: message3 => send(Message17.GotPicker({
      message: message3
    })),
    view: date_picker_exports.view,
    viewInputs: styledViewInputs12({
      value: config.value,
      label: `Choose ${config.label}`,
      format: codec.format,
      isDisabled: config.isDisabled === true || config.isReadOnly === true
    }, h)
  })]), ...(config.name && !config.isDisabled ? [h.input([h.Type("hidden"), h.Name(config.name), h.Value(config.value ? iso.format(config.value) : "")])] : []), h.p([h.Id(`${model.id}-status`), h.Role("status"), ...sxAttrs(h, model.error ? desktopStyles.error : desktopStyles.muted)], [model.error || codec.hint])]);
};

// src/citation.ts
var citation_exports = {};
__export(citation_exports, {
  Message: () => tooltip_exports.Message,
  Model: () => tooltip_exports.Model,
  OutMessage: () => tooltip_exports.OutMessage,
  init: () => tooltip_exports.init,
  popoverViewInputs: () => popoverViewInputs,
  styledViewInputs: () => styledViewInputs13,
  update: () => tooltip_exports.update,
  view: () => tooltip_exports.view
});
var citationStyles = {
  marker: {
    kysU6D: "xjyslct",
    kWkggS: "x95chvd",
    kMzoRj: "xc342km",
    kaIpWk: "x5i151u",
    kMwMTN: "xhje13v",
    kkrTdU: "x1ypdohk",
    k1xSpc: "x3nfvp2",
    kMv6JI: "x14t0e4u",
    kGuDYH: "x1j6dyjg",
    k63SB2: "x1s688f",
    kLWn49: "x1evy7pa",
    k8WAf4: "xt970qd",
    kg3NbH: "xfn1xvj",
    kI3sdo: "x1a2a7pz xkrpzxx",
    kInvED: "x1hl8ikr",
    $$css: true
  },
  superscript: {
    kXLuUW: "x1v0h343",
    kGuDYH: "x1k6wstc",
    kUOVxO: "x1dhlr3c",
    $$css: true
  },
  chip: {
    kXLuUW: "x11njtxf",
    k8WAf4: "xsplgde",
    kg3NbH: "x1xijbu4",
    $$css: true
  }
};

// src/citation.ts
var styledViewInputs13 = (config, h) => styledViewInputs6({
  ...config,
  trigger: [String(config.label)],
  label: config.preview,
  ariaLabel: config.ariaLabel ?? `Open citation ${config.label}`,
  renderTrigger: (attributes, children) => h.button([...attributes, h.Type("button"), h.DataAttribute("citation", String(config.label)), h.OnClick(config.onActivate), ...slotAttrs(config.slotProps?.trigger, h, citationStyles.marker, config.variant === "chip" ? citationStyles.chip : citationStyles.superscript)], children)
}, h);
var popoverViewInputs = (config, h) => styledViewInputs5({
  ...config,
  trigger: [String(config.label)],
  ariaLabel: config.ariaLabel ?? `Citation ${config.label}`,
  slotProps: {
    ...config.slotProps,
    trigger: {
      ...config.slotProps?.trigger,
      attributes: [...(config.slotProps?.trigger?.attributes ?? []), h.DataAttribute("citation", String(config.label)), ...slotAttrs(void 0, h, citationStyles.marker, config.variant === "chip" ? citationStyles.chip : citationStyles.superscript)]
    }
  },
  content: [...config.preview, h.button([h.Type("button"), h.OnClick(config.onActivate), ...slotAttrs(void 0, h, citationStyles.marker)], [config.activateLabel ?? "Open source"])]
}, h);
export { Accordion, Alert, AlertDialog, app_header_exports as AppHeader, AspectRatio, Attachment, Avatar, badge_exports as Badge, Breadcrumb, Bubble, button_exports as Button, ButtonGroup, Calendar, Card, Carousel, ChangeSetPreview, Chart, checkbox_exports as Checkbox, citation_exports as Citation, code_block_exports as CodeBlock, Collapsible, Combobox, Command5 as Command, ContextMenu, date_input_exports as DateInput, description_list_exports as DescriptionList, Dialog, Direction, disclosure_exports as Disclosure, Drawer, DropdownMenu, editable_text_exports as EditableText, Empty, ExplanationTree, field_exports as Field, fieldset_exports as Fieldset, Form, Heading, headless_exports as Headless, HoverCard, icon_exports as Icon, Input2 as Input, InputGroup, InputOtp, Item, Kbd, Label, layout_exports as Layout, legend_exports as Legend, Link, Loader, Marker, measurement_exports as Measurement, Menubar, Message5 as Message, MessageScroller, NativeSelect, NavigationMenu, NumberField, overflow_list_exports as OverflowList, Pagination, panel_exports as Panel, panel_stack_exports as PanelStack, Popover, Progress, RadioGroup, read_only_value_exports as ReadOnlyValue, Resizable, ScrollArea, segmented_control_exports as SegmentedControl, select_exports as Select, Separator, Sheet, shortcuts_exports as Shortcuts, Sidebar, Skeleton, Slider, Sonner, Spinner, split_view_exports as SplitView, stat_exports as Stat, stateful_exports as Stateful, StatusMessage, Stepper, switch_exports as Switch, TabBar, Table, Tabs, Tag, Text, Textarea2 as Textarea, Toggle, ToggleGroup, token_field_exports as TokenField, toolbar_exports as Toolbar, Tooltip, TransactionTimeline, tree_exports as Tree, TreeDiff, ValueInspector, value_tree_exports as ValueTree, VisuallyHidden, workspace_exports as Workspace, changedRegion, diffTrees, summarizeDiff, sxAttrs };